import { a as createCommonjsModule, u as unwrapExports } from './_commonjsHelpers-556cd408.js';
import { _ as _taggedTemplateLiteral, a as _inherits, b as _createClass, c as _classCallCheck, d as _callSuper, e as _defineProperty, f as _objectSpread2, g as _extends$f, h as _objectWithoutProperties, i as _toConsumableArray } from './_rollupPluginBabelHelpers-047e4aae.js';
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import './_rollupPluginBabelHelpers-b9ad31fa-7ae21c08.js';
import styled from 'styled-components';
import { T as Tooltip } from './withTooltip-92e0dfed.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import { I as Icon } from './index-28a062d6-3659b895.js';
import './index-155df85b-a520c7f0.js';
import { B as Button$1 } from './button-fb2021fd.js';
import { T as Text } from './text-5e5c8ea1.js';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import { B as Box } from './box-e581bc98.js';
import { T as Text$1 } from './index-5dfda37f-a2c0763c.js';
import { s as styleInject } from './style-inject.es-1f59c1d0.js';
import { D as Drawer, K as KEY_CODES, A as AddIcon, E as EmojiPicker, C as ConfirmationDialog, H as HSLWrapper, R as RichText, a as ACTIONABLE_OPTIONS, b as CONSTRAINTS, c as AddButton, r as renderAdditionalFields, g as getActionableSubtitle, s as sort, t as toggle, d as remove, e as add, f as edit, h as toggleDefault, i as triggerMixPanelEvent, j as isValidURL, k as isVideo, l as KEYS$1, B as BASE, S as Slider, m as CAROUSEL_SIZE_OPTIONS, n as CAROUSEL_RATIO_OPTIONS, F as File, o as getSize, p as getAspectRatio, q as convertFromCarouselItems, u as convertToCarouselItems, v as addLostKeys, w as arrayMove, x as sortableContainer, y as sortableElement, z as sortableHandle } from './_converter-d0e3aa12.js';
import './constants-9315121a.js';
import { c as convertFromHSL$1, a as convertToHSL$1, P as PlaceholderIcon, b as convertFromHSL$2, d as convertToHSL$2, S as SingleProductMessage, W as WhatsAppPLM, L as List, R as ReplyButton, H as HSLForms, s as styles$a, E as ErrorCross, e as HSLDisplay } from './HSL.display-f87e9e5e.js';
export { e as c } from './HSL.display-f87e9e5e.js';
import { T as Textarea, A as AccordionHeader, a as TrashIcon, b as Text$2 } from './index-34abd151.js';
import { A as Accordion } from './index-30009c89.js';
import { D as Dropdown } from './dropdown-75073a0f.js';
import { T as Toggle } from './toggle-6e04c39b.js';
import { T as ToastMessage } from './toastMessage-bc50b53b.js';
import { R as Radio } from './radio-958150e9.js';

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
  defineProperty(
    GeneratorFunctionPrototype,
    "constructor",
    { value: GeneratorFunction, configurable: true }
  );
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", { value: enqueue });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next mehtod, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined$1;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

var _global = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var hasOwnProperty = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var _core = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1 = _core.version;

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function (it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var document$1 = _global.document;
// typeof document.createElement is 'object' in old IE
var is = _isObject(document$1) && _isObject(document$1.createElement);
var _domCreate = function (it) {
  return is ? document$1.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;

var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);
  P = _toPrimitive(P, true);
  _anObject(Attributes);
  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp = {
	f: f
};

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var id = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var _library = false;

var _shared = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = _global[SHARED] || (_global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: _core.version,
  mode:  'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});
});

var _functionToString = _shared('native-function-to-string', Function.toString);

var _redefine = createCommonjsModule(function (module) {
var SRC = _uid('src');

var TO_STRING = 'toString';
var TPL = ('' + _functionToString).split(TO_STRING);

_core.inspectSource = function (it) {
  return _functionToString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) _has(val, 'name') || _hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === _global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    _hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    _hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || _functionToString.call(this);
});
});

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx = function (fn, that, length) {
  _aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
    // extend global
    if (target) _redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) _hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
_global.core = _core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
var _export = $export;

var _meta = createCommonjsModule(function (module) {
var META = _uid('meta');


var setDesc = _objectDp.f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !_fails(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!_isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};
});
var _meta_1 = _meta.KEY;
var _meta_2 = _meta.NEED;
var _meta_3 = _meta.fastKey;
var _meta_4 = _meta.getWeak;
var _meta_5 = _meta.onFreeze;

var _wks = createCommonjsModule(function (module) {
var store = _shared('wks');

var Symbol = _global.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
};

$exports.store = store;
});

var def = _objectDp.f;

var TAG = _wks('toStringTag');

var _setToStringTag = function (it, tag, stat) {
  if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

var f$1 = _wks;

var _wksExt = {
	f: f$1
};

var defineProperty = _objectDp.f;
var _wksDefine = function (name) {
  var $Symbol = _core.Symbol || (_core.Symbol =  _global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: _wksExt.f(name) });
};

var toString = {}.toString;

var _cof = function (it) {
  return toString.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
};

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function (it) {
  return _iobject(_defined(it));
};

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

// 7.1.15 ToLength

var min = Math.min;
var _toLength = function (it) {
  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;
var _toAbsoluteIndex = function (index, length) {
  index = _toInteger(index);
  return index < 0 ? max(index + length, 0) : min$1(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes



var _arrayIncludes = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);
    var length = _toLength(O.length);
    var index = _toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var shared = _shared('keys');

var _sharedKey = function (key) {
  return shared[key] || (shared[key] = _uid(key));
};

var arrayIndexOf = _arrayIncludes(false);
var IE_PROTO = _sharedKey('IE_PROTO');

var _objectKeysInternal = function (object, names) {
  var O = _toIobject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (_has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

// 19.1.2.14 / 15.2.3.14 Object.keys(O)



var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

var f$2 = Object.getOwnPropertySymbols;

var _objectGops = {
	f: f$2
};

var f$3 = {}.propertyIsEnumerable;

var _objectPie = {
	f: f$3
};

// all enumerable object keys, includes symbols



var _enumKeys = function (it) {
  var result = _objectKeys(it);
  var getSymbols = _objectGops.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = _objectPie.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

// 7.2.2 IsArray(argument)

var _isArray = Array.isArray || function isArray(arg) {
  return _cof(arg) == 'Array';
};

// 7.1.13 ToObject(argument)

var _toObject = function (it) {
  return Object(_defined(it));
};

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject(O);
  var keys = _objectKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
  return O;
};

var document$2 = _global.document;
var _html = document$2 && document$2.documentElement;

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



var IE_PROTO$1 = _sharedKey('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE$1 = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');
  var i = _enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _html.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
  return createDict();
};

var _objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE$1] = _anObject(O);
    result = new Empty();
    Empty[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = createDict();
  return Properties === undefined ? result : _objectDps(result, Properties);
};

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

var f$4 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return _objectKeysInternal(O, hiddenKeys);
};

var _objectGopn = {
	f: f$4
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

var gOPN = _objectGopn.f;
var toString$1 = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

var f$5 = function getOwnPropertyNames(it) {
  return windowNames && toString$1.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(_toIobject(it));
};

var _objectGopnExt = {
	f: f$5
};

var gOPD = Object.getOwnPropertyDescriptor;

var f$6 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = _toIobject(O);
  P = _toPrimitive(P, true);
  if (_ie8DomDefine) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
};

var _objectGopd = {
	f: f$6
};

// ECMAScript 6 symbols shim





var META = _meta.KEY;





















var gOPD$1 = _objectGopd.f;
var dP$1 = _objectDp.f;
var gOPN$1 = _objectGopnExt.f;
var $Symbol = _global.Symbol;
var $JSON = _global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE$2 = 'prototype';
var HIDDEN = _wks('_hidden');
var TO_PRIMITIVE = _wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = _shared('symbol-registry');
var AllSymbols = _shared('symbols');
var OPSymbols = _shared('op-symbols');
var ObjectProto = Object[PROTOTYPE$2];
var USE_NATIVE = typeof $Symbol == 'function' && !!_objectGops.f;
var QObject = _global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = _descriptors && _fails(function () {
  return _objectCreate(dP$1({}, 'a', {
    get: function () { return dP$1(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD$1(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP$1(it, key, D);
  if (protoDesc && it !== ObjectProto) dP$1(ObjectProto, key, protoDesc);
} : dP$1;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _objectCreate($Symbol[PROTOTYPE$2]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  _anObject(it);
  key = _toPrimitive(key, true);
  _anObject(D);
  if (_has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!_has(it, HIDDEN)) dP$1(it, HIDDEN, _propertyDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (_has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _objectCreate(D, { enumerable: _propertyDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP$1(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  _anObject(it);
  var keys = _enumKeys(P = _toIobject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _objectCreate(it) : $defineProperties(_objectCreate(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = _toPrimitive(key, true));
  if (this === ObjectProto && _has(AllSymbols, key) && !_has(OPSymbols, key)) return false;
  return E || !_has(this, key) || !_has(AllSymbols, key) || _has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = _toIobject(it);
  key = _toPrimitive(key, true);
  if (it === ObjectProto && _has(AllSymbols, key) && !_has(OPSymbols, key)) return;
  var D = gOPD$1(it, key);
  if (D && _has(AllSymbols, key) && !(_has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN$1(_toIobject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!_has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN$1(IS_OP ? OPSymbols : _toIobject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (_has(AllSymbols, key = names[i++]) && (IS_OP ? _has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = _uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (_has(this, HIDDEN) && _has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, _propertyDesc(1, value));
    };
    if (_descriptors && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  _redefine($Symbol[PROTOTYPE$2], 'toString', function toString() {
    return this._k;
  });

  _objectGopd.f = $getOwnPropertyDescriptor;
  _objectDp.f = $defineProperty;
  _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames;
  _objectPie.f = $propertyIsEnumerable;
  _objectGops.f = $getOwnPropertySymbols;

  if (_descriptors && !_library) {
    _redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  _wksExt.f = function (name) {
    return wrap(_wks(name));
  };
}

_export(_export.G + _export.W + _export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)_wks(es6Symbols[j++]);

for (var wellKnownSymbols = _objectKeys(_wks.store), k = 0; wellKnownSymbols.length > k;) _wksDefine(wellKnownSymbols[k++]);

_export(_export.S + _export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return _has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

_export(_export.S + _export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = _fails(function () { _objectGops.f(1); });

_export(_export.S + _export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return _objectGops.f(_toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!_isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!_isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE$2][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE$2], TO_PRIMITIVE, $Symbol[PROTOTYPE$2].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
_setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
_setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
_setToStringTag(_global.JSON, 'JSON', true);

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
_export(_export.S, 'Object', { create: _objectCreate });

// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
_export(_export.S + _export.F * !_descriptors, 'Object', { defineProperty: _objectDp.f });

// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
_export(_export.S + _export.F * !_descriptors, 'Object', { defineProperties: _objectDps });

// most Object methods by ES6 should accept primitives



var _objectSap = function (KEY, exec) {
  var fn = (_core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  _export(_export.S + _export.F * _fails(function () { fn(1); }), 'Object', exp);
};

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)

var $getOwnPropertyDescriptor$1 = _objectGopd.f;

_objectSap('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor$1(_toIobject(it), key);
  };
});

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO$2 = _sharedKey('IE_PROTO');
var ObjectProto$1 = Object.prototype;

var _objectGpo = Object.getPrototypeOf || function (O) {
  O = _toObject(O);
  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto$1 : null;
};

// 19.1.2.9 Object.getPrototypeOf(O)



_objectSap('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return _objectGpo(_toObject(it));
  };
});

// 19.1.2.14 Object.keys(O)



_objectSap('keys', function () {
  return function keys(it) {
    return _objectKeys(_toObject(it));
  };
});

// 19.1.2.7 Object.getOwnPropertyNames(O)
_objectSap('getOwnPropertyNames', function () {
  return _objectGopnExt.f;
});

// 19.1.2.5 Object.freeze(O)

var meta = _meta.onFreeze;

_objectSap('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && _isObject(it) ? $freeze(meta(it)) : it;
  };
});

// 19.1.2.17 Object.seal(O)

var meta$1 = _meta.onFreeze;

_objectSap('seal', function ($seal) {
  return function seal(it) {
    return $seal && _isObject(it) ? $seal(meta$1(it)) : it;
  };
});

// 19.1.2.15 Object.preventExtensions(O)

var meta$2 = _meta.onFreeze;

_objectSap('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && _isObject(it) ? $preventExtensions(meta$2(it)) : it;
  };
});

// 19.1.2.12 Object.isFrozen(O)


_objectSap('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return _isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});

// 19.1.2.13 Object.isSealed(O)


_objectSap('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return _isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});

// 19.1.2.11 Object.isExtensible(O)


_objectSap('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return _isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

// 19.1.2.1 Object.assign(target, source, ...)






var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
var _objectAssign = !$assign || _fails(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = _toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = _objectGops.f;
  var isEnum = _objectPie.f;
  while (aLen > index) {
    var S = _iobject(arguments[index++]);
    var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!_descriptors || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

// 19.1.3.1 Object.assign(target, source)


_export(_export.S + _export.F, 'Object', { assign: _objectAssign });

// 7.2.9 SameValue(x, y)
var _sameValue = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

// 19.1.3.10 Object.is(value1, value2)

_export(_export.S, 'Object', { is: _sameValue });

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */


var check = function (O, proto) {
  _anObject(O);
  if (!_isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
var _setProto = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = _ctx(Function.call, _objectGopd.f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

// 19.1.3.19 Object.setPrototypeOf(O, proto)

_export(_export.S, 'Object', { setPrototypeOf: _setProto.set });

// getting tag from 19.1.3.6 Object.prototype.toString()

var TAG$1 = _wks('toStringTag');
// ES3 wrong here
var ARG = _cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

var _classof = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG$1)) == 'string' ? T
    // builtinTag case
    : ARG ? _cof(O)
    // ES3 arguments fallback
    : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

// 19.1.3.6 Object.prototype.toString()

var test = {};
test[_wks('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  _redefine(Object.prototype, 'toString', function toString() {
    return '[object ' + _classof(this) + ']';
  }, true);
}

// fast apply, http://jsperf.lnkit.com/fast-apply/5
var _invoke = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

var _bind = Function.bind || function bind(that /* , ...args */) {
  var fn = _aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : _invoke(fn, args, that);
  };
  if (_isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)


_export(_export.P, 'Function', { bind: _bind });

var dP$2 = _objectDp.f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || _descriptors && dP$2(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});

var HAS_INSTANCE = _wks('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) _objectDp.f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !_isObject(O)) return false;
  if (!_isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = _objectGpo(O)) if (this.prototype === O) return true;
  return false;
} });

var _stringWs = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var space = '[' + _stringWs + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = _fails(function () {
    return !!_stringWs[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : _stringWs[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  _export(_export.P + _export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(_defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

var _stringTrim = exporter;

var $parseInt = _global.parseInt;
var $trim = _stringTrim.trim;

var hex = /^[-+]?0[xX]/;

var _parseInt = $parseInt(_stringWs + '08') !== 8 || $parseInt(_stringWs + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;

// 18.2.5 parseInt(string, radix)
_export(_export.G + _export.F * (parseInt != _parseInt), { parseInt: _parseInt });

var $parseFloat = _global.parseFloat;
var $trim$1 = _stringTrim.trim;

var _parseFloat = 1 / $parseFloat(_stringWs + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim$1(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

// 18.2.4 parseFloat(string)
_export(_export.G + _export.F * (parseFloat != _parseFloat), { parseFloat: _parseFloat });

var setPrototypeOf = _setProto.set;
var _inheritIfRequired = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && _isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};

var gOPN$2 = _objectGopn.f;
var gOPD$2 = _objectGopd.f;
var dP$3 = _objectDp.f;
var $trim$2 = _stringTrim.trim;
var NUMBER = 'Number';
var $Number = _global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = _cof(_objectCreate(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = _toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim$2(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? _fails(function () { proto.valueOf.call(that); }) : _cof(that) != NUMBER)
        ? _inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = _descriptors ? gOPN$2(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j$1 = 0, key; keys.length > j$1; j$1++) {
    if (_has(Base, key = keys[j$1]) && !_has($Number, key)) {
      dP$3($Number, key, gOPD$2(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  _redefine(_global, NUMBER, $Number);
}

var _aNumberValue = function (it, msg) {
  if (typeof it != 'number' && _cof(it) != 'Number') throw TypeError(msg);
  return +it;
};

var _stringRepeat = function repeat(count) {
  var str = String(_defined(this));
  var res = '';
  var n = _toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};

var $toFixed = 1.0.toFixed;
var floor$1 = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor$1(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor$1(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + _stringRepeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

_export(_export.P + _export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !_fails(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = _aNumberValue(this, ERROR);
    var f = _toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + _stringRepeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + _stringRepeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});

var $toPrecision = 1.0.toPrecision;

_export(_export.P + _export.F * (_fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !_fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = _aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});

// 20.1.2.1 Number.EPSILON


_export(_export.S, 'Number', { EPSILON: Math.pow(2, -52) });

// 20.1.2.2 Number.isFinite(number)

var _isFinite = _global.isFinite;

_export(_export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});

// 20.1.2.3 Number.isInteger(number)

var floor$2 = Math.floor;
var _isInteger = function isInteger(it) {
  return !_isObject(it) && isFinite(it) && floor$2(it) === it;
};

// 20.1.2.3 Number.isInteger(number)


_export(_export.S, 'Number', { isInteger: _isInteger });

// 20.1.2.4 Number.isNaN(number)


_export(_export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});

// 20.1.2.5 Number.isSafeInteger(number)


var abs = Math.abs;

_export(_export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return _isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

// 20.1.2.6 Number.MAX_SAFE_INTEGER


_export(_export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });

// 20.1.2.10 Number.MIN_SAFE_INTEGER


_export(_export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });

// 20.1.2.12 Number.parseFloat(string)
_export(_export.S + _export.F * (Number.parseFloat != _parseFloat), 'Number', { parseFloat: _parseFloat });

// 20.1.2.13 Number.parseInt(string, radix)
_export(_export.S + _export.F * (Number.parseInt != _parseInt), 'Number', { parseInt: _parseInt });

// 20.2.2.20 Math.log1p(x)
var _mathLog1p = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

// 20.2.2.3 Math.acosh(x)


var sqrt = Math.sqrt;
var $acosh = Math.acosh;

_export(_export.S + _export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : _mathLog1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

// 20.2.2.5 Math.asinh(x)

var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
_export(_export.S + _export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });

// 20.2.2.7 Math.atanh(x)

var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
_export(_export.S + _export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

// 20.2.2.28 Math.sign(x)
var _mathSign = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

// 20.2.2.9 Math.cbrt(x)



_export(_export.S, 'Math', {
  cbrt: function cbrt(x) {
    return _mathSign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

// 20.2.2.11 Math.clz32(x)


_export(_export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

// 20.2.2.12 Math.cosh(x)

var exp = Math.exp;

_export(_export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
var _mathExpm1 = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;

// 20.2.2.14 Math.expm1(x)



_export(_export.S + _export.F * (_mathExpm1 != Math.expm1), 'Math', { expm1: _mathExpm1 });

// 20.2.2.16 Math.fround(x)

var pow$1 = Math.pow;
var EPSILON = pow$1(2, -52);
var EPSILON32 = pow$1(2, -23);
var MAX32 = pow$1(2, 127) * (2 - EPSILON32);
var MIN32 = pow$1(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

var _mathFround = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = _mathSign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};

// 20.2.2.16 Math.fround(x)


_export(_export.S, 'Math', { fround: _mathFround });

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])

var abs$1 = Math.abs;

_export(_export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs$1(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

// 20.2.2.18 Math.imul(x, y)

var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
_export(_export.S + _export.F * _fails(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

// 20.2.2.21 Math.log10(x)


_export(_export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});

// 20.2.2.20 Math.log1p(x)


_export(_export.S, 'Math', { log1p: _mathLog1p });

// 20.2.2.22 Math.log2(x)


_export(_export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});

// 20.2.2.28 Math.sign(x)


_export(_export.S, 'Math', { sign: _mathSign });

// 20.2.2.30 Math.sinh(x)


var exp$1 = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
_export(_export.S + _export.F * _fails(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (_mathExpm1(x) - _mathExpm1(-x)) / 2
      : (exp$1(x - 1) - exp$1(-x - 1)) * (Math.E / 2);
  }
});

// 20.2.2.33 Math.tanh(x)


var exp$2 = Math.exp;

_export(_export.S, 'Math', {
  tanh: function tanh(x) {
    var a = _mathExpm1(x = +x);
    var b = _mathExpm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp$2(x) + exp$2(-x));
  }
});

// 20.2.2.34 Math.trunc(x)


_export(_export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
_export(_export.S + _export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (_toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});

_export(_export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = _toIobject(callSite.raw);
    var len = _toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});

// 21.1.3.25 String.prototype.trim()
_stringTrim('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});

// true  -> String#at
// false -> String#codePointAt
var _stringAt = function (TO_STRING) {
  return function (that, pos) {
    var s = String(_defined(that));
    var i = _toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _iterators = {};

var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide(IteratorPrototype, _wks('iterator'), function () { return this; });

var _iterCreate = function (Constructor, NAME, next) {
  Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
  _setToStringTag(Constructor, NAME + ' Iterator');
};

var ITERATOR = _wks('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = _objectGpo($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if ( typeof IteratorPrototype[ITERATOR] != 'function') _hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ( (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    _hide(proto, ITERATOR, $default);
  }
  // Plug for library
  _iterators[NAME] = $default;
  _iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine(proto, key, methods[key]);
    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

var $at = _stringAt(true);

// 21.1.3.27 String.prototype[@@iterator]()
_iterDefine(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

var $at$1 = _stringAt(false);
_export(_export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at$1(this, pos);
  }
});

// 7.2.8 IsRegExp(argument)


var MATCH = _wks('match');
var _isRegexp = function (it) {
  var isRegExp;
  return _isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : _cof(it) == 'RegExp');
};

// helper for String#{startsWith, endsWith, includes}



var _stringContext = function (that, searchString, NAME) {
  if (_isRegexp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(_defined(that));
};

var MATCH$1 = _wks('match');
var _failsIsRegexp = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH$1] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};

var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

_export(_export.P + _export.F * _failsIsRegexp(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = _stringContext(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = _toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(_toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});

var INCLUDES = 'includes';

_export(_export.P + _export.F * _failsIsRegexp(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~_stringContext(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

_export(_export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: _stringRepeat
});

var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

_export(_export.P + _export.F * _failsIsRegexp(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = _stringContext(this, searchString, STARTS_WITH);
    var index = _toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(_defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
var _stringHtml = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  _export(_export.P + _export.F * _fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};

// B.2.3.2 String.prototype.anchor(name)
_stringHtml('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});

// B.2.3.3 String.prototype.big()
_stringHtml('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});

// B.2.3.4 String.prototype.blink()
_stringHtml('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});

// B.2.3.5 String.prototype.bold()
_stringHtml('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});

// B.2.3.6 String.prototype.fixed()
_stringHtml('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});

// B.2.3.7 String.prototype.fontcolor(color)
_stringHtml('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});

// B.2.3.8 String.prototype.fontsize(size)
_stringHtml('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});

// B.2.3.9 String.prototype.italics()
_stringHtml('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});

// B.2.3.10 String.prototype.link(url)
_stringHtml('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});

// B.2.3.11 String.prototype.small()
_stringHtml('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});

// B.2.3.12 String.prototype.strike()
_stringHtml('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});

// B.2.3.13 String.prototype.sub()
_stringHtml('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});

// B.2.3.14 String.prototype.sup()
_stringHtml('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});

// 20.3.3.1 / 15.9.4.4 Date.now()


_export(_export.S, 'Date', { now: function () { return new Date().getTime(); } });

_export(_export.P + _export.F * _fails(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = _toObject(this);
    var pv = _toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()

var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
var _dateToIsoString = (_fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !_fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()



// PhantomJS / old WebKit has a broken implementations
_export(_export.P + _export.F * (Date.prototype.toISOString !== _dateToIsoString), 'Date', {
  toISOString: _dateToIsoString
});

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime$1 = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  _redefine(DateProto, TO_STRING, function toString() {
    var value = getTime$1.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}

var NUMBER$1 = 'number';

var _dateToPrimitive = function (hint) {
  if (hint !== 'string' && hint !== NUMBER$1 && hint !== 'default') throw TypeError('Incorrect hint');
  return _toPrimitive(_anObject(this), hint != NUMBER$1);
};

var TO_PRIMITIVE$1 = _wks('toPrimitive');
var proto$1 = Date.prototype;

if (!(TO_PRIMITIVE$1 in proto$1)) _hide(proto$1, TO_PRIMITIVE$1, _dateToPrimitive);

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)


_export(_export.S, 'Array', { isArray: _isArray });

// call something on iterator step with safe closing on error

var _iterCall = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(_anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) _anObject(ret.call(iterator));
    throw e;
  }
};

// check on default Array iterator

var ITERATOR$1 = _wks('iterator');
var ArrayProto = Array.prototype;

var _isArrayIter = function (it) {
  return it !== undefined && (_iterators.Array === it || ArrayProto[ITERATOR$1] === it);
};

var _createProperty = function (object, index, value) {
  if (index in object) _objectDp.f(object, index, _propertyDesc(0, value));
  else object[index] = value;
};

var ITERATOR$2 = _wks('iterator');

var core_getIteratorMethod = _core.getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$2]
    || it['@@iterator']
    || _iterators[_classof(it)];
};

var ITERATOR$3 = _wks('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR$3]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

var _iterDetect = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR$3]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR$3] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

_export(_export.S + _export.F * !_iterDetect(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = _toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = core_getIteratorMethod(O);
    var length, result, step, iterator;
    if (mapping) mapfn = _ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && _isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        _createProperty(result, index, mapping ? _iterCall(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = _toLength(O.length);
      for (result = new C(length); length > index; index++) {
        _createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

// WebKit Array.of isn't generic
_export(_export.S + _export.F * _fails(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) _createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});

var _strictMethod = function (method, arg) {
  return !!method && _fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};

// 22.1.3.13 Array.prototype.join(separator)


var arrayJoin = [].join;

// fallback for not array-like strings
_export(_export.P + _export.F * (_iobject != Object || !_strictMethod(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(_toIobject(this), separator === undefined ? ',' : separator);
  }
});

var arraySlice$1 = [].slice;

// fallback for not array-like ES3 strings and DOM objects
_export(_export.P + _export.F * _fails(function () {
  if (_html) arraySlice$1.call(_html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = _toLength(this.length);
    var klass = _cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice$1.call(this, begin, end);
    var start = _toAbsoluteIndex(begin, len);
    var upTo = _toAbsoluteIndex(end, len);
    var size = _toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});

var $sort = [].sort;
var test$1 = [1, 2, 3];

_export(_export.P + _export.F * (_fails(function () {
  // IE8-
  test$1.sort(undefined);
}) || !_fails(function () {
  // V8 bug
  test$1.sort(null);
  // Old WebKit
}) || !_strictMethod($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(_toObject(this))
      : $sort.call(_toObject(this), _aFunction(comparefn));
  }
});

var SPECIES = _wks('species');

var _arraySpeciesConstructor = function (original) {
  var C;
  if (_isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || _isArray(C.prototype))) C = undefined;
    if (_isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)


var _arraySpeciesCreate = function (original, length) {
  return new (_arraySpeciesConstructor(original))(length);
};

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex





var _arrayMethods = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || _arraySpeciesCreate;
  return function ($this, callbackfn, that) {
    var O = _toObject($this);
    var self = _iobject(O);
    var f = _ctx(callbackfn, that, 3);
    var length = _toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

var $forEach = _arrayMethods(0);
var STRICT = _strictMethod([].forEach, true);

_export(_export.P + _export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});

var $map = _arrayMethods(1);

_export(_export.P + _export.F * !_strictMethod([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});

var $filter = _arrayMethods(2);

_export(_export.P + _export.F * !_strictMethod([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});

var $some = _arrayMethods(3);

_export(_export.P + _export.F * !_strictMethod([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});

var $every = _arrayMethods(4);

_export(_export.P + _export.F * !_strictMethod([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});

var _arrayReduce = function (that, callbackfn, aLen, memo, isRight) {
  _aFunction(callbackfn);
  var O = _toObject(that);
  var self = _iobject(O);
  var length = _toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};

_export(_export.P + _export.F * !_strictMethod([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return _arrayReduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});

_export(_export.P + _export.F * !_strictMethod([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return _arrayReduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});

var $indexOf = _arrayIncludes(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

_export(_export.P + _export.F * (NEGATIVE_ZERO || !_strictMethod($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});

var $native$1 = [].lastIndexOf;
var NEGATIVE_ZERO$1 = !!$native$1 && 1 / [1].lastIndexOf(1, -0) < 0;

_export(_export.P + _export.F * (NEGATIVE_ZERO$1 || !_strictMethod($native$1)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO$1) return $native$1.apply(this, arguments) || 0;
    var O = _toIobject(this);
    var length = _toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, _toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});

var _arrayCopyWithin = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = _toObject(this);
  var len = _toLength(O.length);
  var to = _toAbsoluteIndex(target, len);
  var from = _toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : _toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = _wks('unscopables');
var ArrayProto$1 = Array.prototype;
if (ArrayProto$1[UNSCOPABLES] == undefined) _hide(ArrayProto$1, UNSCOPABLES, {});
var _addToUnscopables = function (key) {
  ArrayProto$1[UNSCOPABLES][key] = true;
};

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)


_export(_export.P, 'Array', { copyWithin: _arrayCopyWithin });

_addToUnscopables('copyWithin');

var _arrayFill = function fill(value /* , start = 0, end = @length */) {
  var O = _toObject(this);
  var length = _toLength(O.length);
  var aLen = arguments.length;
  var index = _toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : _toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)


_export(_export.P, 'Array', { fill: _arrayFill });

_addToUnscopables('fill');

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

var $find = _arrayMethods(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
_export(_export.P + _export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
_addToUnscopables(KEY);

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)

var $find$1 = _arrayMethods(6);
var KEY$1 = 'findIndex';
var forced$1 = true;
// Shouldn't skip holes
if (KEY$1 in []) Array(1)[KEY$1](function () { forced$1 = false; });
_export(_export.P + _export.F * forced$1, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
_addToUnscopables(KEY$1);

var SPECIES$1 = _wks('species');

var _setSpecies = function (KEY) {
  var C = _global[KEY];
  if (_descriptors && C && !C[SPECIES$1]) _objectDp.f(C, SPECIES$1, {
    configurable: true,
    get: function () { return this; }
  });
};

_setSpecies('Array');

var _iterStep = function (done, value) {
  return { value: value, done: !!done };
};

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
  this._t = _toIobject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return _iterStep(1);
  }
  if (kind == 'keys') return _iterStep(0, index);
  if (kind == 'values') return _iterStep(0, O[index]);
  return _iterStep(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
_iterators.Arguments = _iterators.Array;

_addToUnscopables('keys');
_addToUnscopables('values');
_addToUnscopables('entries');

// 21.2.5.3 get RegExp.prototype.flags

var _flags = function () {
  var that = _anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var dP$4 = _objectDp.f;
var gOPN$3 = _objectGopn.f;


var $RegExp = _global.RegExp;
var Base$1 = $RegExp;
var proto$2 = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (_descriptors && (!CORRECT_NEW || _fails(function () {
  re2[_wks('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = _isRegexp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : _inheritIfRequired(CORRECT_NEW
        ? new Base$1(piRE && !fiU ? p.source : p, f)
        : Base$1((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? _flags.call(p) : f)
      , tiRE ? this : proto$2, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP$4($RegExp, key, {
      configurable: true,
      get: function () { return Base$1[key]; },
      set: function (it) { Base$1[key] = it; }
    });
  };
  for (var keys$1 = gOPN$3(Base$1), i = 0; keys$1.length > i;) proxy(keys$1[i++]);
  proto$2.constructor = $RegExp;
  $RegExp.prototype = proto$2;
  _redefine(_global, 'RegExp', $RegExp);
}

_setSpecies('RegExp');

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', _flags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var _regexpExec = patchedExec;

_export({
  target: 'RegExp',
  proto: true,
  forced: _regexpExec !== /./.exec
}, {
  exec: _regexpExec
});

// 21.2.5.3 get RegExp.prototype.flags()
if (_descriptors && /./g.flags != 'g') _objectDp.f(RegExp.prototype, 'flags', {
  configurable: true,
  get: _flags
});

var TO_STRING$1 = 'toString';
var $toString$1 = /./[TO_STRING$1];

var define = function (fn) {
  _redefine(RegExp.prototype, TO_STRING$1, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (_fails(function () { return $toString$1.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = _anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !_descriptors && R instanceof RegExp ? _flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString$1.name != TO_STRING$1) {
  define(function toString() {
    return $toString$1.call(this);
  });
}

var at = _stringAt(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
var _advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};

var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
var _regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (_classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};

var SPECIES$2 = _wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !_fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

var _fixReWks = function (KEY, length, exec) {
  var SYMBOL = _wks(KEY);

  var DELEGATES_TO_SYMBOL = !_fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !_fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$2] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      _defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === _regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    _redefine(String.prototype, KEY, strfn);
    _hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};

// @@match logic
_fixReWks('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = _anObject(regexp);
      var S = String(this);
      if (!rx.global) return _regexpExecAbstract(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = _regexpExecAbstract(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = _advanceStringIndex(S, _toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

var max$1 = Math.max;
var min$2 = Math.min;
var floor$3 = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
_fixReWks('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = _anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = _regexpExecAbstract(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = _advanceStringIndex(S, _toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max$1(min$2(_toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = _toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor$3(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

// @@search logic
_fixReWks('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = _anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!_sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = _regexpExecAbstract(rx, S);
      if (!_sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

// 7.3.20 SpeciesConstructor(O, defaultConstructor)


var SPECIES$3 = _wks('species');
var _speciesConstructor = function (O, D) {
  var C = _anObject(O).constructor;
  var S;
  return C === undefined || (S = _anObject(C)[SPECIES$3]) == undefined ? D : _aFunction(S);
};

var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX$1 = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !_fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
_fixReWks('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!_isRegexp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = _regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX$1];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX$1] === match.index) separatorCopy[LAST_INDEX$1]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = _anObject(regexp);
      var S = String(this);
      var C = _speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return _regexpExecAbstract(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = _regexpExecAbstract(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(_toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = _advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});

var _anInstance = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

var _forOf = createCommonjsModule(function (module) {
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : core_getIteratorMethod(iterable);
  var f = _ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (_isArrayIter(iterFn)) for (length = _toLength(iterable.length); length > index; index++) {
    result = entries ? f(_anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = _iterCall(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;
});

var process = _global.process;
var setTask = _global.setImmediate;
var clearTask = _global.clearImmediate;
var MessageChannel = _global.MessageChannel;
var Dispatch = _global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      _invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (_cof(process) == 'process') {
    defer = function (id) {
      process.nextTick(_ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(_ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = _ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (_global.addEventListener && typeof postMessage == 'function' && !_global.importScripts) {
    defer = function (id) {
      _global.postMessage(id + '', '*');
    };
    _global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in _domCreate('script')) {
    defer = function (id) {
      _html.appendChild(_domCreate('script'))[ONREADYSTATECHANGE] = function () {
        _html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(_ctx(run, id, 1), 0);
    };
  }
}
var _task = {
  set: setTask,
  clear: clearTask
};

var macrotask = _task.set;
var Observer = _global.MutationObserver || _global.WebKitMutationObserver;
var process$1 = _global.process;
var Promise$1 = _global.Promise;
var isNode = _cof(process$1) == 'process';

var _microtask = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process$1.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process$1.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(_global.navigator && _global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise$1.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(_global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

// 25.4.1.5 NewPromiseCapability(C)


function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = _aFunction(resolve);
  this.reject = _aFunction(reject);
}

var f$7 = function (C) {
  return new PromiseCapability(C);
};

var _newPromiseCapability = {
	f: f$7
};

var _perform = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

var navigator = _global.navigator;

var _userAgent = navigator && navigator.userAgent || '';

var _promiseResolve = function (C, x) {
  _anObject(C);
  if (_isObject(x) && x.constructor === C) return x;
  var promiseCapability = _newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var _redefineAll = function (target, src, safe) {
  for (var key in src) _redefine(target, key, src[key], safe);
  return target;
};

var task = _task.set;
var microtask = _microtask();




var PROMISE = 'Promise';
var TypeError$1 = _global.TypeError;
var process$2 = _global.process;
var versions = process$2 && process$2.versions;
var v8 = versions && versions.v8 || '';
var $Promise = _global[PROMISE];
var isNode$1 = _classof(process$2) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = _newPromiseCapability.f;

var USE_NATIVE$1 = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[_wks('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode$1 || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && _userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return _isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(_global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = _perform(function () {
        if (isNode$1) {
          process$2.emit('unhandledRejection', value, promise);
        } else if (handler = _global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = _global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode$1 || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(_global, function () {
    var handler;
    if (isNode$1) {
      process$2.emit('rejectionHandled', promise);
    } else if (handler = _global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError$1("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, _ctx($resolve, wrapper, 1), _ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE$1) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    _anInstance(this, $Promise, PROMISE, '_h');
    _aFunction(executor);
    Internal.call(this);
    try {
      executor(_ctx($resolve, this, 1), _ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = _redefineAll($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(_speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode$1 ? process$2.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = _ctx($resolve, promise, 1);
    this.reject = _ctx($reject, promise, 1);
  };
  _newPromiseCapability.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

_export(_export.G + _export.W + _export.F * !USE_NATIVE$1, { Promise: $Promise });
_setToStringTag($Promise, PROMISE);
_setSpecies(PROMISE);
Wrapper = _core[PROMISE];

// statics
_export(_export.S + _export.F * !USE_NATIVE$1, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
_export(_export.S + _export.F * ( !USE_NATIVE$1), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return _promiseResolve( this, x);
  }
});
_export(_export.S + _export.F * !(USE_NATIVE$1 && _iterDetect(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = _perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      _forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = _perform(function () {
      _forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

var _validateCollection = function (it, TYPE) {
  if (!_isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

var dP$5 = _objectDp.f;









var fastKey = _meta.fastKey;

var SIZE = _descriptors ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

var _collectionStrong = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      _anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = _objectCreate(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
    });
    _redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = _validateCollection(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = _validateCollection(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        _validateCollection(this, NAME);
        var f = _ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(_validateCollection(this, NAME), key);
      }
    });
    if (_descriptors) dP$5(C.prototype, 'size', {
      get: function () {
        return _validateCollection(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    _iterDefine(C, NAME, function (iterated, kind) {
      this._t = _validateCollection(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return _iterStep(1);
      }
      // return step by kind
      if (kind == 'keys') return _iterStep(0, entry.k);
      if (kind == 'values') return _iterStep(0, entry.v);
      return _iterStep(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    _setSpecies(NAME);
  }
};

var _collection = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = _global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    _redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !_isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !_isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !_isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !_fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    _redefineAll(C.prototype, methods);
    _meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = _fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = _iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && _fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        _anInstance(target, C, NAME);
        var that = _inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  _setToStringTag(C, NAME);

  O[NAME] = C;
  _export(_export.G + _export.W + _export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

var MAP = 'Map';

// 23.1 Map Objects
var es6_map = _collection(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = _collectionStrong.getEntry(_validateCollection(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return _collectionStrong.def(_validateCollection(this, MAP), key === 0 ? 0 : key, value);
  }
}, _collectionStrong, true);

var SET = 'Set';

// 23.2 Set Objects
var es6_set = _collection(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return _collectionStrong.def(_validateCollection(this, SET), value = value === 0 ? 0 : value, value);
  }
}, _collectionStrong);

var getWeak = _meta.getWeak;







var arrayFind = _arrayMethods(5);
var arrayFindIndex = _arrayMethods(6);
var id$1 = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

var _collectionWeak = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      _anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id$1++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
    });
    _redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!_isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(_validateCollection(this, NAME))['delete'](key);
        return data && _has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!_isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(_validateCollection(this, NAME)).has(key);
        return data && _has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(_anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

var es6_weakMap = createCommonjsModule(function (module) {

var each = _arrayMethods(0);






var NATIVE_WEAK_MAP = _validateCollection;
var IS_IE11 = !_global.ActiveXObject && 'ActiveXObject' in _global;
var WEAK_MAP = 'WeakMap';
var getWeak = _meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = _collectionWeak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (_isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(_validateCollection(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return _collectionWeak.def(_validateCollection(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = _collection(WEAK_MAP, wrapper, methods, _collectionWeak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = _collectionWeak.getConstructor(wrapper, WEAK_MAP);
  _objectAssign(InternalMap.prototype, methods);
  _meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    _redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (_isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}
});

var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
_collection(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return _collectionWeak.def(_validateCollection(this, WEAK_SET), value, true);
  }
}, _collectionWeak, false, true);

var TYPED = _uid('typed_array');
var VIEW = _uid('view');
var ABV = !!(_global.ArrayBuffer && _global.DataView);
var CONSTR = ABV;
var i$1 = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i$1 < l) {
  if (Typed = _global[TypedArrayConstructors[i$1++]]) {
    _hide(Typed.prototype, TYPED, true);
    _hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

var _typed = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};

// https://tc39.github.io/ecma262/#sec-toindex


var _toIndex = function (it) {
  if (it === undefined) return 0;
  var number = _toInteger(it);
  var length = _toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};

var _typedBuffer = createCommonjsModule(function (module, exports) {











var gOPN = _objectGopn.f;
var dP = _objectDp.f;


var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = _global[ARRAY_BUFFER];
var $DataView = _global[DATA_VIEW];
var Math = _global.Math;
var RangeError = _global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = _global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = _descriptors ? '_b' : BUFFER;
var $LENGTH = _descriptors ? '_l' : BYTE_LENGTH;
var $OFFSET = _descriptors ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = _toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = _toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!_typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    _anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = _toIndex(length);
    this._b = _arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    _anInstance(this, $DataView, DATA_VIEW);
    _anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = _toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : _toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (_descriptors) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  _redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!_fails(function () {
    $ArrayBuffer(1);
  }) || !_fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || _fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      _anInstance(this, $ArrayBuffer);
      return new BaseBuffer(_toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) _hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) _redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
_setToStringTag($ArrayBuffer, ARRAY_BUFFER);
_setToStringTag($DataView, DATA_VIEW);
_hide($DataView[PROTOTYPE], _typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;
});

var ArrayBuffer = _global.ArrayBuffer;

var $ArrayBuffer = _typedBuffer.ArrayBuffer;
var $DataView = _typedBuffer.DataView;
var $isView = _typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW$1 = _typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

_export(_export.G + _export.W + _export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

_export(_export.S + _export.F * !_typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || _isObject(it) && VIEW$1 in it;
  }
});

_export(_export.P + _export.U + _export.F * _fails(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(_anObject(this), start); // FF fix
    var len = _anObject(this).byteLength;
    var first = _toAbsoluteIndex(start, len);
    var fin = _toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (_speciesConstructor(this, $ArrayBuffer))(_toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

_setSpecies(ARRAY_BUFFER);

_export(_export.G + _export.W + _export.F * !_typed.ABV, {
  DataView: _typedBuffer.DataView
});

var _typedArray = createCommonjsModule(function (module) {
if (_descriptors) {
  var LIBRARY = _library;
  var global = _global;
  var fails = _fails;
  var $export = _export;
  var $typed = _typed;
  var $buffer = _typedBuffer;
  var ctx = _ctx;
  var anInstance = _anInstance;
  var propertyDesc = _propertyDesc;
  var hide = _hide;
  var redefineAll = _redefineAll;
  var toInteger = _toInteger;
  var toLength = _toLength;
  var toIndex = _toIndex;
  var toAbsoluteIndex = _toAbsoluteIndex;
  var toPrimitive = _toPrimitive;
  var has = _has;
  var classof = _classof;
  var isObject = _isObject;
  var toObject = _toObject;
  var isArrayIter = _isArrayIter;
  var create = _objectCreate;
  var getPrototypeOf = _objectGpo;
  var gOPN = _objectGopn.f;
  var getIterFn = core_getIteratorMethod;
  var uid = _uid;
  var wks = _wks;
  var createArrayMethod = _arrayMethods;
  var createArrayIncludes = _arrayIncludes;
  var speciesConstructor = _speciesConstructor;
  var ArrayIterators = es6_array_iterator;
  var Iterators = _iterators;
  var $iterDetect = _iterDetect;
  var setSpecies = _setSpecies;
  var arrayFill = _arrayFill;
  var arrayCopyWithin = _arrayCopyWithin;
  var $DP = _objectDp;
  var $GOPD = _objectGopd;
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };
});

_typedArray('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

_typedArray('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

_typedArray('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);

_typedArray('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

_typedArray('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

_typedArray('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

_typedArray('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

_typedArray('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

_typedArray('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)



var rApply = (_global.Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
_export(_export.S + _export.F * !_fails(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = _aFunction(target);
    var L = _anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])







var rConstruct = (_global.Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = _fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !_fails(function () {
  rConstruct(function () { /* empty */ });
});

_export(_export.S + _export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    _aFunction(Target);
    _anObject(args);
    var newTarget = arguments.length < 3 ? Target : _aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (_bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = _objectCreate(_isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return _isObject(result) ? result : instance;
  }
});

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)





// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
_export(_export.S + _export.F * _fails(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(_objectDp.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    _anObject(target);
    propertyKey = _toPrimitive(propertyKey, true);
    _anObject(attributes);
    try {
      _objectDp.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});

// 26.1.4 Reflect.deleteProperty(target, propertyKey)

var gOPD$3 = _objectGopd.f;


_export(_export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD$3(_anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});

// 26.1.5 Reflect.enumerate(target)


var Enumerate = function (iterated) {
  this._t = _anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
_iterCreate(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

_export(_export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});

// 26.1.6 Reflect.get(target, propertyKey [, receiver])







function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (_anObject(target) === receiver) return target[propertyKey];
  if (desc = _objectGopd.f(target, propertyKey)) return _has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (_isObject(proto = _objectGpo(target))) return get(proto, propertyKey, receiver);
}

_export(_export.S, 'Reflect', { get: get });

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)




_export(_export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return _objectGopd.f(_anObject(target), propertyKey);
  }
});

// 26.1.8 Reflect.getPrototypeOf(target)




_export(_export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return _objectGpo(_anObject(target));
  }
});

// 26.1.9 Reflect.has(target, propertyKey)


_export(_export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});

// 26.1.10 Reflect.isExtensible(target)


var $isExtensible = Object.isExtensible;

_export(_export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    _anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});

// all object keys, includes non-enumerable and symbols



var Reflect$1 = _global.Reflect;
var _ownKeys = Reflect$1 && Reflect$1.ownKeys || function ownKeys(it) {
  var keys = _objectGopn.f(_anObject(it));
  var getSymbols = _objectGops.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

// 26.1.11 Reflect.ownKeys(target)


_export(_export.S, 'Reflect', { ownKeys: _ownKeys });

// 26.1.12 Reflect.preventExtensions(target)


var $preventExtensions = Object.preventExtensions;

_export(_export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    _anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])









function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = _objectGopd.f(_anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (_isObject(proto = _objectGpo(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = _propertyDesc(0);
  }
  if (_has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !_isObject(receiver)) return false;
    if (existingDescriptor = _objectGopd.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      _objectDp.f(receiver, propertyKey, existingDescriptor);
    } else _objectDp.f(receiver, propertyKey, _propertyDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

_export(_export.S, 'Reflect', { set: set });

// 26.1.14 Reflect.setPrototypeOf(target, proto)



if (_setProto) _export(_export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    _setProto.check(target, proto);
    try {
      _setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});

// https://github.com/tc39/Array.prototype.includes

var $includes = _arrayIncludes(true);

_export(_export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

_addToUnscopables('includes');

var includes = _core.Array.includes;

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray




var IS_CONCAT_SPREADABLE = _wks('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? _ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (_isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : _isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, _toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

var _flattenIntoArray = flattenIntoArray;

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap







_export(_export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = _toObject(this);
    var sourceLen, A;
    _aFunction(callbackfn);
    sourceLen = _toLength(O.length);
    A = _arraySpeciesCreate(O, 0);
    _flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

_addToUnscopables('flatMap');

var flatMap = _core.Array.flatMap;

// https://github.com/tc39/proposal-string-pad-start-end




var _stringPad = function (that, maxLength, fillString, left) {
  var S = String(_defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = _toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = _stringRepeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};

// https://github.com/tc39/proposal-string-pad-start-end




// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(_userAgent);

_export(_export.P + _export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return _stringPad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

var padStart = _core.String.padStart;

// https://github.com/tc39/proposal-string-pad-start-end




// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG$1 = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(_userAgent);

_export(_export.P + _export.F * WEBKIT_BUG$1, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return _stringPad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

var padEnd = _core.String.padEnd;

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
_stringTrim('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');

var trimStart = _core.String.trimLeft;

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
_stringTrim('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');

var trimEnd = _core.String.trimRight;

_wksDefine('asyncIterator');

var asyncIterator = _wksExt.f('asyncIterator');

// https://github.com/tc39/proposal-object-getownpropertydescriptors






_export(_export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = _toIobject(object);
    var getDesc = _objectGopd.f;
    var keys = _ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) _createProperty(result, key, desc);
    }
    return result;
  }
});

var getOwnPropertyDescriptors = _core.Object.getOwnPropertyDescriptors;

var isEnum$1 = _objectPie.f;
var _objectToArray = function (isEntries) {
  return function (it) {
    var O = _toIobject(it);
    var keys = _objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!_descriptors || isEnum$1.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

// https://github.com/tc39/proposal-object-values-entries

var $values = _objectToArray(false);

_export(_export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

var values = _core.Object.values;

// https://github.com/tc39/proposal-object-values-entries

var $entries = _objectToArray(true);

_export(_export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

var entries = _core.Object.entries;

_export(_export.P + _export.R, 'Promise', { 'finally': function (onFinally) {
  var C = _speciesConstructor(this, _core.Promise || _global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return _promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return _promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

var _finally = _core.Promise['finally'];

// ie9- setTimeout & setInterval additional parameters fix



var slice = [].slice;
var MSIE = /MSIE .\./.test(_userAgent); // <- dirty ie9- check
var wrap$1 = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
_export(_export.G + _export.B + _export.F * MSIE, {
  setTimeout: wrap$1(_global.setTimeout),
  setInterval: wrap$1(_global.setInterval)
});

_export(_export.G + _export.B, {
  setImmediate: _task.set,
  clearImmediate: _task.clear
});

var ITERATOR$4 = _wks('iterator');
var TO_STRING_TAG = _wks('toStringTag');
var ArrayValues = _iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = _objectKeys(DOMIterables), i$2 = 0; i$2 < collections.length; i$2++) {
  var NAME$1 = collections[i$2];
  var explicit = DOMIterables[NAME$1];
  var Collection = _global[NAME$1];
  var proto$3 = Collection && Collection.prototype;
  var key$1;
  if (proto$3) {
    if (!proto$3[ITERATOR$4]) _hide(proto$3, ITERATOR$4, ArrayValues);
    if (!proto$3[TO_STRING_TAG]) _hide(proto$3, TO_STRING_TAG, NAME$1);
    _iterators[NAME$1] = ArrayValues;
    if (explicit) for (key$1 in es6_array_iterator) if (!proto$3[key$1]) _redefine(proto$3, key$1, es6_array_iterator[key$1], true);
  }
}

var _global$1 = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core$1 = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1$1 = _core$1.version;

var _aFunction$1 = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx$1 = function (fn, that, length) {
  _aFunction$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var _isObject$1 = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject$1 = function (it) {
  if (!_isObject$1(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails$1 = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors$1 = !_fails$1(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var document$3 = _global$1.document;
// typeof document.createElement is 'object' in old IE
var is$1 = _isObject$1(document$3) && _isObject$1(document$3.createElement);
var _domCreate$1 = function (it) {
  return is$1 ? document$3.createElement(it) : {};
};

var _ie8DomDefine$1 = !_descriptors$1 && !_fails$1(function () {
  return Object.defineProperty(_domCreate$1('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive$1 = function (it, S) {
  if (!_isObject$1(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject$1(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject$1(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject$1(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP$6 = Object.defineProperty;

var f$8 = _descriptors$1 ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject$1(O);
  P = _toPrimitive$1(P, true);
  _anObject$1(Attributes);
  if (_ie8DomDefine$1) try {
    return dP$6(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp$1 = {
	f: f$8
};

var _propertyDesc$1 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide$1 = _descriptors$1 ? function (object, key, value) {
  return _objectDp$1.f(object, key, _propertyDesc$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty$1 = {}.hasOwnProperty;
var _has$1 = function (it, key) {
  return hasOwnProperty$1.call(it, key);
};

var PROTOTYPE$3 = 'prototype';

var $export$1 = function (type, name, source) {
  var IS_FORCED = type & $export$1.F;
  var IS_GLOBAL = type & $export$1.G;
  var IS_STATIC = type & $export$1.S;
  var IS_PROTO = type & $export$1.P;
  var IS_BIND = type & $export$1.B;
  var IS_WRAP = type & $export$1.W;
  var exports = IS_GLOBAL ? _core$1 : _core$1[name] || (_core$1[name] = {});
  var expProto = exports[PROTOTYPE$3];
  var target = IS_GLOBAL ? _global$1 : IS_STATIC ? _global$1[name] : (_global$1[name] || {})[PROTOTYPE$3];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && _has$1(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? _ctx$1(out, _global$1)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE$3] = C[PROTOTYPE$3];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? _ctx$1(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export$1.R && expProto && !expProto[key]) _hide$1(expProto, key, out);
    }
  }
};
// type bitmap
$export$1.F = 1;   // forced
$export$1.G = 2;   // global
$export$1.S = 4;   // static
$export$1.P = 8;   // proto
$export$1.B = 16;  // bind
$export$1.W = 32;  // wrap
$export$1.U = 64;  // safe
$export$1.R = 128; // real proto method for `library`
var _export$1 = $export$1;

// https://github.com/tc39/proposal-global


_export$1(_export$1.G, { global: _global$1 });

var global = _core$1.global;

var lib = createCommonjsModule(function (module) {



var _global = _interopRequireDefault(global);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

if (_global["default"]._babelPolyfill && typeof console !== "undefined" && console.warn) {
  console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended " + "and may have consequences if different versions of the polyfills are applied sequentially. " + "If you do need to load the polyfill more than once, use @babel/polyfill/noConflict " + "instead to bypass the warning.");
}

_global["default"]._babelPolyfill = true;
});

unwrapExports(lib);

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ReplaceIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 10c0 .477.054.95.162 1.415.034.147.168.25.327.25h.003a.331.331 0 00.327-.254c.6-2.637 3.028-4.576 5.844-4.723v.906c0 .128.08.246.209.294a.35.35 0 00.367-.067l2.776-2.64a.31.31 0 000-.452l-2.776-2.637a.35.35 0 00-.367-.067.316.316 0 00-.209.295v1.04C5.958 3.526 3 6.44 3 10zM10.337 17.68v-1.04C14.039 16.475 17 13.56 17 10c0-.477-.054-.954-.162-1.414a.333.333 0 00-.33-.25.331.331 0 00-.327.253c-.6 2.637-3.028 4.576-5.844 4.723v-.905a.316.316 0 00-.209-.295.351.351 0 00-.367.067l-2.776 2.64a.312.312 0 00-.1.228.31.31 0 00.1.224l2.776 2.637a.349.349 0 00.367.067.316.316 0 00.21-.294h-.001z",
  fill: "#464646"
})));

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var HSLTextQuickReplies = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1({
  width: "92",
  height: "45",
  viewBox: "0 0 92 45",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: ".5",
  y: "29.5",
  width: "43",
  height: "15",
  rx: "3.5",
  fill: "#FEFEFE",
  stroke: "#CFE5FF"
}), /*#__PURE__*/React.createElement("rect", {
  x: "12",
  y: "35",
  width: "20",
  height: "4",
  rx: "1",
  fill: "#6FB2FF"
}), /*#__PURE__*/React.createElement("rect", {
  x: "48.5",
  y: "29.5",
  width: "43",
  height: "15",
  rx: "3.5",
  fill: "#FEFEFE",
  stroke: "#CFE5FF"
}), /*#__PURE__*/React.createElement("rect", {
  x: "60",
  y: "35",
  width: "20",
  height: "4",
  rx: "1",
  fill: "#6FB2FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.5.5H84A7.5 7.5 0 0191.5 8v9a7.5 7.5 0 01-7.5 7.5H8A7.5 7.5 0 01.5 17V.5z",
  fill: "#CFE5FF",
  stroke: "#CFE5FF"
}), /*#__PURE__*/React.createElement("rect", {
  x: "8",
  y: "8",
  width: "62",
  height: "4",
  rx: "1",
  fill: "#6FB2FF"
}), /*#__PURE__*/React.createElement("rect", {
  x: "8",
  y: "14",
  width: "31",
  height: "4",
  rx: "1",
  fill: "#6FB2FF"
})));

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var HSLButtons = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$2({
  width: "92",
  height: "64",
  viewBox: "0 0 92 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  stroke: "#CFE5FF",
  d: "M.5 25.5h91v19H.5z"
}), /*#__PURE__*/React.createElement("rect", {
  x: "35",
  y: "33",
  width: "21.647",
  height: "4",
  rx: "1",
  fill: "#6FB2FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.5 44.5h91V56a7.5 7.5 0 01-7.5 7.5H8A7.5 7.5 0 01.5 56V44.5z",
  fill: "#FEFEFE",
  stroke: "#CFE5FF"
}), /*#__PURE__*/React.createElement("rect", {
  x: "35",
  y: "52",
  width: "21.647",
  height: "4",
  rx: "1",
  fill: "#6FB2FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.5.5H84A7.5 7.5 0 0191.5 8v16.5H.5V.5z",
  fill: "#CFE5FF",
  stroke: "#CFE5FF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6FB2FF",
  d: "M8 8h62v4H8zM8 14h31v4H8z"
})));

function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var HSLCarousel = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$3({
  width: "108",
  height: "94",
  viewBox: "0 0 108 94",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_184_909",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "108",
  height: "94"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M0 0h108v94H0z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_184_909)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "26",
  y: "15",
  width: "56",
  height: "64",
  rx: "2",
  fill: "#CFE5FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 17a2 2 0 012-2h52a2 2 0 012 2v38H26V17zM30 60h44v4H30zM30 66h34v4H30z",
  fill: "#6FB2FF"
}), /*#__PURE__*/React.createElement("g", {
  opacity: ".5"
}, /*#__PURE__*/React.createElement("rect", {
  x: "-32",
  y: "15",
  width: "56",
  height: "64",
  rx: "2",
  fill: "#CFE5FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-32 17a2 2 0 012-2h52a2 2 0 012 2v38h-56V17zM-28 60h44v4h-44zM-28 66H6v4h-34z",
  fill: "#6FB2FF"
})), /*#__PURE__*/React.createElement("g", {
  opacity: ".5"
}, /*#__PURE__*/React.createElement("rect", {
  x: "84",
  y: "15",
  width: "56",
  height: "64",
  rx: "2",
  fill: "#CFE5FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84 17a2 2 0 012-2h52a2 2 0 012 2v38H84V17zM88 60h44v4H88zM88 66h34v4H88z",
  fill: "#6FB2FF"
})))));

function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var HSLImage = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$4({
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#6FB2FF",
  d: "M11 23h41v28H11z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56 50.667V13.333C56 10.4 53.6 8 50.667 8H13.333C10.4 8 8 10.4 8 13.333v37.334C8 53.6 10.4 56 13.333 56h37.334C53.6 56 56 53.6 56 50.667zM22.667 36l6.666 8.027L38.667 32l12 16H13.333l9.334-12z",
  fill: "#CFE5FF"
})));

function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var HSLVideo = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$5({
  width: "57",
  height: "48",
  viewBox: "0 0 57 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "57",
  height: "33",
  rx: "2",
  fill: "#CFE5FF"
}), /*#__PURE__*/React.createElement("rect", {
  y: "42",
  width: "57",
  height: "2",
  rx: "1",
  fill: "#6FB2FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "24",
  cy: "43",
  r: "4",
  fill: "#CFE5FF",
  stroke: "#6FB2FF",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35 14.268c1.333.77 1.333 2.694 0 3.464l-7.5 4.33c-1.333.77-3-.192-3-1.732v-8.66c0-1.54 1.667-2.502 3-1.732l7.5 4.33z",
  fill: "#6FB2FF"
})));

function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var HSLRawText = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$6({
  width: "52",
  height: "48",
  viewBox: "0 0 52 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6 8a7 7 0 017-7h3a3 3 0 013 3v41a2 2 0 01-2 2h-5a6 6 0 01-6-6V8zM33 2h8a4 4 0 014 4v34a8 8 0 01-8 8 4 4 0 01-4-4V2z",
  fill: "#6FB2FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.859 0c2.303 0 4.249.384 4.249 2.772 0 1.592-.85 2.168-2.632 2.525-2.138.439-4.386.604-4.386 5.379v6.34c0 3.979-1.837 5.708-5.291 6.01v.768c3.454.302 5.29 2.443 5.29 6.395v7.135c0 4.643 2.126 4.953 4.209 5.345l.178.034c1.782.357 2.632.933 2.632 2.525 0 2.36-1.892 2.772-4.25 2.772-5.674 0-9.594-2.635-9.594-9.66v-6.505c0-4.144-1.371-4.665-2.824-5.104C1.15 26.319 0 25.523 0 23.437c0-2.277 1.316-2.991 2.522-3.375 1.343-.412 2.742-.933 2.742-5.05V9.578C5.264 2.525 9.184 0 14.859 0zm21.895 0c5.675 0 9.595 2.525 9.595 9.578v5.434c0 4.117 1.399 4.638 2.742 5.05 1.206.384 2.522 1.098 2.522 3.375 0 2.086-1.151 2.882-2.44 3.294-1.453.439-2.824.96-2.824 5.104v6.505c0 7.025-3.92 9.66-9.595 9.66-2.357 0-4.249-.412-4.249-2.772 0-1.592.85-2.168 2.632-2.525l.178-.034c2.083-.392 4.208-.702 4.208-5.345V30.19c0-3.952 1.837-6.093 5.291-6.395v-.768c-3.454-.302-5.29-2.031-5.29-6.01v-6.34c0-4.775-2.249-4.94-4.387-5.38-1.782-.356-2.632-.932-2.632-2.524C32.505.384 34.451 0 36.755 0z",
  fill: "#CFE5FF"
})));

function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var HSLForm = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$7({
  width: "50",
  height: "48",
  viewBox: "0 0 50 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M34.842 44.336H3.684V7.066h4.79v1.57c0 .995.842 1.833 1.842 1.833s1.842-.838 1.842-1.832v-1.57h5.316v1.57c0 .994.842 1.832 1.842 1.832s1.842-.838 1.842-1.832v-1.57h5.316v1.57c0 .994.842 1.832 1.842 1.832s1.842-.838 1.842-1.832v-1.57h4.79v17.535l3.684-3.664V6.177a2.767 2.767 0 00-2.79-2.775h-5.737v-1.57C30.105.838 29.263 0 28.263 0s-1.842.838-1.842 1.832v1.57h-5.316v-1.57C21.105.838 20.263 0 19.263 0s-1.842.838-1.842 1.832v1.57h-5.316v-1.57C12.105.838 11.263 0 10.263 0S8.421.838 8.421 1.832v1.57H2.789C1.263 3.402 0 4.606 0 6.177v39.049A2.767 2.767 0 002.79 48h33c1.526 0 2.789-1.256 2.789-2.774v-7.8l-3.684 3.664v3.246h-.053z",
  fill: "#CFE5FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.526 27.01c0-.995-.842-1.832-1.842-1.832h-16.79c-1 0-1.841.837-1.841 1.832 0 .994.842 1.832 1.842 1.832h16.79c1 0 1.841-.838 1.841-1.832zM10.895 19.682h16.79c1 0 1.841-.838 1.841-1.832 0-.995-.842-1.833-1.842-1.833h-16.79c-1 0-1.841.838-1.841 1.832 0 .995.79 1.833 1.842 1.833zM9.053 36.17c0 1.047.79 1.832 1.842 1.832h13.79l.736-3.245c.053-.157.053-.314.105-.419H10.895a1.826 1.826 0 00-1.842 1.832zM28.263 40.515l4.053-.89c.158-.053.316-.157.473-.262L34 38.107l-4.474-4.45-1.21 1.205a.848.848 0 00-.263.47l-.948 4.084c-.158.68.474 1.256 1.158 1.099zM31.105 32.14l4.421 4.449 10.527-10.47-4.421-4.448L31.105 32.14zM49.684 21.2l-3.105-3.141c-.421-.367-1-.367-1.368 0l-2.106 2.094 4.474 4.449 2.105-2.094c.421-.366.421-.942 0-1.308z",
  fill: "#6FB2FF"
})));

function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
var HSLWAReplyBtn = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$8({
  xmlns: "http://www.w3.org/2000/svg",
  width: "44",
  height: "48",
  viewBox: "0 0 44 48",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.7.032L9.428 0l-.62.02C3.898.33.008 4.381 0 9.34v22.45l.02.615c.319 4.879 4.403 8.738 9.395 8.738h17.573l-3.881 3.677-.227.258a1.792 1.792 0 00.222 2.374c.763.729 2.003.73 2.77.005l7.837-7.416.227-.257a1.793 1.793 0 00-.222-2.375l-7.836-7.474-.272-.215a2.038 2.038 0 00-2.5.21l-.227.258a1.793 1.793 0 00.223 2.375l5.07 4.838H9.416l-.544-.025c-2.865-.272-5.105-2.67-5.105-5.586V9.346l.026-.54C4.07 5.96 6.486 3.736 9.422 3.74l24.272.033.543.026c2.862.275 5.099 2.67 5.099 5.585v8.794l.03.336a1.88 1.88 0 001.853 1.534c1.04 0 1.883-.837 1.883-1.87V9.385l-.02-.614C42.764 3.896 38.687.039 33.699.032z",
  fill: "#8BF1B5"
}), /*#__PURE__*/React.createElement("rect", {
  x: "9",
  y: "11",
  width: "26",
  height: "4",
  rx: "1",
  fill: "#6ECD95"
}), /*#__PURE__*/React.createElement("rect", {
  x: "9",
  y: "18",
  width: "26",
  height: "4",
  rx: "1",
  fill: "#6ECD95"
})));

function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
var HSLWAList = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$9({
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "1.5",
  y: "1.5",
  width: "45",
  height: "45",
  rx: "1.5",
  stroke: "#A2EDC1",
  strokeWidth: "3"
}), /*#__PURE__*/React.createElement("rect", {
  x: "9",
  y: "9",
  width: "6",
  height: "6",
  rx: "1",
  fill: "#6ECD95"
}), /*#__PURE__*/React.createElement("rect", {
  x: "9",
  y: "21",
  width: "6",
  height: "6",
  rx: "1",
  fill: "#6ECD95"
}), /*#__PURE__*/React.createElement("rect", {
  x: "9",
  y: "33",
  width: "6",
  height: "6",
  rx: "1",
  fill: "#6ECD95"
}), /*#__PURE__*/React.createElement("rect", {
  x: "19",
  y: "9",
  width: "20",
  height: "6",
  rx: "1",
  fill: "#6ECD95"
}), /*#__PURE__*/React.createElement("rect", {
  x: "19",
  y: "21",
  width: "20",
  height: "6",
  rx: "1",
  fill: "#6ECD95"
}), /*#__PURE__*/React.createElement("rect", {
  x: "19",
  y: "33",
  width: "20",
  height: "6",
  rx: "1",
  fill: "#6ECD95"
})));

function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
var WhatsappIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$a({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "url(#pattern0)",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "pattern0",
  patternContentUnits: "objectBoundingBox",
  width: "1",
  height: "1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_184_1158",
  transform: "matrix(.004 0 0 .004 -.592 -.408)"
})), /*#__PURE__*/React.createElement("image", {
  id: "image0_184_1158",
  width: "547",
  height: "456",
  xlinkHref: "data:image/png;base64,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"
}))));

function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
var MultiPLM = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$b({
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "1.5",
  y: "1.5",
  width: "45",
  height: "45",
  rx: "1.5",
  stroke: "#BFEFD3",
  strokeWidth: "3"
}), /*#__PURE__*/React.createElement("rect", {
  x: "8",
  y: "8",
  width: "14",
  height: "14",
  rx: "1",
  fill: "#6ECD95"
}), /*#__PURE__*/React.createElement("rect", {
  x: "26",
  y: "8",
  width: "14",
  height: "4",
  rx: "2",
  fill: "#6ECD95"
}), /*#__PURE__*/React.createElement("rect", {
  x: "26",
  y: "14",
  width: "9",
  height: "4",
  rx: "2",
  fill: "#6ECD95"
}), /*#__PURE__*/React.createElement("rect", {
  x: "8",
  y: "26",
  width: "14",
  height: "14",
  rx: "1",
  fill: "#6ECD95"
}), /*#__PURE__*/React.createElement("rect", {
  x: "26",
  y: "26",
  width: "14",
  height: "4",
  rx: "2",
  fill: "#6ECD95"
}), /*#__PURE__*/React.createElement("rect", {
  x: "26",
  y: "32",
  width: "9",
  height: "4",
  rx: "2",
  fill: "#6ECD95"
})));

function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
var SinglePLM = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$c({
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "1.5",
  y: "1.5",
  width: "45",
  height: "45",
  rx: "1.5",
  stroke: "#BFEFD3",
  strokeWidth: "3"
}), /*#__PURE__*/React.createElement("rect", {
  x: "9",
  y: "9",
  width: "14",
  height: "14",
  rx: "1",
  fill: "#6ECD95"
}), /*#__PURE__*/React.createElement("rect", {
  x: "9",
  y: "29",
  width: "30",
  height: "4",
  rx: "2",
  fill: "#6ECD95"
}), /*#__PURE__*/React.createElement("rect", {
  x: "9",
  y: "35",
  width: "19",
  height: "4",
  rx: "2",
  fill: "#6ECD95"
})));

var HSLTYPES = [{
  title: 'Text & Quick Replies',
  value: 'TEXT',
  image: HSLTextQuickReplies
}, {
  title: 'Button',
  value: 'BUTTON',
  image: HSLButtons
}, {
  title: 'Image',
  value: 'IMAGE',
  image: HSLImage
}, {
  title: 'Video',
  value: 'VIDEO',
  image: HSLVideo
}, {
  title: 'Carousel',
  value: 'CAROUSEL',
  image: HSLCarousel
}, {
  title: 'Raw Text / JSON',
  value: 'RAW',
  image: HSLRawText
}, {
  title: 'Form Builder',
  value: 'FORM',
  image: HSLForm
}, {
  type: 'group_title',
  title: 'WhatsApp elements',
  image: WhatsappIcon
}, {
  title: 'Whatsapp Reply button',
  value: 'WHATSAPP_INTERACTIVE_BUTTON',
  image: HSLWAReplyBtn
}, {
  title: 'Whatsapp List',
  value: 'WHATSAPP_INTERACTIVE_LIST',
  image: HSLWAList
}, {
  title: 'Whatsapp Multi PLM',
  value: 'WHATSAPP_INTERACTIVE_PRODUCT_LIST',
  image: MultiPLM
}, {
  title: 'Whatsapp Single PLM',
  value: 'WHATSAPP_INTERACTIVE_SINGLE_PRODUCT',
  image: SinglePLM
}];

var css_248z = ".AddHSL_addHSLWrapper__21MXO {\n  outline: none; }\n\n.AddHSL_addHSL__1Bcpf {\n  display: flex;\n  align-items: center;\n  padding: 16px;\n  width: 300px;\n  background-color: #fff;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.02);\n  border-radius: 24px;\n  overflow: hidden;\n  border: 1px dashed #ddd;\n  border-top-left-radius: 4px;\n  cursor: pointer;\n  box-sizing: border-box; }\n  .AddHSL_addHSL__1Bcpf * {\n    font-family: \"Roboto\", sans-serif;\n    -webkit-font-smoothing: antialiased; }\n  .AddHSL_addHSL__1Bcpf.AddHSL_small__1ZV22 {\n    padding: 8px;\n    font-size: 14px; }\n    .AddHSL_addHSL__1Bcpf.AddHSL_small__1ZV22 .AddHSL_addHSLText__1hsCz {\n      opacity: 0.5; }\n\n.AddHSL_addHSLIcon__3b_nT {\n  margin-right: 8px; }\n\n.AddHSL_addHSLText__1hsCz {\n  color: #333; }\n\n.AddHSL_hslTypes__1gkLF {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 8px;\n  padding-top: 16px;\n  overflow-y: auto; }\n";
var styles = {"addHSLWrapper":"AddHSL_addHSLWrapper__21MXO","addHSL":"AddHSL_addHSL__1Bcpf","small":"AddHSL_small__1ZV22","addHSLText":"AddHSL_addHSLText__1hsCz","addHSLIcon":"AddHSL_addHSLIcon__3b_nT","hslTypes":"AddHSL_hslTypes__1gkLF"};
styleInject(css_248z);

var css_248z$1 = ".HSLType_hslType__1_U2k {\n  flex: 1;\n  flex-basis: calc(50% - 34px);\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: 0.2s ease-out; }\n  .HSLType_hslType__1_U2k:hover {\n    background-color: #fafafa; }\n\n.HSLType_hslTypeActive__3QnZG {\n  background-color: rgba(14, 68, 152, 0.05);\n  border: 1px solid #0e4498; }\n\n.HSLType_hslImage__2liLG {\n  width: 100%;\n  height: 100px;\n  object-fit: contain;\n  margin-bottom: 8px; }\n\n.HSLType_hslTitle__3tCIf {\n  margin-bottom: 12px;\n  text-align: center;\n  font-size: 14px; }\n\n.HSLType_hslSupport__2JI1s {\n  display: flex;\n  align-items: center; }\n\n.HSLType_hslSupportItem__2wCvu {\n  display: none;\n  width: 20px;\n  height: 20px;\n  background-color: #eee;\n  border-radius: 10px;\n  margin-right: 4px; }\n";
var hslStyles = {"hslType":"HSLType_hslType__1_U2k","hslTypeActive":"HSLType_hslTypeActive__3QnZG","hslImage":"HSLType_hslImage__2liLG","hslTitle":"HSLType_hslTitle__3tCIf","hslSupport":"HSLType_hslSupport__2JI1s","hslSupportItem":"HSLType_hslSupportItem__2wCvu"};
styleInject(css_248z$1);

var _templateObject, _templateObject2;
var BoxWrapper = styled.div({
  background: "#CFE5FF1A",
  padding: "16px 10px",
  borderRadius: "4px",
  border: "1px solid #CFE5FFB2",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginRight: "8px",
  marginBottom: "8px",
  textAlign: "center",
  cursor: "pointer",
  width: "calc(50% - 8px)",
  height: "160px",
  boxSizing: "border-box"
});
var BoxWrapperDisabled = styled(BoxWrapper)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  background: ", ";\n  border: 1px solid ", ";\n  cursor: not-allowed;\n"])), function (props) {
  return "".concat(props.theme.colors.grey.soft);
}, function (props) {
  return "".concat(props.theme.colors.grey.haptik);
});
var IconBox = styled(Icon)({
  minWidth: "80px",
  width: "auto",
  height: "auto",
  margin: "0px auto 0px auto",
  flexGrow: "1",
  "> span": {
    width: "auto",
    height: "auto"
  }
});
var IconBoxDisabled = styled(IconBox)({
  filter: "grayscale(100%)",
  cursor: "not-allowed"
});
var GroupTitleWrapper = styled(Box)({
  alignItems: "center",
  margin: "12px 0 18px",
  width: "100%"
});
var GroupTitleIconBox = styled(Icon)({
  marginRight: "12px",
  marginBottom: "3px"
});
var DisabledToolTip = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: none;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background-color: ", ";\n  border: 1px solid ", ";\n  color: ", ";\n  top: 0px;\n  padding-bottom: 10%;\n  line-height: 1.6;\n  font-size: 15px;\n  align-items: center;\n  justify-content: center;\n\n  ", ":hover & {\n    display: flex;\n  }\n"])), function (props) {
  return "".concat(props.theme.colors.grey.soft, "CC");
}, function (props) {
  return "".concat(props.theme.colors.red.neon);
}, function (props) {
  return "".concat(props.theme.colors.red.neon);
}, BoxWrapperDisabled);
var HSLType = function HSLType(_ref) {
  var title = _ref.title,
    onClick = _ref.onClick,
    active = _ref.active,
    image = _ref.image,
    type = _ref.type,
    channelsEnabled = _ref.channelsEnabled,
    disabledOption = _ref.disabledOption,
    currentChannelName = _ref.currentChannelName;
  var whatsappElementsEnabled = channelsEnabled && channelsEnabled.includes("whatsapp");
  if (type && type === "group_title") {
    if (!whatsappElementsEnabled) {
      return null;
    }
    return /*#__PURE__*/React.createElement(GroupTitleWrapper, null, /*#__PURE__*/React.createElement(GroupTitleIconBox, {
      src: image
    }), /*#__PURE__*/React.createElement(Text, {
      variant: "h3.semi-bold"
    }, title));
  }
  var renderText = function renderText() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      variant: "body.md"
    }, title), /*#__PURE__*/React.createElement("div", {
      className: hslStyles.hslSupport
    }, /*#__PURE__*/React.createElement("div", {
      className: hslStyles.hslSupportItem
    }), /*#__PURE__*/React.createElement("div", {
      className: hslStyles.hslSupportItem
    })));
  };
  return !disabledOption ? /*#__PURE__*/React.createElement(BoxWrapper, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(IconBox, {
    src: image
  }), renderText()) : /*#__PURE__*/React.createElement(BoxWrapperDisabled, null, /*#__PURE__*/React.createElement(IconBoxDisabled, {
    src: image
  }), renderText(), /*#__PURE__*/React.createElement(DisabledToolTip, null, "Not supported on ", currentChannelName));
};
HSLType.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
  active: PropTypes.bool,
  image: PropTypes.string,
  channelsEnabled: PropTypes.array,
  disabledOption: PropTypes.bool
};
HSLType.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "HSLType",
  "props": {
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "active": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "image": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "channelsEnabled": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "disabledOption": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};

var disabledHSLForPlatforms = {
  WhatsApp: ["CAROUSEL", "FORM"]
};
var AddHSL = /*#__PURE__*/function (_React$Component) {
  function AddHSL() {
    var _this;
    _classCallCheck(this, AddHSL);
    _this = _callSuper(this, AddHSL);
    _defineProperty(_this, "_renderDrawer", function () {
      return /*#__PURE__*/React.createElement(Drawer, {
        zIndex: 10001,
        placement: "RIGHT",
        active: _this.state.active,
        onClose: _this._deactivateDrawer
      }, /*#__PURE__*/React.createElement(Drawer.Header, {
        themed: true,
        onClose: _this._deactivateDrawer
      }, "Add an HSL Element"), /*#__PURE__*/React.createElement("div", {
        className: styles.hslTypes
      }, HSLTYPES.map(function (_ref, i) {
        var _disabledHSLForPlatfo;
        var title = _ref.title,
          value = _ref.value,
          image = _ref.image,
          type = _ref.type;
        // Temporary enabling Whatsapp HSL only for prestaging and devservers
        var disabledOption = false;
        if (title === "Whatsapp List" || title === "Whatsapp Reply button" || title === "Whatsapp Multi PLM" || title === "Whatsapp Single PLM") {
          var whatsappElementsEnabled = _this.props.channelsEnabled && _this.props.channelsEnabled.includes("whatsapp");
          if (_this.props.currentChannelName && _this.props.currentChannelName !== "WhatsApp") {
            disabledOption = true;
          }
          if (!whatsappElementsEnabled) {
            return null;
          }
        }
        if (disabledHSLForPlatforms !== null && disabledHSLForPlatforms !== void 0 && (_disabledHSLForPlatfo = disabledHSLForPlatforms[_this.props.currentChannelName]) !== null && _disabledHSLForPlatfo !== void 0 && _disabledHSLForPlatfo.includes(value)) {
          disabledOption = true;
        }
        return /*#__PURE__*/React.createElement(HSLType, {
          active: i === _this.state.activeIndex,
          key: i,
          title: title,
          type: type,
          image: image,
          onClick: function onClick() {
            return _this._handleOnClick(value);
          },
          channelsEnabled: _this.props.channelsEnabled,
          disabledOption: disabledOption,
          currentChannelName: _this.props.currentChannelName
        });
      }), /*#__PURE__*/React.createElement("div", {
        className: hslStyles.hslType
      })));
    });
    _defineProperty(_this, "_deactivateDrawer", function () {
      _this.setState({
        active: false,
        activeIndex: 0
      });
    });
    _defineProperty(_this, "_activateDrawer", function () {
      _this.setState({
        active: true
      });
    });
    _defineProperty(_this, "_handleKeyUp", function (e) {
      var activeIndex = _this.state.activeIndex;
      switch (e.keyCode) {
        case KEY_CODES.DOWN:
          return _this._changeActiveIndex(activeIndex + 2);
        case KEY_CODES.UP:
          return _this._changeActiveIndex(activeIndex - 2);
        case KEY_CODES.LEFT:
          return _this._changeActiveIndex(activeIndex - 1);
        case KEY_CODES.RIGHT:
          return _this._changeActiveIndex(activeIndex + 1);
        case KEY_CODES.ENTER:
          return _this._handleOnClick(HSLTYPES[activeIndex].value);
        default:
          return null;
      }
    });
    _defineProperty(_this, "_handleOnClick", function (HSLType) {
      _this._deactivateDrawer();
      _this.props.onClick(HSLType);
    });
    _defineProperty(_this, "_changeActiveIndex", function (newIndex) {
      if (newIndex > HSLTYPES.length - 1) return;
      if (newIndex < 0) return;
      _this.setState({
        activeIndex: newIndex
      });
    });
    _this.state = {
      active: false,
      activeIndex: 0
    };
    return _this;
  }
  _inherits(AddHSL, _React$Component);
  return _createClass(AddHSL, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        active: nextProps.active
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props;
      var noReplaceAction = ((_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.actionType) !== "replaceAction";
      var smallClassName = this.props.small ? styles.small : "";
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.addHSLWrapper, " ").concat(this.props.className),
        style: this.props.style,
        tabIndex: "-1",
        onKeyUp: this._handleKeyUp
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(noReplaceAction && styles.addHSL, " ").concat(smallClassName),
        onClick: this._activateDrawer
      }, noReplaceAction ? /*#__PURE__*/React.createElement(Icon, {
        className: styles.addHSLIcon,
        src: AddIcon
      }) : null, /*#__PURE__*/React.createElement("span", {
        className: styles.addHSLText
      }, this.props.children || "Add a chat element")), this._renderDrawer());
    }
  }]);
}(React.Component);
AddHSL.propTypes = {
  onClick: PropTypes.func,
  active: PropTypes.bool,
  small: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.string,
  children: PropTypes.string,
  channelsEnabled: PropTypes.array
};
AddHSL.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "_renderDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_deactivateDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_activateDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_handleKeyUp",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleOnClick",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "HSLType",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_changeActiveIndex",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "newIndex",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "AddHSL",
  "props": {
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "active": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "small": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "style": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "channelsEnabled": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$2 = ".Actionable_actionableWrapper__ijk1p {\n  position: relative;\n  cursor: pointer;\n  transition: 0.2s ease-out; }\n  .Actionable_actionableWrapper__ijk1p.Actionable_active__3xE4v {\n    background-color: #0e4498;\n    pointer-events: none; }\n    .Actionable_actionableWrapper__ijk1p.Actionable_active__3xE4v span {\n      color: #fff; }\n  .Actionable_actionableWrapper__ijk1p:hover {\n    background-color: #7facf3; }\n  .Actionable_actionableWrapper__ijk1p:active {\n    background-color: #0e4498; }\n    .Actionable_actionableWrapper__ijk1p:active span {\n      color: #fff; }\n  .Actionable_actionableWrapper__ijk1p > div {\n    transition: 0.2s ease-out; }\n  .Actionable_actionableWrapper__ijk1p:last-child > div {\n    border-bottom: 1px solid transparent; }\n\n.Actionable_actionable__1URAR {\n  padding: 16px;\n  border-bottom: 1px solid #ddd;\n  transition: 0.2s ease-out;\n  text-align: center;\n  cursor: pointer;\n  color: #0e4498;\n  font-size: 14px;\n  font-weight: 400;\n  pointer-events: none; }\n  .Actionable_actionable__1URAR:hover {\n    background-color: #f5f5f5; }\n  .Actionable_actionable__1URAR.small {\n    padding: 8px; }\n    .Actionable_actionable__1URAR.small .Actionable_actionableSubText__3Mny8 {\n      display: none; }\n\n.Actionable_actionableMainText__1u7qI {\n  display: block;\n  margin-bottom: 4px; }\n\n.Actionable_actionableSubText__3Mny8 {\n  display: block;\n  font-size: 12px;\n  color: #999;\n  max-width: 240px;\n  white-space: nowrap;\n  margin: 0 auto;\n  text-overflow: ellipsis;\n  overflow: hidden; }\n\n.Actionable_actionableCreateText__1bXDQ {\n  font-weight: 500; }\n\n.Actionable_actionableMenu__2JzeU {\n  position: absolute;\n  top: 50%;\n  right: -16px;\n  padding: 8px;\n  transform: translate3d(100%, -50%, 0);\n  display: flex; }\n\n.Actionable_actionableMenuIcon__1kqZ6 {\n  cursor: pointer;\n  padding-right: 12px;\n  opacity: 0.7; }\n  .Actionable_actionableMenuIcon__1kqZ6:hover {\n    opacity: 0.99; }\n\nhr {\n  height: 1px;\n  border: none;\n  background-color: #eee;\n  margin-top: 0; }\n";
var styles$1 = {"actionableWrapper":"Actionable_actionableWrapper__ijk1p","active":"Actionable_active__3xE4v","actionable":"Actionable_actionable__1URAR","actionableSubText":"Actionable_actionableSubText__3Mny8","actionableMainText":"Actionable_actionableMainText__1u7qI","actionableCreateText":"Actionable_actionableCreateText__1bXDQ","actionableMenu":"Actionable_actionableMenu__2JzeU","actionableMenuIcon":"Actionable_actionableMenuIcon__1kqZ6"};
styleInject(css_248z$2);

var Actionable = function Actionable(_ref) {
  var index = _ref.index,
    _onClick = _ref.onClick,
    text = _ref.text,
    subtitle = _ref.subtitle,
    active = _ref.active,
    mode = _ref.mode;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1.actionableWrapper, " ").concat(mode, " ").concat(active ? styles$1.active : ""),
    onClick: function onClick() {
      return _onClick("ACTIONABLE", index);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1.actionable, " ").concat(mode)
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$1.actionableMainText
  }, text), /*#__PURE__*/React.createElement("span", {
    className: styles$1.actionableSubText
  }, subtitle)));
};
Actionable.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
  text: PropTypes.string,
  subtitle: PropTypes.string,
  index: PropTypes.number,
  disabledCursorStyle: PropTypes.object
};
Actionable.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Actionable",
  "props": {
    "active": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "text": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "subtitle": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "index": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "disabledCursorStyle": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$3 = ".Button_button__1zueY {\n  position: relative;\n  width: 300px;\n  background-color: #fff;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.02);\n  border-radius: 24px;\n  overflow: hidden;\n  border: 1px solid #ddd;\n  border-top-left-radius: 4px; }\n  .Button_button__1zueY:hover .Button_textMessageMeta__YyrnC {\n    opacity: 0.5;\n    height: 14px;\n    margin-top: 6px; }\n  .Button_button__1zueY.Button_active__2RWiZ {\n    border-color: #051a3b; }\n\n.Button_buttonHeader__lijrN {\n  width: 300px;\n  max-width: 300px;\n  background-color: #fff;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.02);\n  border-radius: 24px;\n  overflow: hidden;\n  border: 1px solid #ddd;\n  border-top-left-radius: 4px;\n  padding: 12px;\n  font-size: 14px;\n  border-top-right-radius: 24px;\n  box-sizing: border-box;\n  background-color: #f5f5f5;\n  line-height: 1.4;\n  border: none;\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n  border-bottom: 1px solid #ddd;\n  box-shadow: none;\n  transition: 0.2s ease-out; }\n  .Button_buttonHeader__lijrN.small {\n    padding: 8px;\n    border-radius: 16px;\n    border-top-left-radius: 4px; }\n  .Button_buttonHeader__lijrN.Button_active__2RWiZ {\n    background-color: #0e4498;\n    color: #fff; }\n    .Button_buttonHeader__lijrN.Button_active__2RWiZ input::placeholder {\n      color: white !important; }\n\n.Button_textMessageMeta__YyrnC {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 12px;\n  margin-top: 0px;\n  font-weight: 600;\n  height: 0;\n  opacity: 0;\n  transition: 0.1s ease-out; }\n\n.Button_buttonHeaderText__3QMWK {\n  font-size: inherit;\n  color: inherit;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  padding: 0;\n  outline: none;\n  resize: none;\n  border: none;\n  pointer-events: none;\n  width: 100%;\n  overflow: hidden; }\n\n.Button_buttonHeaderNoBorder__Z1eT6 {\n  border-bottom: none; }\n\n.Button_buttonHeaderTextPlaceholder__NtWbI {\n  opacity: 0.3; }\n\n.Button_error__3Qy8u {\n  border: 1px solid #ef8b93; }\n\n.Button_overlay__1LxxR {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  bottom: 0;\n  cursor: not-allowed; }\n";
var styles$2 = {"button":"Button_button__1zueY","textMessageMeta":"Button_textMessageMeta__YyrnC","active":"Button_active__2RWiZ","buttonHeader":"Button_buttonHeader__lijrN","buttonHeaderText":"Button_buttonHeaderText__3QMWK","buttonHeaderNoBorder":"Button_buttonHeaderNoBorder__Z1eT6","buttonHeaderTextPlaceholder":"Button_buttonHeaderTextPlaceholder__NtWbI","error":"Button_error__3Qy8u","overlay":"Button_overlay__1LxxR"};
styleInject(css_248z$3);

var _dec, _dec2, _dec3, _dec4, _class;
var Button = (_dec = ToastMessage(), _dec2 = EmojiPicker(), _dec3 = ConfirmationDialog(), _dec4 = HSLWrapper(), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = /*#__PURE__*/function (_React$Component) {
  function Button(_props) {
    var _this;
    _classCallCheck(this, Button);
    _this = _callSuper(this, Button, [_props]);
    _defineProperty(_this, "emptyActionable", {
      id: 0,
      title: "Button",
      type: {},
      uri: {}
    });
    _defineProperty(_this, "initialState", {
      type: "BUTTON",
      actionableActive: false,
      actionables: [_objectSpread2({}, _this.emptyActionable)],
      botSays: "",
      voiceSays: "",
      autoOpenMic: false
    });
    _defineProperty(_this, "reset", function (nextProps, shouldAssignStateDirectly) {
      var props = nextProps || _this.props || {};
      var value = props.value ? convertFromHSL$1(props.value) : _objectSpread2({}, _this.initialState);
      if (shouldAssignStateDirectly) {
        _this.state = value;
        _this.props.onStateChange();
      } else {
        _this._setState(value);
      }
    });
    _defineProperty(_this, "_renderHeader", function () {
      var placeholderClass = (_this.state.botSays || "").length === 0 ? styles$2.buttonHeaderTextPlaceholder : "";
      var noBorderClass = (_this.state.actionables || []).length === 0 ? styles$2.buttonHeaderNoBorder : "";
      var activeClass = _this.state.actionableActive === -2 ? styles$2.active : "";
      var placeholderText = _this.props.readOnly ? "No Text" : "Tap to add";
      return /*#__PURE__*/React.createElement("div", {
        onClick: _this._openDrawer,
        className: "".concat(styles$2.buttonHeader, " ").concat(_this.props.mode, " ").concat(noBorderClass, " ").concat(activeClass)
      }, /*#__PURE__*/React.createElement(Textarea, {
        className: "".concat(styles$2.buttonHeaderText, " ").concat(placeholderClass),
        value: _this.state.botSays || placeholderText,
        disabled: true
      }), _this.props.date ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$2.textMessageMeta)
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$2.textMessageDate)
      }, _this.props.date), /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$2.textMessageUser)
      }, _this.props.user)) : null);
    });
    _defineProperty(_this, "_renderBody", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: styles$2.buttonActionables
      }, _this.state.actionables.map(function (actionable, i) {
        return /*#__PURE__*/React.createElement(Actionable, {
          mode: _this.props.mode,
          text: actionable.text,
          subtitle: _this._getActionableSubtitle(actionable),
          active: i === _this.state.actionableActive,
          onClick: _this._openDrawer,
          index: i,
          key: i
        });
      }));
    });
    _defineProperty(_this, "_renderDrawer", function () {
      if (_this.props.state) return null;
      return /*#__PURE__*/React.createElement(Drawer, {
        zIndex: 10001,
        placement: "RIGHT",
        active: _this.props.drawerActive,
        onClose: _this._save,
        width: 400
      }, /*#__PURE__*/React.createElement(Drawer.Header, {
        onCopy: _this._copy,
        onDone: _this._save
      }, "Edit Button"), /*#__PURE__*/React.createElement("div", {
        className: "drawer-body-overflow"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: "16px",
          paddingBottom: 8
        }
      }, /*#__PURE__*/React.createElement(RichText, _extends$f({}, _this.props, {
        className: "input-margin",
        value: _this.state.botSays,
        onChange: function onChange(newValue) {
          return _this._editTopLevel("botSays", newValue);
        },
        placeholder: "Type here",
        label: "Bot Responses",
        autoFocus: _this.state.actionableActive === -2,
        multiline: true,
        hasCounter: true,
        hasVoice: true,
        withHeader: true
      })), _this._renderVoiceFields()), /*#__PURE__*/React.createElement(Accordion.Sortable, {
        useDragHandle: true,
        lockAxis: "y",
        onSortEnd: _this._sortActionable,
        helperClass: "sortableElement"
      }, _this.state.actionables.map(function (actionable, i) {
        return /*#__PURE__*/React.createElement(Accordion.Item.Sortable, {
          prefixClassName: "accordion-padding",
          active: _this.state.actionableActive === i,
          onChange: _this._toggleActionable,
          itemIndex: i,
          index: i,
          key: i,
          renderHeader: function renderHeader(_ref) {
            var ReorderIcon = _ref.ReorderIcon,
              ExpandIcon = _ref.ExpandIcon;
            return /*#__PURE__*/React.createElement(AccordionHeader, {
              hasStar: true,
              index: i,
              isStarred: actionable.isDefault,
              onStar: _this._toggleActionableDefault,
              onDelete: _this._deleteActionable,
              ReorderIcon: ReorderIcon,
              ExpandIcon: ExpandIcon
            }, actionable.text || actionable.title);
          }
        }, /*#__PURE__*/React.createElement(Dropdown, {
          value: actionable.type.text,
          onChange: function onChange(value) {
            _this._editActionable(i, "type", value);
          },
          onFocus: function onFocus() {
            return _this._handleFocus(i);
          },
          placeholder: "Select Type",
          options: ACTIONABLE_OPTIONS,
          label: "Button Type",
          className: "input-margin"
        }), /*#__PURE__*/React.createElement(RichText, _extends$f({}, _this.props, {
          className: "input-margin",
          value: actionable.text,
          onChange: function onChange(value) {
            return _this._editActionable(i, "text", value);
          },
          placeholder: "Type here",
          label: "Button Text",
          onFocus: function onFocus() {
            return _this._handleFocus(i);
          },
          autoFocus: _this.state.actionableActive === i,
          maxCharacters: CONSTRAINTS.MAX_BUTTON_CHARACTERS,
          activateToastMessage: _this.props.activateToastMessage,
          withHeader: true,
          hasCounter: true,
          isRephraseEnabled: false
        })), _this._renderAdditionalFields(actionable, actionable.type.additionalFields, i, _this._save), _this._renderAdditionalFields(actionable, actionable.uri.additionalFields, i, _this._save));
      })), /*#__PURE__*/React.createElement(AddButton, {
        onClick: _this._addActionable
      }, "Add Button")));
    });
    _defineProperty(_this, "_renderVoiceFields", function () {
      if (_this._canRenderVoiceField()) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RichText, _extends$f({}, _this.props, {
          className: "input-margin",
          value: _this.state.voiceSays,
          onChange: function onChange(newValue) {
            return _this._editTopLevel("voiceSays", newValue);
          },
          placeholder: "Type here",
          label: "Voice says",
          hasVoice: true,
          multiline: true,
          withHeader: true,
          isRephraseEnabled: false
        })), /*#__PURE__*/React.createElement(Toggle, {
          className: "input-margin",
          value: _this.state.autoOpenMic,
          onChange: function onChange(newValue) {
            return _this._editTopLevel("autoOpenMic", newValue);
          },
          label: "Auto open mic"
        }));
      }
      return /*#__PURE__*/React.createElement(AddButton, {
        nested: true,
        onClick: function onClick() {
          return _this._editTopLevel("hasVoiceFields", true);
        }
      }, "Voice support");
    });
    _defineProperty(_this, "_canRenderVoiceField", function () {
      return _this.state.hasVoiceFields || _this.props.value.voice_text;
    });
    _defineProperty(_this, "_renderAdditionalFields", function (actionable) {
      var additionalFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var actionableIndex = arguments.length > 2 ? arguments[2] : undefined;
      return renderAdditionalFields(actionable, additionalFields, actionableIndex, _this._editActionable, _this._toggleActionable, _this.state.actionableActive, undefined, _this.props.activateEmojiPicker);
    });
    _defineProperty(_this, "_openDrawer", function (clickType, clickIndex) {
      var _this$props$value = _this.props.value,
        value = _this$props$value === void 0 ? {} : _this$props$value;
      if (value.supported_response === false) {
        return;
      }
      if (_this.props.readOnly) {
        _this._copy();
        return;
      }
      var actionableActive = -2;
      if (clickType === "ACTIONABLE") {
        actionableActive = clickIndex;
      }
      if (_this.props.isPopupElement) {
        _this.props.onReverseChange("actionableActive", actionableActive);
      } else {
        _this.setState({
          actionableActive: actionableActive
        }, function () {
          _this.props.activateDrawer();
        });
      }
    });
    _defineProperty(_this, "_handleFocus", function (i) {
      return _this.state.actionableActive !== i && _this._toggleActionable(i);
    });
    _defineProperty(_this, "_setState", function (state) {
      _this.setState(state, _this.props.onStateChange);
    });
    _defineProperty(_this, "_editTopLevel", function (key, value) {
      _this._setState(_defineProperty(_defineProperty({}, key, value), "changed", true));
    });
    _defineProperty(_this, "_getActionableSubtitle", function (actionable) {
      return getActionableSubtitle(actionable);
    });
    _defineProperty(_this, "_sortActionable", function (_ref2) {
      var oldIndex = _ref2.oldIndex,
        newIndex = _ref2.newIndex;
      var actionables = sort(_this.state.actionables, oldIndex, newIndex);
      _this._setState({
        actionables: actionables,
        changed: true
      });
    });
    _defineProperty(_this, "_toggleActionable", function (index) {
      var actionableActive = toggle(_this.state.actionableActive, index);
      _this._setState({
        actionableActive: actionableActive
      });
    });
    _defineProperty(_this, "_deleteActionable", function (index, e) {
      if (e) e.stopPropagation();
      if (_this.state.actionables.length - 1 < CONSTRAINTS.MIN_BUTTONS) {
        _this.props.activateToastMessage("You need to have at least ".concat(CONSTRAINTS.MIN_BUTTONS, " button"));
      } else {
        var actionables = remove(_this.state.actionables, index);
        _this._setState({
          actionables: actionables,
          changed: true
        });
      }
    });
    _defineProperty(_this, "_addActionable", function (index, e) {
      if (e) e.stopPropagation();
      if (_this.state.actionables.length + 1 > CONSTRAINTS.MAX_BUTTONS) {
        _this.props.activateToastMessage("You can't have more than ".concat(CONSTRAINTS.MAX_BUTTONS, " buttons"));
      } else {
        var actionables = add(_this.state.actionables, index, _this.emptyActionable);
        _this._setState({
          actionables: actionables,
          changed: true
        });
      }
    });
    _defineProperty(_this, "_editActionable", function (index, key, value) {
      var actionables = edit(_this.state.actionables, index, key, value);
      _this._setState({
        actionables: actionables,
        changed: true
      });
    });
    _defineProperty(_this, "_toggleActionableDefault", function (index, e) {
      e.preventDefault();
      e.stopPropagation();
      var newValue = !_this.state.actionables[index].isDefault;
      var actionables = toggleDefault(_this.state.actionables, index, newValue);
      _this._setState({
        actionables: actionables,
        changed: true
      });
    });
    _defineProperty(_this, "_save", function (e) {
      var _this$state;
      _this.setState({
        actionableActive: -1
      });
      _this.props.onSave(convertToHSL$1(_this.state), e);
      var hslElementAction = (_this$state = _this.state) !== null && _this$state !== void 0 && (_this$state = _this$state._originalHSL) !== null && _this$state !== void 0 && _this$state.isNew ? "Create" : "Edit";
      triggerMixPanelEvent(_this.state.type, hslElementAction);
    });
    _defineProperty(_this, "_copy", function () {
      _this.props.copyToClipboard(convertToHSL$1(_this.state));
    });
    _defineProperty(_this, "_showConfirmationDialog", function () {
      if (!_this.state.changed) {
        _this.props.deactivateDrawer();
      } else {
        _this.props.activateConfirmationDialog({}, function (isConfirmed) {
          if (isConfirmed) {
            _this.props.deactivateDrawer();
            _this.setState({
              changed: false
            });
          }
        });
      }
    });
    _this.state = _objectSpread2({}, _this.initialState);
    if (_props.state) _this.state = _props.state;else _this.reset(_props, true);
    return _this;
  }
  _inherits(Button, _React$Component);
  return _createClass(Button, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.state) this.setState(nextProps.state);
      if (!this.props.value && nextProps.value) this.reset(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$value2 = this.props.value,
        value = _this$props$value2 === void 0 ? {} : _this$props$value2;
      var errorClass = "";
      if (value.supported_response === false && !value.text) {
        errorClass = styles$2.error;
      }
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("section", {
        className: "".concat(styles$2.button, " ").concat(errorClass)
      }, /*#__PURE__*/React.createElement("div", {
        onClick: this._openDrawer
      }, this._renderHeader(), this._renderBody()), this._renderDrawer(), errorClass && /*#__PURE__*/React.createElement("div", {
        className: styles$2.overlay
      })));
    }
  }]);
}(React.Component)) || _class) || _class) || _class) || _class);
Button.propTypes = {
  activateConfirmationDialog: PropTypes.func,
  activateDrawer: PropTypes.func,
  activateEmojiPicker: PropTypes.func,
  activateToastMessage: PropTypes.func,
  copyToClipboard: PropTypes.func,
  date: PropTypes.string,
  deactivateDrawer: PropTypes.func,
  drawerActive: PropTypes.bool,
  entitySearchURL: PropTypes.string,
  isPopupElement: PropTypes.bool,
  mode: PropTypes.string,
  onReverseChange: PropTypes.func,
  onSave: PropTypes.func,
  onStateChange: PropTypes.func,
  readOnly: PropTypes.bool,
  state: PropTypes.object,
  user: PropTypes.string,
  value: PropTypes.object,
  isRephraseEnabled: PropTypes.bool,
  baseUrl: PropTypes.string
};
Button.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "reset",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "nextProps",
      "type": null
    }, {
      "name": "shouldAssignStateDirectly",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderHeader",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderBody",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderVoiceFields",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_canRenderVoiceField",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderAdditionalFields",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "actionable",
      "type": null
    }, {
      "name": "additionalFields",
      "type": null
    }, {
      "name": "actionableIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_openDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "clickType",
      "type": null
    }, {
      "name": "clickIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleFocus",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_setState",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "state",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_editTopLevel",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "key",
      "type": null
    }, {
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_getActionableSubtitle",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "actionable",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_sortActionable",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ oldIndex, newIndex }",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_toggleActionable",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_deleteActionable",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_addActionable",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_editActionable",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "key",
      "type": null
    }, {
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_toggleActionableDefault",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_save",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_copy",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_showConfirmationDialog",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Button",
  "props": {
    "activateConfirmationDialog": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activateDrawer": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activateEmojiPicker": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activateToastMessage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "copyToClipboard": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "date": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "deactivateDrawer": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "drawerActive": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "entitySearchURL": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "isPopupElement": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "mode": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onReverseChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onSave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onStateChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "readOnly": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "state": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "user": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "isRephraseEnabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "baseUrl": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
var ReorderLeftIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$d({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "10",
  viewBox: "0 0 20 10"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-2-7h24v24H-2z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  d: "M17.5 1h-5A1.5 1.5 0 0011 2.5v5A1.5 1.5 0 0012.5 9h5A1.5 1.5 0 0019 7.5v-5A1.5 1.5 0 0017.5 1z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M2.463 6.619l-1.62-1.62 1.62-1.62M.87 5.028h6.82"
}))));

function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
var ReorderRightIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$e({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "10",
  viewBox: "0 0 20 10"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22 17H-2V-7h24z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  d: "M2.5 9h5A1.5 1.5 0 009 7.5v-5A1.5 1.5 0 007.5 1h-5A1.5 1.5 0 001 2.5v5A1.5 1.5 0 002.5 9z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M17.537 3.381l1.62 1.62-1.62 1.62M19.13 4.972h-6.82"
}))));

var css_248z$4 = ".CarouselElement_carouselElementWrapper__2g0t- {\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 0px;\n  position: relative; }\n  .CarouselElement_carouselElementWrapper__2g0t-.CarouselElement_isFirst__3pR50 {\n    margin-left: 0; }\n\n@keyframes CarouselElement_slide-up__1AwFB {\n  0% {\n    opacity: 0;\n    transform: translateY(10px); }\n  100% {\n    opacity: 1;\n    transform: translateY(0px); } }\n\n.CarouselElement_carouselWrapper__Ztvm2 {\n  width: 268px;\n  min-width: 268px;\n  border: 1px solid #ddd;\n  border-radius: 24px;\n  overflow: hidden;\n  background-color: #fff;\n  transform: scale3d(0.8, 0.8, 1);\n  transition: 0.3s cubic-bezier(0.175, 0.5, 0.12, 1); }\n  .CarouselElement_carouselWrapper__Ztvm2 input,\n  .CarouselElement_carouselWrapper__Ztvm2 textarea {\n    display: block;\n    outline: none;\n    border: none;\n    resize: none;\n    width: 100%;\n    background-color: transparent; }\n    .CarouselElement_carouselWrapper__Ztvm2 input::placeholder,\n    .CarouselElement_carouselWrapper__Ztvm2 textarea::placeholder {\n      color: #000; }\n  .CarouselElement_carouselWrapper__Ztvm2.CarouselElement_enlarged__1ldQ2 {\n    transform: scale3d(1, 1, 1);\n    margin-top: auto;\n    margin-bottom: auto;\n    border: 1px solid transparent; }\n  .CarouselElement_carouselWrapper__Ztvm2.CarouselElement_noBorder__16AqC {\n    border: none; }\n\n.CarouselElement_carouselLessMarginRight__X1w3U {\n  margin-right: -36px;\n  transform-origin: 0 50%; }\n\n.CarouselElement_carouselImage__2UXGG {\n  width: 100%;\n  min-height: 150px;\n  height: 150px;\n  object-fit: cover;\n  border-bottom: 1px solid #ddd; }\n\n.CarouselElement_customKeyImage__3oPix {\n  width: 100%;\n  min-height: 150px;\n  height: 150px;\n  border-bottom: 1px solid #ddd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column; }\n  .CarouselElement_customKeyImage__3oPix > div {\n    padding-bottom: 8px; }\n\n.CarouselElement_carouselImagePlaceholder__31kEz {\n  width: 100%;\n  height: 150px;\n  border-bottom: 1px solid #ddd;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n\n.CarouselElement_carouselImagePlaceholderIcon__c9gwG {\n  width: 64px;\n  height: 64px; }\n\n.CarouselElement_carouselText__IKCWz {\n  padding: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #ddd; }\n  .CarouselElement_carouselText__IKCWz * {\n    cursor: pointer;\n    transition: 0.2s ease-out; }\n    .CarouselElement_carouselText__IKCWz *:hover {\n      color: #0e4498;\n      background-color: rgba(14, 68, 152, 0.1); }\n    .CarouselElement_carouselText__IKCWz *.CarouselElement_active__17FLZ {\n      color: #0e4498; }\n  .CarouselElement_carouselText__IKCWz:empty {\n    padding: 0;\n    border: none;\n    margin-bottom: -5px; }\n\n.CarouselElement_carouselTextTitleWrapper__3NWDP {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 6px; }\n\n.CarouselElement_carouselTextTitle__qsm1B {\n  font-size: 17px;\n  flex: 2;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.CarouselElement_carouselTextMetadata__ZrYNK {\n  text-align: right;\n  font-size: 12px;\n  opacity: 0.7;\n  flex: 1; }\n\n.CarouselElement_carouselTextSubtitle__u17sK {\n  font-weight: 700;\n  margin-bottom: 6px;\n  font-size: 14px; }\n\n.CarouselElement_carouselTextDescription__iiv5b {\n  font-size: 14px;\n  opacity: 0.7;\n  position: relative;\n  left: -1px;\n  padding: 0 !important;\n  box-shadow: none !important; }\n\n.CarouselElement_carouselElementActions__2zE5L {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 16px;\n  opacity: 0;\n  pointer-events: none;\n  transition: 0.2s ease-out;\n  transition-delay: 0.1s; }\n  .CarouselElement_carouselElementActions__2zE5L.CarouselElement_enlarged__1ldQ2 {\n    opacity: 1;\n    pointer-events: auto; }\n    .CarouselElement_carouselElementActions__2zE5L.CarouselElement_enlarged__1ldQ2.CarouselElement_onlyElement__2g3ou {\n      opacity: 0;\n      pointer-events: none; }\n\n.CarouselElement_carouselElementAction__3wymN {\n  width: 24px;\n  height: 24px;\n  background-color: #fff;\n  border-radius: 48px;\n  margin-right: 16px;\n  padding: 8px;\n  cursor: pointer;\n  box-sizing: content-box; }\n  .CarouselElement_carouselElementAction__3wymN:last-child {\n    margin-right: -16px; }\n  .CarouselElement_carouselElementAction__3wymN.CarouselElement_rotated__3k_fp {\n    transform: rotate(90deg); }\n  .CarouselElement_carouselElementAction__3wymN.CarouselElement_firstElement__3_kNe {\n    opacity: 0;\n    display: none; }\n  .CarouselElement_carouselElementAction__3wymN.CarouselElement_lastElement__3--Lo {\n    opacity: 0;\n    display: none; }\n\n.CarouselElement_miniActionable__2O-a9 {\n  position: relative;\n  margin-left: -8px;\n  transform: translateY(-50%); }\n  .CarouselElement_miniActionable__2O-a9 button {\n    margin: 0 auto;\n    font-size: 14px;\n    font-weight: 500; }\n\n.CarouselElement_overlay__3DQ4J {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  bottom: 0;\n  cursor: not-allowed; }\n";
var styles$3 = {"carouselElementWrapper":"CarouselElement_carouselElementWrapper__2g0t-","isFirst":"CarouselElement_isFirst__3pR50","carouselWrapper":"CarouselElement_carouselWrapper__Ztvm2","enlarged":"CarouselElement_enlarged__1ldQ2","noBorder":"CarouselElement_noBorder__16AqC","carouselLessMarginRight":"CarouselElement_carouselLessMarginRight__X1w3U","carouselImage":"CarouselElement_carouselImage__2UXGG","customKeyImage":"CarouselElement_customKeyImage__3oPix","carouselImagePlaceholder":"CarouselElement_carouselImagePlaceholder__31kEz","carouselImagePlaceholderIcon":"CarouselElement_carouselImagePlaceholderIcon__c9gwG","carouselText":"CarouselElement_carouselText__IKCWz","active":"CarouselElement_active__17FLZ","carouselTextTitleWrapper":"CarouselElement_carouselTextTitleWrapper__3NWDP","carouselTextTitle":"CarouselElement_carouselTextTitle__qsm1B","carouselTextMetadata":"CarouselElement_carouselTextMetadata__ZrYNK","carouselTextSubtitle":"CarouselElement_carouselTextSubtitle__u17sK","carouselTextDescription":"CarouselElement_carouselTextDescription__iiv5b","carouselElementActions":"CarouselElement_carouselElementActions__2zE5L","onlyElement":"CarouselElement_onlyElement__2g3ou","carouselElementAction":"CarouselElement_carouselElementAction__3wymN","rotated":"CarouselElement_rotated__3k_fp","firstElement":"CarouselElement_firstElement__3_kNe","lastElement":"CarouselElement_lastElement__3--Lo","miniActionable":"CarouselElement_miniActionable__2O-a9","overlay":"CarouselElement_overlay__3DQ4J","slide-up":"CarouselElement_slide-up__1AwFB"};
styleInject(css_248z$4);

var CarouselElement = /*#__PURE__*/function (_React$Component) {
  function CarouselElement() {
    var _this;
    _classCallCheck(this, CarouselElement);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CarouselElement, [].concat(args));
    _defineProperty(_this, "state", {});
    _defineProperty(_this, "_renderImage", function (horizontalAlignment, verticalAlignment) {
      var _this$props = _this.props,
        thumbnail = _this$props.thumbnail,
        aspectRatio = _this$props.aspectRatio;
      var width = BASE.IMAGE_WIDTH;
      var height = width / aspectRatio.value;
      if (thumbnail && isValidURL(thumbnail) && !isVideo(thumbnail).isVideo) {
        return /*#__PURE__*/React.createElement("img", {
          onClick: function onClick(e) {
            return _this._handleClick(0, e);
          },
          src: thumbnail,
          className: styles$3.carouselImage,
          style: {
            width: width,
            height: height,
            objectPosition: "".concat((horizontalAlignment === null || horizontalAlignment === void 0 ? void 0 : horizontalAlignment.value) || "center", " ").concat((verticalAlignment === null || verticalAlignment === void 0 ? void 0 : verticalAlignment.value) || "center")
          }
        });
      }
      if (thumbnail && isValidURL(thumbnail) && isVideo(thumbnail).isVideo) {
        return /*#__PURE__*/React.createElement("iframe", {
          className: styles$3.carouselImage,
          allowFullScreen: "allowfullscreen",
          mozAllowFullScreen: "mozallowfullscreen",
          msAllowFullScreen: "msallowfullscreen",
          oAllowFullScreen: "oallowfullscreen",
          webkitAllowFullScreen: "webkitallowfullscreen",
          frameBorder: "0",
          src: thumbnail,
          width: width,
          height: height
        });
      }
      return /*#__PURE__*/React.createElement("div", {
        onClick: function onClick(e) {
          return _this._handleClick(0, e);
        },
        style: {
          width: width,
          height: height
        },
        className: styles$3.customKeyImage
      }, /*#__PURE__*/React.createElement(Icon, {
        className: styles$3.carouselImagePlaceholderIcon,
        src: PlaceholderIcon
      }), thumbnail);
    });
    _defineProperty(_this, "_handleClick", function (textIndex, e) {
      _this.props.onClick(_this.props.index, e, -1, textIndex);
    });
    _defineProperty(_this, "_handleMiniActionableClick", function (e) {
      _this.props.onClick(_this.props.index, e, KEYS$1.MINI_ACTIONABLE_INDEX, 0);
    });
    return _this;
  }
  _inherits(CarouselElement, _React$Component);
  return _createClass(CarouselElement, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        title = _this$props2.title,
        subtitle = _this$props2.subtitle,
        description = _this$props2.description,
        metadata = _this$props2.metadata,
        children = _this$props2.children,
        onDelete = _this$props2.onDelete,
        index = _this$props2.index,
        enlarged = _this$props2.enlarged,
        lessMarginRight = _this$props2.lessMarginRight,
        numElements = _this$props2.numElements,
        onReorder = _this$props2.onReorder,
        isPopupElement = _this$props2.isPopupElement,
        activeTextElement = _this$props2.activeTextElement,
        active = _this$props2.active,
        actionables = _this$props2.actionables,
        errorClass = _this$props2.errorClass,
        horizontalAlignment = _this$props2.horizontalAlignment,
        verticalAlignment = _this$props2.verticalAlignment;
      var onlyElement = numElements === 1;
      var lastElement = index === numElements - 1;
      var firstElement = index === 0;
      var enlargedClassName = enlarged && active ? styles$3.enlarged : "";
      var onlyElementClassName = onlyElement ? styles$3.onlyElement : "";
      var lastElementClassName = lastElement ? styles$3.lastElement : "";
      var firstElementClassName = firstElement ? styles$3.firstElement : "";
      var lessMarginRightClassName = lessMarginRight ? styles$3.carouselLessMarginRight : "";
      var noBorderClassName = isPopupElement ? styles$3.noBorder : "";
      var offset = "auto";
      if (this._wrapperDOM && !isPopupElement && !enlarged) {
        offset = 0.1 * this._wrapperDOM.getBoundingClientRect().height * -1 + 1;
      }
      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(DOMElement) {
          _this2._wrapperDOM = DOMElement;
        },
        className: "".concat(styles$3.carouselElementWrapper, " ").concat(index === 0 ? styles$3.isFirst : "")
      }, /*#__PURE__*/React.createElement("div", {
        className: " ".concat(errorClass, " ").concat(styles$3.carouselWrapper, " ").concat(enlargedClassName, " ").concat(lessMarginRightClassName, " ").concat(noBorderClassName, " "),
        style: {
          marginTop: offset,
          marginBottom: offset
        }
      }, this._renderImage(horizontalAlignment, verticalAlignment), /*#__PURE__*/React.createElement("div", {
        className: styles$3.carouselText
      }, title || metadata || isPopupElement ? /*#__PURE__*/React.createElement("div", {
        className: styles$3.carouselTextTitleWrapper
      }, /*#__PURE__*/React.createElement("input", {
        onClick: function onClick(e) {
          return _this2._handleClick(0, e);
        },
        className: "".concat(styles$3.carouselTextTitle, " ").concat(activeTextElement === 0 ? styles$3.active : ""),
        value: title,
        placeholder: "Title"
      }), metadata ? /*#__PURE__*/React.createElement("input", {
        onClick: function onClick(e) {
          return _this2._handleClick(1, e);
        },
        className: "".concat(styles$3.carouselTextMetadata, " ").concat(activeTextElement === 1 ? styles$3.active : ""),
        value: metadata,
        placeholder: "Metadata"
      }) : null) : null, subtitle || isPopupElement ? /*#__PURE__*/React.createElement("input", {
        onClick: function onClick(e) {
          return _this2._handleClick(2, e);
        },
        className: "".concat(styles$3.carouselTextSubtitle, " ").concat(activeTextElement === 2 ? styles$3.active : ""),
        value: subtitle,
        placeholder: "Subtitle"
      }) : null, description || isPopupElement ? /*#__PURE__*/React.createElement("textarea", {
        onClick: function onClick(e) {
          return _this2._handleClick(3, e);
        },
        className: "".concat(styles$3.carouselTextDescription, " ").concat(activeTextElement === 3 ? styles$3.active : ""),
        value: description,
        placeholder: "Description"
      }) : null), !actionables[KEYS$1.MINI_ACTIONABLE_INDEX] ? /*#__PURE__*/React.createElement("div", {
        className: styles$3.carouselActionables
      }, children) : null), actionables[KEYS$1.MINI_ACTIONABLE_INDEX] ? /*#__PURE__*/React.createElement("div", {
        className: styles$3.miniActionable,
        onClick: this._handleMiniActionableClick
      }, /*#__PURE__*/React.createElement(Button$1, {
        primary: true,
        big: true,
        className: errorClass
      }, actionables[KEYS$1.MINI_ACTIONABLE_INDEX].text)) : null, isPopupElement ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$3.carouselElementActions, " ").concat(enlargedClassName, " ").concat(onlyElementClassName)
      }, /*#__PURE__*/React.createElement(Icon, {
        src: ReorderLeftIcon,
        className: "".concat(styles$3.carouselElementAction, " ").concat(firstElementClassName),
        onClick: function onClick(e) {
          return onReorder(index, -1, e);
        }
      }), /*#__PURE__*/React.createElement(Icon, {
        src: TrashIcon,
        className: styles$3.carouselElementAction,
        onClick: function onClick(e) {
          return onDelete(index, e);
        }
      }), /*#__PURE__*/React.createElement(Icon, {
        src: ReorderRightIcon,
        className: "".concat(styles$3.carouselElementAction, " ").concat(lastElementClassName),
        onClick: function onClick(e) {
          return onReorder(index, 1, e);
        }
      })) : null, errorClass && /*#__PURE__*/React.createElement("div", {
        className: styles$3.overlay
      }));
    }
  }]);
}(React.Component);
_defineProperty(CarouselElement, "propTypes", {
  children: PropTypes.node,
  index: PropTypes.number,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  onReorder: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  metadata: PropTypes.string,
  thumbnail: PropTypes.string,
  enlarged: PropTypes.bool,
  lessMarginRight: PropTypes.bool,
  numElements: PropTypes.number,
  isPopupElement: PropTypes.bool,
  aspectRatio: PropTypes.object,
  horizontalAlignment: PropTypes.object,
  verticalAlignment: PropTypes.object
});
CarouselElement.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "_renderImage",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "horizontalAlignment",
      "type": null
    }, {
      "name": "verticalAlignment",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleClick",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "textIndex",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleMiniActionableClick",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "CarouselElement",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "index": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onDelete": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onReorder": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "subtitle": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "description": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "metadata": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "thumbnail": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "enlarged": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "lessMarginRight": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "numElements": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "isPopupElement": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "aspectRatio": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "horizontalAlignment": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "verticalAlignment": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$5 = ".AddCarouselElement_addCarouselElementWrapper__1X4ex {\n  display: inline-block;\n  vertical-align: middle;\n  width: 166.66667px;\n  min-width: 166.66667px;\n  border: 1px solid #ddd;\n  border-radius: 24px;\n  overflow: hidden;\n  background-color: #fff;\n  transform: translateY(30%);\n  margin-left: 26px;\n  transition: 0.5s cubic-bezier(0.175, 0.5, 0.12, 1);\n  min-height: 200px;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer; }\n  .AddCarouselElement_addCarouselElementWrapper__1X4ex:hover {\n    background: #fff;\n    background-color: #f3f6fa; }\n  .AddCarouselElement_addCarouselElementWrapper__1X4ex.AddCarouselElement_active__3OADc {\n    transform: translateY(30%) scale3d(1.3, 1.3, 1.3); }\n\n.AddCarouselElement_carouselLessMarginRight__1bKfv {\n  margin-right: -24px;\n  transform-origin: 0 50%; }\n\n.AddCarouselElement_addCarouselElementText__3_XHi {\n  font-size: 18px;\n  color: #0e4498;\n  text-align: center; }\n\n.AddCarouselElement_addCarouselElementIcon__32ZHf {\n  width: 48px;\n  height: 48px;\n  border-radius: 100px;\n  margin-bottom: 16px; }\n  .AddCarouselElement_addCarouselElementIcon__32ZHf svg g {\n    stroke: #0e4498; }\n  .AddCarouselElement_addCarouselElementIcon__32ZHf svg path {\n    fill: #0e4498; }\n";
var styles$4 = {"addCarouselElementWrapper":"AddCarouselElement_addCarouselElementWrapper__1X4ex","active":"AddCarouselElement_active__3OADc","carouselLessMarginRight":"AddCarouselElement_carouselLessMarginRight__1bKfv","addCarouselElementText":"AddCarouselElement_addCarouselElementText__3_XHi","addCarouselElementIcon":"AddCarouselElement_addCarouselElementIcon__32ZHf"};
styleInject(css_248z$5);

var AddCarouselElement = function AddCarouselElement(_ref) {
  var _onClick = _ref.onClick,
    index = _ref.index,
    enlarged = _ref.enlarged,
    lessMarginRight = _ref.lessMarginRight,
    style = _ref.style,
    active = _ref.active;
  var enlargedClassName = enlarged || active ? styles$4.active : "";
  var lessMarginRightClassName = lessMarginRight ? styles$4.carouselLessMarginRight : "";
  return /*#__PURE__*/React.createElement("div", {
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$4.addCarouselElementWrapper, " ").concat(enlargedClassName, " ").concat(lessMarginRightClassName),
    onClick: function onClick(e) {
      return _onClick(index, e);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: AddIcon,
    className: styles$4.addCarouselElementIcon
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$4.addCarouselElementText
  }, "Add Carousel Element")));
};
AddCarouselElement.propTypes = {
  index: PropTypes.number,
  onClick: PropTypes.func,
  enlarged: PropTypes.bool,
  lessMarginRight: PropTypes.bool,
  style: PropTypes.object
};
AddCarouselElement.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AddCarouselElement",
  "props": {
    "index": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "enlarged": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "lessMarginRight": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "style": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$6 = ".Carousel_textMessage__2kE4x {\n  width: 300px;\n  max-width: 300px;\n  background-color: #fff;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.02);\n  border-radius: 24px;\n  overflow: hidden;\n  border: 1px solid #ddd;\n  border-top-left-radius: 4px;\n  padding: 12px;\n  font-size: 14px;\n  border-top-right-radius: 24px;\n  box-sizing: border-box;\n  background-color: #f5f5f5;\n  line-height: 1.4;\n  margin-bottom: 12px; }\n  .Carousel_textMessage__2kE4x.small {\n    padding: 8px;\n    border-radius: 16px;\n    border-top-left-radius: 4px; }\n  .Carousel_textMessage__2kE4x.Carousel_active__2FUij {\n    background-color: #0e4498;\n    color: #fff;\n    border-color: #051a3b;\n    transition: 0.2s ease-out; }\n    .Carousel_textMessage__2kE4x.Carousel_active__2FUij input::placeholder {\n      color: white !important; }\n\n.Carousel_textMessagePopup__39PGC {\n  margin-left: auto;\n  margin-right: auto; }\n\n.Carousel_textMessageText___h1EJ {\n  font-size: inherit;\n  color: inherit;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  padding: 0;\n  outline: none;\n  resize: none;\n  border: none;\n  pointer-events: none;\n  width: 100%;\n  overflow: hidden; }\n\n.Carousel_textMessageTextPlaceholder__gulVP {\n  opacity: 0.3; }\n\n.Carousel_carouselHeaderDropdowns__1z1aH {\n  display: flex;\n  padding: 0 12px; }\n  .Carousel_carouselHeaderDropdowns__1z1aH > div {\n    flex: 1; }\n    .Carousel_carouselHeaderDropdowns__1z1aH > div:first-child {\n      flex: 1;\n      margin-right: 8px; }\n\n.Carousel_carouselElements__3V6q7 {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  max-width: 600px;\n  overflow: hidden; }\n  .Carousel_carouselElementsError__1X_dC {\n    border: 1px solid #ef8b93; }\n\n.Carousel_carouselElementsArrow__29qWB {\n  width: 46px !important;\n  height: 46px !important;\n  z-index: 3;\n  left: auto !important;\n  right: -5px !important;\n  transition: 0.2s ease-out;\n  filter: drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.1)); }\n  .Carousel_carouselElementsArrow__29qWB svg > g {\n    fill: #fff; }\n  .Carousel_carouselElementsArrow__29qWB:before {\n    content: none !important; }\n\n.Carousel_carouselElementsArrowPrev__3Zi_S {\n  left: -5px !important;\n  right: auto !important;\n  transform: rotate(180deg) translateY(50%) !important; }\n";
var styles$5 = {"textMessage":"Carousel_textMessage__2kE4x","active":"Carousel_active__2FUij","textMessagePopup":"Carousel_textMessagePopup__39PGC","textMessageText":"Carousel_textMessageText___h1EJ","textMessageTextPlaceholder":"Carousel_textMessageTextPlaceholder__gulVP","carouselHeaderDropdowns":"Carousel_carouselHeaderDropdowns__1z1aH","carouselElements":"Carousel_carouselElements__3V6q7","carouselElementsError":"Carousel_carouselElementsError__1X_dC","carouselElementsArrow":"Carousel_carouselElementsArrow__29qWB","carouselElementsArrowPrev":"Carousel_carouselElementsArrowPrev__3Zi_S"};
styleInject(css_248z$6);

var _dec$1, _dec2$1, _dec3$1, _dec4$1, _class$1;
var Carousel = (_dec$1 = EmojiPicker(), _dec2$1 = ToastMessage(), _dec3$1 = ConfirmationDialog(), _dec4$1 = HSLWrapper(), _dec$1(_class$1 = _dec2$1(_class$1 = _dec3$1(_class$1 = _dec4$1(_class$1 = /*#__PURE__*/function (_React$Component) {
  function Carousel(_props) {
    var _this;
    _classCallCheck(this, Carousel);
    _this = _callSuper(this, Carousel, [_props]);
    _defineProperty(_this, "emptyActionable", {
      id: 0,
      title: "Button",
      type: {},
      uri: {}
    });
    _defineProperty(_this, "emptyMiniActionable", {
      id: 0,
      title: "Button",
      type: {},
      uri: {}
    });
    _defineProperty(_this, "emptyCarouselItem", {
      thumbnail: "",
      title: "",
      actionables: add([], 0, _this.emptyActionable)
    });
    _defineProperty(_this, "initialState", {
      type: "CAROUSEL",
      accordionActive: false,
      items: [_objectSpread2({}, _this.emptyCarouselItem)],
      size: {},
      aspectRatio: {},
      activeCarouselElementIndex: 0,
      activeTextElement: -1
    });
    _defineProperty(_this, "reset", function (nextProps, shouldAssignStateDirectly) {
      var props = nextProps || _this.props || {};
      var value = props.value ? convertFromHSL$2(props.value) : _objectSpread2({}, _this.initialState);
      if (value.items.length === 0) {
        value.items = value.items.concat([_objectSpread2({}, _this.emptyCarouselItem)]);
      }
      if (shouldAssignStateDirectly) {
        _this.state = value;
        _this.props.onStateChange();
      } else {
        _this._setState(value);
      }
    });
    _defineProperty(_this, "_renderMessage", function () {
      var placeholderClass = (_this.state.botSays || "").length === 0 ? styles$5.textMessageTextPlaceholder : "";
      var popupClass = _this.props.isPopupElement ? styles$5.textMessagePopup : "";
      var activeClass = _this.state.accordionActive === -2 ? styles$5.active : "";
      var placeholderText = _this.props.readOnly ? "No Text" : "Tap to add";
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$5.textMessage, " ").concat(popupClass, " ").concat(activeClass),
        onClick: function onClick(e) {
          return _this._openDrawer(0, e, -2);
        }
      }, /*#__PURE__*/React.createElement(Textarea, {
        className: "".concat(styles$5.textMessageText, " ").concat(placeholderClass),
        value: _this.state.botSays || placeholderText,
        disabled: true
      }, _this.state.botSays));
    });
    _defineProperty(_this, "_renderCarousel", function () {
      var _this$props$value = _this.props.value,
        value = _this$props$value === void 0 ? {} : _this$props$value;
      var errorClass = "";
      if (value.supported_response === false) {
        errorClass = styles$5.carouselElementsError;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$5.carouselElements)
      }, /*#__PURE__*/React.createElement(Slider, {
        centerMode: !!_this.props.isPopupElement,
        ref: function ref(sliderElement) {
          _this._slider = sliderElement;
        },
        onChange: _this._activateCarouselElement,
        initialSlide: _this.state.activeCarouselElementIndex
      }, _this.state.items.map(function (item, i) {
        var isActive = i === _this.state.activeCarouselElementIndex;
        return /*#__PURE__*/React.createElement(CarouselElement, _extends$f({
          activeTextElement: isActive ? _this.state.activeTextElement : -1,
          enlarged: isActive && _this.props.isPopupElement,
          lessMarginRight: !_this.props.isPopupElement,
          numElements: _this.state.items.length,
          onClick: _this._openDrawer,
          onDelete: _this._deleteCarouselElement,
          onReorder: _this._reorderCarouselElement,
          index: i,
          key: i,
          isPopupElement: _this.props.isPopupElement,
          aspectRatio: _this.state.aspectRatio,
          errorClass: errorClass,
          horizontalAlignment: item.horizontalAlignment,
          verticalAlignment: item.verticalAlignment
        }, item), _this._renderActionables(item.actionables, i));
      }), _this.props.isPopupElement ? /*#__PURE__*/React.createElement(AddCarouselElement, {
        onClick: _this._addCarouselElement,
        enlarged: _this.state.items.length + 1 === _this.state.activeCarouselElementIndex && _this.props.isPopupElement,
        lessMarginRight: !_this.props.isPopupElement
      }) : null));
    });
    _defineProperty(_this, "_renderActionables", function () {
      var actionables = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var carouselIndex = arguments.length > 1 ? arguments[1] : undefined;
      return actionables.map(function (actionable, i) {
        var _this$state = _this.state,
          accordionActive = _this$state.accordionActive,
          activeCarouselElementIndex = _this$state.activeCarouselElementIndex;
        var isActive = i === accordionActive && carouselIndex === activeCarouselElementIndex;
        return /*#__PURE__*/React.createElement(Actionable, {
          active: isActive,
          onClick: function onClick(clickType, clickIndex) {
            return _this._openDrawer(_this.state.activeCarouselElementIndex, undefined, clickIndex);
          },
          index: i,
          key: i,
          text: actionable.text,
          subtitle: _this._getActionableSubtitle(actionable)
        });
      });
    });
    _defineProperty(_this, "_renderDrawer", function () {
      if (_this.props.isPopupElement) return null;
      var _this$state2 = _this.state,
        items = _this$state2.items,
        activeCarouselElementIndex = _this$state2.activeCarouselElementIndex;
      var activeCarouselElement = items[activeCarouselElementIndex];
      return /*#__PURE__*/React.createElement(Drawer, {
        zIndex: 10001,
        placement: "RIGHT",
        active: _this.props.drawerActive,
        onClose: _this._save,
        width: 400
      }, /*#__PURE__*/React.createElement(Drawer.Header, {
        onDone: _this._save,
        onCopy: _this._copy
      }, "Edit Carousel"), /*#__PURE__*/React.createElement("div", {
        className: "drawer-body-overflow"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          paddingTop: 16
        },
        className: "".concat(styles$5.carouselHeaderDropdowns, " input-margin")
      }, /*#__PURE__*/React.createElement(Dropdown, {
        placeholder: "Select Size",
        value: _this.state.size.text,
        onChange: function onChange(size) {
          _this._setState({
            size: size
          });
        },
        options: CAROUSEL_SIZE_OPTIONS
      }), /*#__PURE__*/React.createElement(Dropdown, {
        placeholder: "Select Aspect Ratio",
        value: _this.state.aspectRatio.text,
        onChange: function onChange(aspectRatio) {
          _this._setState({
            aspectRatio: aspectRatio
          });
        },
        options: CAROUSEL_RATIO_OPTIONS
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          padding: "0 16px"
        }
      }, _this.state.aspectRatio.text === "Custom" ? /*#__PURE__*/React.createElement(Text$1, {
        className: "input-margin",
        label: "Custom Aspect Ratio",
        placeholder: "Eg. 1.68",
        value: _this.state.aspectRatio.value,
        onChange: function onChange(aspectRatio) {
          _this._setState({
            aspectRatio: {
              text: "Custom",
              value: aspectRatio
            }
          });
        }
      }) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          padding: "0 16px"
        }
      }, /*#__PURE__*/React.createElement(RichText, _extends$f({}, _this.props, {
        className: "input-margin",
        value: _this.state.botSays,
        onChange: _this._editBotSays,
        placeholder: "Type here",
        label: "Notification Text",
        autoFocus: _this.state.accordionActive === -2,
        onFocus: function onFocus() {
          return _this.state.accordionActive !== -2 && _this._toggleActionable(-2);
        },
        multiline: true,
        hasCounter: true,
        withHeader: true
      }))), /*#__PURE__*/React.createElement(Accordion.Sortable, {
        key: _this.state.activeCarouselElementIndex,
        useDragHandle: true,
        lockAxis: "y",
        onSortEnd: _this._sortActionable,
        helperClass: "sortableElement"
      }, _this._renderCarouselDetailFields(), _this._renderActionableFields(), _this._renderMiniActionableFields()), !activeCarouselElement.hasMiniActionable ? /*#__PURE__*/React.createElement(AddButton, {
        onClick: _this._addActionable
      }, "Add Button") : null));
    });
    _defineProperty(_this, "_renderCarouselDetailFields", function () {
      var _this$state3 = _this.state,
        items = _this$state3.items,
        activeCarouselElementIndex = _this$state3.activeCarouselElementIndex;
      var activeCarouselElement = items[activeCarouselElementIndex];
      return /*#__PURE__*/React.createElement(Accordion.Item, {
        itemIndex: -1,
        index: -1,
        key: -1,
        onChange: _this._toggleActionable,
        active: _this.state.accordionActive === -1,
        prefixClassName: "accordion-padding",
        renderHeader: function renderHeader(_ref) {
          var ExpandIcon = _ref.ExpandIcon;
          return /*#__PURE__*/React.createElement(AccordionHeader, {
            index: -1,
            ExpandIcon: ExpandIcon
          }, "Carousel Details");
        }
      }, /*#__PURE__*/React.createElement(File, {
        value: activeCarouselElement.thumbnail,
        onChange: function onChange(value) {
          _this._editTopLevelKey("thumbnail", value);
        },
        source: 0
      }), _this._renderCustomImageKey(activeCarouselElement), _this._renderHorizontalAlignedImage(activeCarouselElement), _this._renderVericalAlignedImage(activeCarouselElement), /*#__PURE__*/React.createElement(RichText, _extends$f({}, _this.props, {
        className: "input-margin",
        label: "Title",
        placeholder: "Type..",
        value: activeCarouselElement.title,
        autoFocus: _this.state.accordionActive === -1 && _this.state.activeTextElement === 0,
        onFocus: function onFocus(e) {
          return _this._handleTopLevelFocus(0, e);
        },
        onChange: function onChange(value) {
          _this._editTopLevelKey("title", value);
        },
        withHeader: true,
        isRephraseEnabled: false
      })), /*#__PURE__*/React.createElement(RichText, _extends$f({}, _this.props, {
        className: "input-margin",
        label: "Subtitle",
        placeholder: "Type..",
        value: activeCarouselElement.subtitle,
        autoFocus: _this.state.accordionActive === -1 && _this.state.activeTextElement === 2,
        onFocus: function onFocus(e) {
          return _this._handleTopLevelFocus(2, e);
        },
        onChange: function onChange(value) {
          _this._editTopLevelKey("subtitle", value);
        },
        withHeader: true,
        isRephraseEnabled: false
      })), /*#__PURE__*/React.createElement(RichText, _extends$f({}, _this.props, {
        className: "input-margin",
        label: "Description",
        placeholder: "Type..",
        value: activeCarouselElement.description,
        autoFocus: _this.state.accordionActive === -1 && _this.state.activeTextElement === 3,
        onFocus: function onFocus(e) {
          return _this._handleTopLevelFocus(3, e);
        },
        onChange: function onChange(value) {
          _this._editTopLevelKey("description", value);
        },
        multiline: true,
        withHeader: true,
        isRephraseEnabled: false
      })), /*#__PURE__*/React.createElement(RichText, _extends$f({}, _this.props, {
        className: "input-margin",
        label: "Metadata",
        placeholder: "Type..",
        value: activeCarouselElement.metadata,
        autoFocus: _this.state.accordionActive === -1 && _this.state.activeTextElement === 1,
        onFocus: function onFocus(e) {
          return _this._handleTopLevelFocus(1, e);
        },
        onChange: function onChange(value) {
          _this._editTopLevelKey("metadata", value);
        },
        withHeader: true,
        isRephraseEnabled: false
      })), /*#__PURE__*/React.createElement(Toggle, {
        value: activeCarouselElement.hasMiniActionable,
        onChange: function onChange(value) {
          return _this._editTopLevelKey("hasMiniActionable", value);
        },
        label: "Has Mini Actionable"
      }));
    });
    _defineProperty(_this, "_renderActionableFields", function () {
      var _this$state4 = _this.state,
        items = _this$state4.items,
        activeCarouselElementIndex = _this$state4.activeCarouselElementIndex;
      var activeCarouselElement = items[activeCarouselElementIndex];
      if (activeCarouselElement.hasMiniActionable) return null;
      return activeCarouselElement.actionables.map(function (actionable, i) {
        return /*#__PURE__*/React.createElement(Accordion.Item.Sortable, {
          itemIndex: i,
          index: i,
          key: i,
          onChange: _this._toggleActionable,
          active: _this.state.accordionActive === i,
          prefixClassName: "accordion-padding",
          renderHeader: function renderHeader(_ref2) {
            var ReorderIcon = _ref2.ReorderIcon,
              ExpandIcon = _ref2.ExpandIcon;
            return /*#__PURE__*/React.createElement(AccordionHeader, {
              index: i,
              onDelete: _this._deleteActionable,
              ReorderIcon: ReorderIcon,
              ExpandIcon: ExpandIcon
            }, actionable.text || actionable.title);
          }
        }, /*#__PURE__*/React.createElement(RichText, _extends$f({}, _this.props, {
          className: "input-margin",
          value: actionable.text,
          onChange: function onChange(value) {
            return _this._editActionable(i, "text", value);
          },
          placeholder: "Type here",
          label: "Button Text",
          onFocus: function onFocus() {
            return _this.state.accordionActive !== i && _this._toggleActionable(i);
          },
          autoFocus: _this.state.accordionActive === i,
          withHeader: true,
          isRephraseEnabled: false
        })), /*#__PURE__*/React.createElement(Dropdown, {
          value: actionable.type.text,
          onChange: function onChange(value) {
            _this._editActionable(i, "type", value);
          },
          placeholder: "Select Type",
          options: ACTIONABLE_OPTIONS,
          label: "Button Type",
          className: "input-margin"
        }), _this._renderAdditionalFields(actionable, actionable.type.additionalFields, i), _this._renderAdditionalFields(actionable, actionable.uri.additionalFields, i));
      });
    });
    _defineProperty(_this, "_renderMiniActionableFields", function () {
      var i = KEYS$1.MINI_ACTIONABLE_INDEX;
      var _this$state5 = _this.state,
        items = _this$state5.items,
        activeCarouselElementIndex = _this$state5.activeCarouselElementIndex;
      var activeCarouselElement = items[activeCarouselElementIndex];
      var miniActionable = _objectSpread2(_objectSpread2({}, _this.emptyMiniActionable), activeCarouselElement.actionables[i] || {});
      if (!activeCarouselElement.hasMiniActionable) return null;
      return /*#__PURE__*/React.createElement(Accordion.Item, {
        itemIndex: i,
        index: i,
        key: i,
        onChange: _this._toggleActionable,
        active: _this.state.accordionActive === i,
        prefixClassName: "accordion-padding",
        renderHeader: function renderHeader(_ref3) {
          var ExpandIcon = _ref3.ExpandIcon;
          return /*#__PURE__*/React.createElement(AccordionHeader, {
            index: -1,
            ExpandIcon: ExpandIcon
          }, "Mini Actionable");
        }
      }, /*#__PURE__*/React.createElement(RichText, _extends$f({}, _this.props, {
        className: "input-margin",
        value: miniActionable.text,
        onChange: function onChange(value) {
          return _this._editActionable(i, "text", value);
        },
        placeholder: "Type here",
        label: "Button Text",
        onFocus: function onFocus() {
          return _this.state.accordionActive !== i && _this._toggleActionable(i);
        },
        autoFocus: _this.state.accordionActive === i,
        withHeader: true,
        isRephraseEnabled: false
      })), /*#__PURE__*/React.createElement(Dropdown, {
        value: miniActionable.type.text,
        onChange: function onChange(value) {
          _this._editActionable(i, "type", value);
        },
        placeholder: "Select Type",
        options: ACTIONABLE_OPTIONS,
        label: "Button Type",
        className: "input-margin"
      }), _this._renderAdditionalFields(miniActionable, miniActionable.type.additionalFields, i), _this._renderAdditionalFields(miniActionable, miniActionable.uri.additionalFields, i));
    });
    _defineProperty(_this, "_renderCustomImageKey", function (activeCarouselElement) {
      var hasCustomImageKey = activeCarouselElement.hasCustomImageKey;
      if (hasCustomImageKey || !isValidURL(activeCarouselElement.thumbnail)) {
        return /*#__PURE__*/React.createElement(Text$1, {
          className: "input-margin",
          value: activeCarouselElement.thumbnail,
          onChange: function onChange(value) {
            _this._editTopLevelKey("thumbnail", value);
          },
          placeholder: "Type here",
          label: "Custom URL or Key"
        });
      }
      return /*#__PURE__*/React.createElement(AddButton, {
        nested: true,
        onClick: function onClick() {
          return _this._editTopLevelKey("hasCustomImageKey", true);
        }
      }, "Add a custom image key");
    });
    _defineProperty(_this, "_renderHorizontalAlignedImage", function (activeCarouselElement) {
      return /*#__PURE__*/React.createElement("div", {
        className: "input-margin"
      }, /*#__PURE__*/React.createElement(Radio, {
        label: "Horizontal Image Alignment",
        value: activeCarouselElement.horizontalAlignment || {
          title: "Center",
          value: "Center"
        },
        onChange: function onChange(value) {
          _this._editTopLevelKey("horizontalAlignment", value);
        },
        options: [{
          title: "Left",
          value: "Left"
        }, {
          title: "Center",
          value: "Center"
        }, {
          title: "Right",
          value: "Right"
        }],
        optionKey: "title"
      }));
    });
    _defineProperty(_this, "_renderVericalAlignedImage", function (activeCarouselElement) {
      return /*#__PURE__*/React.createElement("div", {
        className: "input-margin"
      }, /*#__PURE__*/React.createElement(Radio, {
        label: "Vertical Image Alignment",
        value: activeCarouselElement.verticalAlignment || {
          title: "Center",
          value: "Center"
        },
        onChange: function onChange(value) {
          _this._editTopLevelKey("verticalAlignment", value);
        },
        options: [{
          title: "Top",
          value: "Top"
        }, {
          title: "Center",
          value: "Center"
        }, {
          title: "Bottom",
          value: "Bottom"
        }],
        optionKey: "title"
      }));
    });
    _defineProperty(_this, "_renderAdditionalFields", function (actionable) {
      var additionalFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var actionableIndex = arguments.length > 2 ? arguments[2] : undefined;
      return renderAdditionalFields(actionable, additionalFields, actionableIndex, _this._editActionable, _this._toggleActionable, _this.state.accordionActive, undefined, _this.props.activateEmojiPicker);
    });
    _defineProperty(_this, "_getActionableSubtitle", function (actionable) {
      return getActionableSubtitle(actionable);
    });
    _defineProperty(_this, "_handleTopLevelFocus", function (activeTextElement, e) {
      e && e.stopPropagation();
      if (_this.state.accordionActive !== -1) {
        _this._toggleActionable(-1);
      }
      _this._setState({
        activeTextElement: activeTextElement
      });
    });
    _defineProperty(_this, "_openDrawer", function () {
      var carouselItemIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var clickIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -2;
      var activeTextElement = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;
      var _this$props$value2 = _this.props.value,
        value = _this$props$value2 === void 0 ? {} : _this$props$value2;
      if (value.supported_response === false) {
        return;
      }
      if (_this.props.readOnly) {
        _this._copy();
        return;
      }
      if (_this.props.isPopupElement) {
        _this.props.onReverseChange("accordionActive", clickIndex);
        _this.props.onReverseChange("activeTextElement", activeTextElement);
      } else {
        _this.setState({
          activeCarouselElementIndex: carouselItemIndex,
          accordionActive: clickIndex,
          activeTextElement: activeTextElement
        }, function () {
          _this.props.activateDrawer();
        });
      }
    });
    _defineProperty(_this, "_editBotSays", function (botSays) {
      _this._setState({
        botSays: botSays,
        changed: true
      });
    });
    _defineProperty(_this, "_addCarouselElement", function () {
      var newCarouselElement = _objectSpread2({}, _this.emptyCarouselItem);
      if (_this.state.items.length > 0) {
        newCarouselElement.actionables = _this.state.items[0].actionables.map(function (actionable) {
          return _objectSpread2({}, actionable);
        });
      }
      var items = _this.state.items.concat([newCarouselElement]);
      if (_this.props.isPopupElement) {
        var newIndex = items.length - 1;
        _this.props.onReverseChange("activeCarouselElementIndex", newIndex);
        _this.props.onReverseChange("items", items);
      }
    });
    _defineProperty(_this, "_deleteCarouselElement", function (index) {
      var items = _this.state.items.filter(function (_, i) {
        return i !== index;
      });
      if (_this.props.isPopupElement) {
        var newIndex = Math.max(index - 1, 0);
        _this.props.onReverseChange("activeCarouselElementIndex", newIndex);
        _this.props.onReverseChange("items", items, function () {
          _this.setState({
            activeCarouselElementIndex: newIndex
          });
        });
      }
    });
    _defineProperty(_this, "_reorderCarouselElement", function (index, offset) {
      var items = sort(_this.state.items, index, index + offset);
      if (_this.props.isPopupElement) {
        var newIndex = index + offset;
        _this.props.onReverseChange("activeCarouselElementIndex", newIndex);
        _this.props.onReverseChange("items", items, function () {
          _this.setState({
            activeCarouselElementIndex: newIndex
          });
        });
      }
    });
    _defineProperty(_this, "_activateCarouselElement", function (newIndex) {
      if (newIndex > _this.state.items.length - 1) return;
      _this.setState({
        activeCarouselElementIndex: newIndex
      });
      if (_this.props.isPopupElement) {
        _this.props.onReverseChange("activeCarouselElementIndex", newIndex);
      }
    });
    _defineProperty(_this, "_setState", function (state, cb) {
      _this.setState(state, function () {
        _this.props.onStateChange();
        if (cb) cb();
      });
    });
    _defineProperty(_this, "_editTopLevelKey", function (key, value) {
      var _this$state6 = _this.state,
        items = _this$state6.items,
        activeCarouselElementIndex = _this$state6.activeCarouselElementIndex;
      items[activeCarouselElementIndex][key] = value;
      _this._setState({
        items: items,
        changed: true
      });
    });
    _defineProperty(_this, "_sortActionable", function (_ref4) {
      var oldIndex = _ref4.oldIndex,
        newIndex = _ref4.newIndex;
      var _this$state7 = _this.state,
        items = _this$state7.items,
        activeCarouselElementIndex = _this$state7.activeCarouselElementIndex;
      var actionables = items[activeCarouselElementIndex].actionables;
      items[activeCarouselElementIndex].actionables = sort(actionables, oldIndex, newIndex);
      _this._setState({
        items: items,
        changed: true
      });
    });
    _defineProperty(_this, "_toggleActionable", function (index) {
      var accordionActive = toggle(_this.state.accordionActive, index);
      _this._setState({
        accordionActive: accordionActive
      });
    });
    _defineProperty(_this, "_deleteActionable", function (index, e) {
      if (e) e.stopPropagation();
      var _this$state8 = _this.state,
        items = _this$state8.items,
        activeCarouselElementIndex = _this$state8.activeCarouselElementIndex;
      var actionables = items[activeCarouselElementIndex].actionables;
      items[activeCarouselElementIndex].actionables = remove(actionables, index);
      _this._setState({
        items: items,
        changed: true
      });
    });
    _defineProperty(_this, "_addActionable", function (index, e) {
      if (e) e.stopPropagation();
      var _this$state9 = _this.state,
        items = _this$state9.items,
        activeCarouselElementIndex = _this$state9.activeCarouselElementIndex;
      var actionables = items[activeCarouselElementIndex].actionables;
      if (actionables.length + 1 > CONSTRAINTS.MAX_BUTTONS) {
        _this.props.activateToastMessage("You can't have more than ".concat(CONSTRAINTS.MAX_BUTTONS, " buttons"));
      } else {
        items[activeCarouselElementIndex].actionables = add(actionables, index, _this.emptyActionable);
        _this._setState({
          items: items,
          changed: true
        });
      }
    });
    _defineProperty(_this, "_editActionable", function (index, key, value) {
      var _this$state10 = _this.state,
        items = _this$state10.items,
        activeCarouselElementIndex = _this$state10.activeCarouselElementIndex;
      var actionables = items[activeCarouselElementIndex].actionables;
      items[activeCarouselElementIndex].actionables = edit(actionables, index, key, value);
      _this._setState({
        items: items,
        changed: true
      });
    });
    _defineProperty(_this, "_save", function (e) {
      var _this$state11;
      _this.setState({
        accordionActive: -3,
        activeTextElement: -1
      });
      _this.props.onSave(convertToHSL$2(_this.state), e);
      var hslElementAction = (_this$state11 = _this.state) !== null && _this$state11 !== void 0 && (_this$state11 = _this$state11._originalHSL) !== null && _this$state11 !== void 0 && _this$state11.isNew ? "Create" : "Edit";
      triggerMixPanelEvent(_this.state.type, hslElementAction);
    });
    _defineProperty(_this, "_copy", function () {
      _this.props.copyToClipboard(convertToHSL$2(_this.state));
    });
    _defineProperty(_this, "_showConfirmationDialog", function () {
      if (!_this.state.changed) {
        _this.props.deactivateDrawer();
      } else {
        _this.props.activateConfirmationDialog({
          themed: true
        }, function (isConfirmed) {
          if (isConfirmed) {
            _this.props.deactivateDrawer();
            _this.setState({
              changed: false
            });
          }
        });
      }
    });
    _this.state = _objectSpread2({}, _this.initialState);
    if (_props.state) _this.state = _props.state;else _this.reset(_props, true);
    return _this;
  }
  _inherits(Carousel, _React$Component);
  return _createClass(Carousel, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.state) this.setState(nextProps.state);
      if (!this.props.value && nextProps.value) this.reset(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/React.createElement("section", {
        className: styles$5.button
      }, /*#__PURE__*/React.createElement("div", {
        onClick: function onClick(e) {
          return _this2._openDrawer(0, e, -2);
        }
      }, this._renderCarousel()), this._renderDrawer());
    }
  }]);
}(React.Component)) || _class$1) || _class$1) || _class$1) || _class$1);
Carousel.propTypes = {
  activateConfirmationDialog: PropTypes.func,
  activateDrawer: PropTypes.func,
  activateEmojiPicker: PropTypes.func,
  activateToastMessage: PropTypes.func,
  copyToClipboard: PropTypes.func,
  deactivateDrawer: PropTypes.func,
  drawerActive: PropTypes.bool,
  entitySearchURL: PropTypes.string,
  isPopupElement: PropTypes.bool,
  onReverseChange: PropTypes.func,
  onSave: PropTypes.func,
  onStateChange: PropTypes.func,
  readOnly: PropTypes.bool,
  state: PropTypes.object,
  value: PropTypes.object,
  isRephraseEnabled: PropTypes.bool,
  baseUrl: PropTypes.string
};
Carousel.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "reset",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "nextProps",
      "type": null
    }, {
      "name": "shouldAssignStateDirectly",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderMessage",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderCarousel",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderActionables",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "actionables",
      "type": null
    }, {
      "name": "carouselIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderCarouselDetailFields",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderActionableFields",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderMiniActionableFields",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderCustomImageKey",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "activeCarouselElement",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderHorizontalAlignedImage",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "activeCarouselElement",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderVericalAlignedImage",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "activeCarouselElement",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderAdditionalFields",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "actionable",
      "type": null
    }, {
      "name": "additionalFields",
      "type": null
    }, {
      "name": "actionableIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_getActionableSubtitle",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "actionable",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleTopLevelFocus",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "activeTextElement",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_openDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "carouselItemIndex",
      "type": null
    }, {
      "name": "e",
      "type": null
    }, {
      "name": "clickIndex",
      "type": null
    }, {
      "name": "activeTextElement",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_editBotSays",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "botSays",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_addCarouselElement",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_deleteCarouselElement",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_reorderCarouselElement",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "offset",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_activateCarouselElement",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "newIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_setState",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "state",
      "type": null
    }, {
      "name": "cb",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_editTopLevelKey",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "key",
      "type": null
    }, {
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_sortActionable",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ oldIndex, newIndex }",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_toggleActionable",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_deleteActionable",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_addActionable",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_editActionable",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "key",
      "type": null
    }, {
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_save",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_copy",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_showConfirmationDialog",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Carousel",
  "props": {
    "activateConfirmationDialog": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activateDrawer": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activateEmojiPicker": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activateToastMessage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "copyToClipboard": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "deactivateDrawer": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "drawerActive": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "entitySearchURL": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "isPopupElement": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onReverseChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onSave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onStateChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "readOnly": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "state": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "isRephraseEnabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "baseUrl": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var convertFromHSL = function convertFromHSL(HSL) {
  HSL.data = HSL.data || {};
  var component = {
    botSays: HSL.text,
    type: HSL.builder_metadata_subtype ? HSL.builder_metadata_subtype : HSL.type,
    size: getSize(HSL.data.width),
    aspectRatio: getAspectRatio(HSL.data.image_aspect_ratio),
    activeImageElementIndex: 0,
    _originalHSL: HSL
  };
  component.items = convertFromCarouselItems(HSL);
  return component;
};
var convertToHSL = function convertToHSL(component) {
  var HSL = {
    text: component.botSays,
    type: "CAROUSEL",
    builder_metadata_subtype: component.type,
    data: {
      image_aspect_ratio: component.aspectRatio.value,
      width: component.size.value
    }
  };
  HSL.data.items = convertToCarouselItems(component);
  HSL = addLostKeys(HSL, component._originalHSL);
  return HSL;
};

var css_248z$7 = ".ImageElement_imageElementWrapper__1HJxf {\n  display: inline-block;\n  vertical-align: middle;\n  animation: ImageElement_slide-up__2PVit 0.5s ease-out;\n  animation-delay: 0.2s;\n  animation-fill-mode: both;\n  opacity: 0; }\n\n@keyframes ImageElement_slide-up__2PVit {\n  0% {\n    opacity: 0;\n    transform: translateY(10px); }\n  100% {\n    opacity: 1;\n    transform: translateY(0px); } }\n\n.ImageElement_imageWrapper__2zbrg {\n  width: 300px;\n  min-width: 300px;\n  border-radius: 24px;\n  overflow: hidden;\n  transform: scale3d(1, 1, 1);\n  transition: 0.5s cubic-bezier(0.175, 0.5, 0.12, 1); }\n\n.ImageElement_imageImage__2QEP8,\n.ImageElement_imageImagePlaceholder__pZxRo {\n  width: 216px;\n  min-height: 140px;\n  height: 140px;\n  object-fit: cover;\n  border-radius: 24px;\n  border: 1px solid #ddd;\n  background-color: #fff;\n  box-sizing: border-box; }\n\n.ImageElement_imageImagePlaceholder__pZxRo {\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n\n.ImageElement_imagePlaceholderIcon__1UvBe {\n  width: 52px;\n  height: 52px; }\n";
var styles$6 = {"imageElementWrapper":"ImageElement_imageElementWrapper__1HJxf","slide-up":"ImageElement_slide-up__2PVit","imageWrapper":"ImageElement_imageWrapper__2zbrg","imageImage":"ImageElement_imageImage__2QEP8","imageImagePlaceholder":"ImageElement_imageImagePlaceholder__pZxRo","imagePlaceholderIcon":"ImageElement_imagePlaceholderIcon__1UvBe"};
styleInject(css_248z$7);

var ImageElement = function ImageElement(_ref) {
  var thumbnail = _ref.thumbnail,
    _onClick = _ref.onClick,
    index = _ref.index,
    aspectRatio = _ref.aspectRatio,
    errorClass = _ref.errorClass,
    isPopupElement = _ref.isPopupElement;
  var width = BASE.IMAGE_WIDTH;
  var height = width / aspectRatio.value;
  var videoCheck = thumbnail && isVideo(thumbnail);
  return /*#__PURE__*/React.createElement("div", {
    className: styles$6.imageElementWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$6.imageWrapper, " ").concat(errorClass),
    onClick: function onClick(e) {
      _onClick(index, e);
      e.preventDefault();
      e.stopPropagation();
    }
  }, thumbnail && videoCheck.isYoutubeVideo && /*#__PURE__*/React.createElement("iframe", {
    title: "youtube_video",
    allowFullScreen: "allowfullscreen",
    mozAllowFullScreen: "mozallowfullscreen",
    msAllowFullScreen: "msallowfullscreen",
    oAllowFullScreen: "oallowfullscreen",
    webkitAllowFullScreen: "webkitallowfullscreen",
    frameBorder: "0",
    src: thumbnail,
    width: "216",
    height: "140",
    style: {
      pointerEvents: isPopupElement ? "all" : "none",
      borderRadius: "24px"
    }
  }), thumbnail && videoCheck.isVideo && /*#__PURE__*/React.createElement("video", {
    className: styles$6.imageImage,
    controls: true
  }, /*#__PURE__*/React.createElement("source", {
    src: thumbnail,
    type: "video/mp4"
  })), thumbnail && !videoCheck.isVideo && !videoCheck.isYoutubeVideo && /*#__PURE__*/React.createElement("img", {
    src: thumbnail,
    className: styles$6.imageImage
  }), !thumbnail && /*#__PURE__*/React.createElement("div", {
    className: styles$6.imageImagePlaceholder
  }, /*#__PURE__*/React.createElement(Icon, {
    className: styles$6.imagePlaceholderIcon,
    src: PlaceholderIcon
  }))));
};
ImageElement.propTypes = {
  index: PropTypes.number,
  onClick: PropTypes.func,
  thumbnail: PropTypes.string,
  aspectRatio: PropTypes.object,
  errorClass: PropTypes.string,
  isPopupElement: PropTypes.bool
};
ImageElement.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ImageElement",
  "props": {
    "index": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "thumbnail": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "aspectRatio": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "errorClass": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "isPopupElement": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$8 = ".Image_textMessage__3lxeA {\n  width: 300px;\n  max-width: 300px;\n  background-color: #fff;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.02);\n  border-radius: 24px;\n  overflow: hidden;\n  border: 1px solid #ddd;\n  border-top-left-radius: 4px;\n  padding: 12px;\n  font-size: 14px;\n  border-top-right-radius: 24px;\n  box-sizing: border-box;\n  background-color: #f5f5f5;\n  line-height: 1.4;\n  margin-bottom: 12px; }\n  .Image_textMessage__3lxeA.small {\n    padding: 8px;\n    border-radius: 16px;\n    border-top-left-radius: 4px; }\n\n.Image_textMessageText__34V3G {\n  font-size: inherit;\n  color: inherit;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  padding: 0;\n  outline: none;\n  resize: none;\n  border: none;\n  pointer-events: none;\n  width: 100%;\n  overflow: hidden; }\n\n.Image_textMessageTextPlaceholder__XMNuY {\n  opacity: 0.3; }\n\n.Image_carouselHeaderDropdowns__3-e7- {\n  display: flex;\n  padding: 0 12px; }\n  .Image_carouselHeaderDropdowns__3-e7- > div {\n    flex: 1.4; }\n    .Image_carouselHeaderDropdowns__3-e7- > div:first-child {\n      flex: 1;\n      margin-right: 8px; }\n\n.Image_centerAlign__2dN9Z {\n  text-align: center; }\n\n.Image_carouselElements__2_j3E {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  max-width: 600px;\n  overflow: hidden; }\n  .Image_carouselElementsError__3txrl {\n    border: 1px solid #ef8b93; }\n\n.Image_carouselElementsArrow__1qkF_ {\n  width: 46px !important;\n  height: 46px !important;\n  z-index: 3;\n  left: auto !important;\n  right: -5px !important;\n  transition: 0.2s ease-out;\n  filter: drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.1)); }\n  .Image_carouselElementsArrow__1qkF_ svg > g {\n    fill: #fff; }\n  .Image_carouselElementsArrow__1qkF_:before {\n    content: none !important; }\n\n.Image_carouselElementsArrowPrev__3NUOs {\n  left: -5px !important;\n  right: auto !important;\n  transform: rotate(180deg) translateY(50%) !important; }\n";
var styles$7 = {"textMessage":"Image_textMessage__3lxeA","textMessageText":"Image_textMessageText__34V3G","textMessageTextPlaceholder":"Image_textMessageTextPlaceholder__XMNuY","carouselHeaderDropdowns":"Image_carouselHeaderDropdowns__3-e7-","centerAlign":"Image_centerAlign__2dN9Z","carouselElements":"Image_carouselElements__2_j3E","carouselElementsError":"Image_carouselElementsError__3txrl","carouselElementsArrow":"Image_carouselElementsArrow__1qkF_","carouselElementsArrowPrev":"Image_carouselElementsArrowPrev__3NUOs"};
styleInject(css_248z$8);

var _dec$2, _dec2$2, _dec3$2, _dec4$2, _class$2;
var ImageHSL = (_dec$2 = EmojiPicker(), _dec2$2 = ToastMessage(), _dec3$2 = ConfirmationDialog(), _dec4$2 = HSLWrapper(), _dec$2(_class$2 = _dec2$2(_class$2 = _dec3$2(_class$2 = _dec4$2(_class$2 = /*#__PURE__*/function (_React$Component) {
  function ImageHSL(_props) {
    var _this;
    _classCallCheck(this, ImageHSL);
    _this = _callSuper(this, ImageHSL, [_props]);
    _defineProperty(_this, "emptyImageItem", {
      thumbnail: "",
      title: "",
      actionables: []
    });
    _defineProperty(_this, "initialState", {
      type: "IMAGE",
      items: [_objectSpread2({}, _this.emptyImageItem)],
      size: {},
      aspectRatio: {},
      activeImageElementIndex: 0
    });
    _defineProperty(_this, "reset", function (nextProps, shouldAssignStateDirectly) {
      var props = nextProps || _this.props || {};
      var value = props.value ? convertFromHSL(props.value) : _objectSpread2({}, _this.initialState);
      if (value.items.length === 0) {
        value.items = value.items.concat([_objectSpread2({}, _this.emptyCarouselItem)]);
      }
      if (shouldAssignStateDirectly) {
        _this.state = value;
        _this.props.onStateChange();
      } else {
        _this._setState(value);
      }
    });
    _defineProperty(_this, "_renderMessage", function () {
      var placeholderClass = (_this.state.botSays || "").length === 0 ? styles$7.textMessageTextPlaceholder : "";
      var placeholderText = _this.props.readOnly ? "No Text" : "Tap to add";
      return /*#__PURE__*/React.createElement("div", {
        className: styles$7.textMessage,
        onClick: function onClick(e) {
          return _this._openDrawer(0, e);
        }
      }, /*#__PURE__*/React.createElement(Textarea, {
        className: "".concat(styles$7.textMessageText, " ").concat(placeholderClass),
        value: _this.state.botSays || placeholderText,
        disabled: true
      }, _this.state.botSays));
    });
    _defineProperty(_this, "_renderImage", function () {
      var _this$props$value = _this.props.value,
        value = _this$props$value === void 0 ? {} : _this$props$value;
      var errorClass = "";
      if (value.supported_response !== undefined) {
        errorClass = value.supported_response === false ? styles$7.carouselElementsError : "";
      }
      return /*#__PURE__*/React.createElement("div", {
        className: styles$7.carouselElements
      }, _this.state.items.map(function (item, i) {
        return /*#__PURE__*/React.createElement(ImageElement, _extends$f({
          lessMarginRight: !_this.props.isPopupElement,
          numElements: _this.state.items.length,
          onClick: _this._openDrawer,
          index: i,
          key: i,
          isPopupElement: _this.props.isPopupElement,
          aspectRatio: _this.state.aspectRatio,
          errorClass: errorClass
        }, item));
      }));
    });
    _defineProperty(_this, "_renderDrawer", function () {
      if (_this.props.isPopupElement) return null;
      var _this$state = _this.state,
        items = _this$state.items,
        activeImageElementIndex = _this$state.activeImageElementIndex;
      var activeImageElement = items[activeImageElementIndex];
      return /*#__PURE__*/React.createElement(Drawer, {
        zIndex: 10001,
        placement: "RIGHT",
        active: _this.props.drawerActive,
        onClose: _this._save,
        width: 400
      }, /*#__PURE__*/React.createElement(Drawer.Header, {
        onDone: _this._save,
        onCopy: _this._copy
      }, _this.state.type === "VIDEO" ? "Edit Video" : "Edit Image"), /*#__PURE__*/React.createElement("div", {
        className: "drawer-body-overflow"
      }, _this.state.type !== "VIDEO" ? /*#__PURE__*/React.createElement("div", {
        style: {
          paddingTop: 16
        },
        className: "".concat(styles$7.carouselHeaderDropdowns)
      }, /*#__PURE__*/React.createElement(Dropdown, {
        placeholder: "Select Size",
        value: _this.state.size.text,
        onChange: function onChange(size) {
          _this._setState({
            size: size
          });
        },
        options: CAROUSEL_SIZE_OPTIONS
      }), /*#__PURE__*/React.createElement(Dropdown, {
        placeholder: "Select Aspect Ratio",
        value: _this.state.aspectRatio.text,
        onChange: function onChange(aspectRatio) {
          _this._setState({
            aspectRatio: aspectRatio
          });
        },
        options: CAROUSEL_RATIO_OPTIONS
      })) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: "0 16px"
        }
      }, _this.state.aspectRatio.text === "Custom" ? /*#__PURE__*/React.createElement(Text$1, {
        className: "input-margin",
        label: "Custom Aspect Ratio",
        placeholder: "Eg. 1.68",
        value: _this.state.aspectRatio.value,
        onChange: function onChange(aspectRatio) {
          _this._setState({
            aspectRatio: {
              text: "Custom",
              value: aspectRatio
            }
          });
        }
      }) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          padding: "0 16px",
          marginTop: "16px"
        }
      }, /*#__PURE__*/React.createElement(RichText, _extends$f({}, _this.props, {
        className: "input-margin",
        value: _this.state.botSays,
        onChange: _this._editBotSays,
        placeholder: "Type here",
        label: "Notification Text",
        multiline: true,
        hasCounter: true,
        withHeader: true
      })), /*#__PURE__*/React.createElement(File, {
        className: "input-margin",
        value: activeImageElement.thumbnail,
        onChange: function onChange(value) {
          _this._editTopLevelKey("thumbnail", value);
        },
        type: _this.state.type.toLowerCase(),
        source: 0
      }), _this.state.type === "VIDEO" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: styles$7.centerAlign
      }, "or"), /*#__PURE__*/React.createElement(Text$1, {
        className: "input-margin",
        label: "Video URL",
        placeholder: "Enter Youtube embedded video URL here",
        value: activeImageElement.thumbnail,
        onChange: function onChange(value) {
          _this._editTopLevelKey("thumbnail", value);
        }
      })) : null)));
    });
    _defineProperty(_this, "_openDrawer", function (carouselItemIndex, e) {
      if (_this.props.readOnly) {
        _this._copy();
        return;
      }
      _this.props.activateDrawer(e);
      _this.setState({
        activeImageElementIndex: carouselItemIndex
      });
    });
    _defineProperty(_this, "_setState", function (state, cb) {
      _this.setState(state, function () {
        _this.props.onStateChange();
        if (cb) cb();
      });
    });
    _defineProperty(_this, "_editBotSays", function (botSays) {
      _this._setState({
        botSays: botSays,
        changed: true
      });
    });
    _defineProperty(_this, "_editTopLevelKey", function (key, value) {
      var _this$state2 = _this.state,
        items = _this$state2.items,
        activeImageElementIndex = _this$state2.activeImageElementIndex;
      items[activeImageElementIndex][key] = value;
      _this._setState({
        items: items,
        changed: true
      });
    });
    _defineProperty(_this, "_save", function (e) {
      var _this$state3;
      _this.props.onSave(convertToHSL(_this.state), e);
      var hslElementAction = (_this$state3 = _this.state) !== null && _this$state3 !== void 0 && (_this$state3 = _this$state3._originalHSL) !== null && _this$state3 !== void 0 && _this$state3.isNew ? "Create" : "Edit";
      triggerMixPanelEvent(_this.state.type, hslElementAction);
    });
    _defineProperty(_this, "_copy", function () {
      _this.props.copyToClipboard(convertToHSL(_this.state));
    });
    _defineProperty(_this, "_showConfirmationDialog", function () {
      if (!_this.state.changed) {
        _this.props.deactivateDrawer();
      } else {
        _this.props.activateConfirmationDialog({
          themed: true
        }, function (isConfirmed) {
          if (isConfirmed) {
            _this.props.deactivateDrawer();
            _this.setState({
              changed: false
            });
          }
        });
      }
    });
    _this.state = _objectSpread2({}, _this.initialState);
    if (_props.state) _this.state = _props.state;else _this.reset(_props, true);
    return _this;
  }
  _inherits(ImageHSL, _React$Component);
  return _createClass(ImageHSL, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.state) this.setState(nextProps.state);
      if (!this.props.value && nextProps.value) this.reset(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("section", {
        className: styles$7.button
      }, this._renderImage(), this._renderDrawer());
    }
  }]);
}(React.Component)) || _class$2) || _class$2) || _class$2) || _class$2);
ImageHSL.propTypes = {
  activateConfirmationDialog: PropTypes.func,
  activateDrawer: PropTypes.func,
  activateEmojiPicker: PropTypes.func,
  activateToastMessage: PropTypes.func,
  copyToClipboard: PropTypes.func,
  deactivateDrawer: PropTypes.func,
  drawerActive: PropTypes.bool,
  entitySearchURL: PropTypes.string,
  isPopupElement: PropTypes.bool,
  onReverseChange: PropTypes.func,
  onSave: PropTypes.func,
  onStateChange: PropTypes.func,
  readOnly: PropTypes.bool,
  state: PropTypes.object,
  value: PropTypes.object,
  isRephraseEnabled: PropTypes.bool,
  baseUrl: PropTypes.string
};
ImageHSL.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "reset",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "nextProps",
      "type": null
    }, {
      "name": "shouldAssignStateDirectly",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderMessage",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderImage",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_openDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "carouselItemIndex",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_setState",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "state",
      "type": null
    }, {
      "name": "cb",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_editBotSays",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "botSays",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_editTopLevelKey",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "key",
      "type": null
    }, {
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_save",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_copy",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_showConfirmationDialog",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "ImageHSL",
  "props": {
    "activateConfirmationDialog": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activateDrawer": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activateEmojiPicker": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activateToastMessage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "copyToClipboard": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "deactivateDrawer": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "drawerActive": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "entitySearchURL": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "isPopupElement": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onReverseChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onSave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onStateChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "readOnly": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "state": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "isRephraseEnabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "baseUrl": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$9 = ".RawText_textMessage__POtOi {\n  width: 300px;\n  max-width: 300px;\n  background-color: #fff;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.02);\n  border-radius: 24px;\n  overflow: hidden;\n  border: 1px solid #ddd;\n  border-top-left-radius: 4px;\n  padding: 12px;\n  font-size: 14px;\n  border-top-right-radius: 24px;\n  box-sizing: border-box;\n  background-color: #f5f5f5;\n  line-height: 1.4;\n  width: 300px;\n  cursor: pointer; }\n  .RawText_textMessage__POtOi.small {\n    padding: 8px;\n    border-radius: 16px;\n    border-top-left-radius: 4px; }\n  .RawText_textMessage__POtOi:hover .RawText_textMessageMeta__19roz {\n    opacity: 0.5;\n    height: 14px;\n    margin-top: 6px; }\n\n.RawText_textMessageText__2wEbk {\n  font-size: inherit;\n  color: inherit;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  padding: 0;\n  outline: none;\n  resize: none;\n  border: none;\n  pointer-events: none;\n  width: 100%;\n  overflow: hidden;\n  font-family: Consolas, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New !important; }\n  .RawText_textMessageText__2wEbk.no-raw {\n    font-family: inherit !important; }\n\n.RawText_textMessageMeta__19roz {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 12px;\n  margin-top: 0px;\n  font-weight: 600;\n  height: 0;\n  opacity: 0;\n  transition: 0.1s ease-out; }\n\n.RawText_textMessageTextPlaceholder__3TE_A {\n  opacity: 0.3; }\n\n.RawText_quickReplies__1MIBd {\n  display: flex;\n  align-items: center;\n  margin-top: 24px; }\n";
var styles$8 = {"textMessage":"RawText_textMessage__POtOi","textMessageMeta":"RawText_textMessageMeta__19roz","textMessageText":"RawText_textMessageText__2wEbk","textMessageTextPlaceholder":"RawText_textMessageTextPlaceholder__3TE_A","quickReplies":"RawText_quickReplies__1MIBd"};
styleInject(css_248z$9);

var _dec$3, _dec2$3, _dec3$3, _class$3;
var RawText = (_dec$3 = ToastMessage(), _dec2$3 = ConfirmationDialog(), _dec3$3 = HSLWrapper(), _dec$3(_class$3 = _dec2$3(_class$3 = _dec3$3(_class$3 = /*#__PURE__*/function (_React$Component) {
  function RawText(_props) {
    var _this;
    _classCallCheck(this, RawText);
    _this = _callSuper(this, RawText, [_props]);
    _defineProperty(_this, "reset", function (nextProps, shouldAssignStateDirectly) {
      var props = nextProps || _this.props || {};
      var value = props.value || "";
      try {
        var jsonValue = JSON.parse(value);
        if (jsonValue.type === "RAW") {
          value = "";
        }
      } catch (e) {
        console.debug("Not JSON, continuing");
      }
      if (shouldAssignStateDirectly) {
        _this.state = {
          botSays: value
        };
        _this.props.onStateChange();
      } else {
        _this.setState({
          botSays: value
        });
      }
    });
    _defineProperty(_this, "_renderMessage", function () {
      var placeholderClass = (_this.state.botSays || "").length === 0 ? styles$8.textMessageTextPlaceholder : "";
      var placeholderText = _this.props.readOnly ? "No Text" : "Tap to add";
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$8.textMessage, " ").concat(_this.props.mode)
      }, /*#__PURE__*/React.createElement(Textarea, {
        className: "".concat(styles$8.textMessageText, " ").concat(placeholderClass, " ").concat(_this.props.mode),
        value: _this.state.botSays || placeholderText,
        disabled: true
      }, _this.state.botSays), _this.props.date ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$8.textMessageMeta)
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$8.textMessageDate)
      }, _this.props.date), /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$8.textMessageUser)
      }, _this.props.user)) : null);
    });
    _defineProperty(_this, "_renderDrawer", function () {
      if (_this.props.state) return null;
      return /*#__PURE__*/React.createElement(Drawer, {
        zIndex: 10001,
        placement: "RIGHT",
        active: _this.props.drawerActive,
        onClose: _this._save,
        width: 400
      }, /*#__PURE__*/React.createElement(Drawer.Header, {
        onDone: _this._save
      }, "Edit Raw HSL"), /*#__PURE__*/React.createElement("div", {
        style: {
          padding: "16px"
        },
        className: "drawer-body-overflow"
      }, /*#__PURE__*/React.createElement(RichText, _extends$f({}, _this.props, {
        value: _this.state.botSays,
        onChange: _this._editBotSays,
        placeholder: "Type here",
        label: "Bot Responses",
        multiline: true,
        autoFocus: true,
        disableMaxLineValidation: true,
        withHeader: true
      }))));
    });
    _defineProperty(_this, "_openDrawer", function () {
      if (_this.props.readOnly) {
        _this._copy();
        return;
      }
      _this.props.activateDrawer();
    });
    _defineProperty(_this, "_setState", function (state) {
      _this.setState(state, _this.props.onStateChange);
    });
    _defineProperty(_this, "_editBotSays", function (botSays) {
      _this._setState({
        botSays: botSays,
        changed: true
      });
    });
    _defineProperty(_this, "_save", function (e) {
      var _this$props;
      _this.props.onSave(_this.state.botSays, e);
      var hslElementAction = (_this$props = _this.props) !== null && _this$props !== void 0 && _this$props.isNew ? "Create" : "Edit";
      triggerMixPanelEvent("Raw Text", hslElementAction);
    });
    _defineProperty(_this, "_copy", function () {
      _this.props.copyToClipboard(_this.state.botSays);
    });
    _defineProperty(_this, "_showConfirmationDialog", function (e) {
      if (!_this.state.changed) {
        _this.props.deactivateDrawer(e);
      } else {
        _this.props.activateConfirmationDialog({
          themed: true
        }, function (isConfirmed) {
          if (isConfirmed) {
            _this.props.deactivateDrawer(e);
            _this.setState({
              changed: false
            });
          }
        });
      }
    });
    _this.state = {
      botSays: ""
    };
    if (_props.state) _this.state = _props.state;else _this.reset(_props, true);
    return _this;
  }

  // eslint-disable-next-line react/no-deprecated
  _inherits(RawText, _React$Component);
  return _createClass(RawText, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.state) this.setState(nextProps.state);
      if (!this.props.value && nextProps.value || this.props.value !== nextProps.value) this.reset(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: styles$8.text,
        onClick: this._openDrawer
      }, this._renderMessage(), this._renderDrawer());
    }
  }]);
}(React.Component)) || _class$3) || _class$3) || _class$3);
RawText.propTypes = {
  activateConfirmationDialog: PropTypes.func,
  activateDrawer: PropTypes.func,
  copyToClipboard: PropTypes.func,
  date: PropTypes.string,
  deactivateDrawer: PropTypes.func,
  drawerActive: PropTypes.bool,
  entitySearchURL: PropTypes.string,
  mode: PropTypes.string,
  onSave: PropTypes.func,
  onStateChange: PropTypes.func,
  readOnly: PropTypes.bool,
  state: PropTypes.object,
  user: PropTypes.string,
  value: PropTypes.string,
  isRephraseEnabled: PropTypes.bool,
  baseUrl: PropTypes.string
};
RawText.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "reset",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "nextProps",
      "type": null
    }, {
      "name": "shouldAssignStateDirectly",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderMessage",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_openDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_setState",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "state",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_editBotSays",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "botSays",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_save",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_copy",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_showConfirmationDialog",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "RawText",
  "props": {
    "activateConfirmationDialog": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activateDrawer": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "copyToClipboard": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "date": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "deactivateDrawer": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "drawerActive": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "entitySearchURL": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "mode": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onSave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onStateChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "readOnly": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "state": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "user": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "isRephraseEnabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "baseUrl": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$a = ".VariantSettings_variantSettings__1RwyC {\n  background-color: #fff;\n  box-sizing: border-box;\n  border-radius: 8px;\n  overflow: hidden;\n  max-width: 300px;\n  padding-top: 12px;\n  display: flex;\n  flex-direction: column; }\n\n.VariantSettings_variantSettingsLabel__RxR0J {\n  font-size: 14px;\n  color: #333;\n  font-weight: 600;\n  margin-bottom: 4px;\n  padding: 0 12px; }\n\n.VariantSettings_variantSettingsHint__2SYLX {\n  font-size: 12px;\n  color: #aaa;\n  font-weight: 300;\n  margin-bottom: 4px;\n  line-height: 1.4;\n  padding: 0 12px; }\n\n.VariantSettings_variantSettingsInput__2r30e {\n  margin-bottom: 16px;\n  padding: 0 12px; }\n\n.VariantSettings_variantSettingsErrors__342Q6 {\n  margin-top: 4px;\n  overflow-y: auto;\n  flex: 1;\n  max-height: 100px;\n  border-top: 1px solid #eee;\n  border-bottom: 1px solid #eee; }\n\n.VariantSettings_variantSettingsError__14ufZ {\n  padding: 8px 12px;\n  background-color: #fff9dd;\n  border-bottom: 1px solid #eee; }\n  .VariantSettings_variantSettingsError__14ufZ .VariantSettings_variantSettingsErrorTitle__2n8kx {\n    font-size: 12px;\n    color: #333;\n    margin-bottom: 2px; }\n  .VariantSettings_variantSettingsError__14ufZ .VariantSettings_variantSettingsErrorDescription__1J-zJ {\n    font-size: 10px;\n    color: #888;\n    font-weight: 300;\n    line-height: 1.4; }\n";
var styles$9 = {"variantSettings":"VariantSettings_variantSettings__1RwyC","variantSettingsLabel":"VariantSettings_variantSettingsLabel__RxR0J","variantSettingsHint":"VariantSettings_variantSettingsHint__2SYLX","variantSettingsInput":"VariantSettings_variantSettingsInput__2r30e","variantSettingsErrors":"VariantSettings_variantSettingsErrors__342Q6","variantSettingsError":"VariantSettings_variantSettingsError__14ufZ","variantSettingsErrorTitle":"VariantSettings_variantSettingsErrorTitle__2n8kx","variantSettingsErrorDescription":"VariantSettings_variantSettingsErrorDescription__1J-zJ"};
styleInject(css_248z$a);

// eslint-disable-next-line react/prop-types
var Label = function Label(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$9.variantSettingsLabel
  }, children);
};

// eslint-disable-next-line react/prop-types
var Hint = function Hint(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$9.variantSettingsHint
  }, children);
};
var Error$1 = function Error(_ref3) {
  var _ref3$platform = _ref3.platform,
    platform = _ref3$platform === void 0 ? "Whatsapp" : _ref3$platform,
    _ref3$error = _ref3.error,
    error = _ref3$error === void 0 ? "Quick Replies not supported" : _ref3$error,
    _ref3$description = _ref3.description,
    description = _ref3$description === void 0 ? "WhatsApp doesn’t have quick replies, try asking a question instead?" : _ref3$description;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$9.variantSettingsError
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$9.variantSettingsErrorTitle
  }, /*#__PURE__*/React.createElement("strong", null, platform, ": "), error), /*#__PURE__*/React.createElement("div", {
    className: styles$9.variantSettingsErrorDescription
  }, description));
};
Error$1.propTypes = {
  description: PropTypes.string,
  error: PropTypes.string,
  platform: PropTypes.string
};
function VariantSettings(_ref4) {
  var _ref4$errors = _ref4.errors,
    errors = _ref4$errors === void 0 ? [] : _ref4$errors,
    _onChange = _ref4.onChange,
    _ref4$supportedPlatfo = _ref4.supportedPlatforms,
    supportedPlatforms = _ref4$supportedPlatfo === void 0 ? [] : _ref4$supportedPlatfo,
    _ref4$allPlatforms = _ref4.allPlatforms,
    allPlatforms = _ref4$allPlatforms === void 0 ? [] : _ref4$allPlatforms;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$9.variantSettings
  }, /*#__PURE__*/React.createElement(Label, null, "Supported Platforms"), /*#__PURE__*/React.createElement(Hint, null, "The variant will only be shown on these platforms"), /*#__PURE__*/React.createElement(Dropdown, {
    withMultiple: true,
    withSearch: true,
    placeholder: "Select Platforms...",
    className: styles$9.variantSettingsInput,
    value: supportedPlatforms,
    options: allPlatforms,
    optionKey: "title",
    searchKeys: ["title"],
    onChange: function onChange(val) {
      // if new value is not all, remove instances of all
      // else if new value is all, then remove all other instances
      val = val.filter(function (value) {
        return val[val.length - 1].title !== "All" ? value.title !== "All" : value.title === "All";
      });
      _onChange(val);
    }
  }), errors.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, null, "Compatibility Errors (", errors.length, ")"), /*#__PURE__*/React.createElement(Hint, null, errors.length ? "Some platforms dont support certain elements" : "Everything looks great! This chat element is supported by all the platforms selected above."), /*#__PURE__*/React.createElement("div", {
    className: styles$9.variantSettingsErrors
  }, errors.map(function (error, i) {
    return /*#__PURE__*/React.createElement(Error$1, {
      key: i,
      platform: error.platform,
      error: error.title,
      description: error.description
    });
  }))) : null);
}
VariantSettings.propTypes = {
  allPlatforms: PropTypes.array,
  errors: PropTypes.array,
  onChange: PropTypes.func,
  supportedPlatforms: PropTypes.array
};
VariantSettings.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "VariantSettings",
  "props": {
    "errors": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "supportedPlatforms": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "allPlatforms": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

var _dec$4, _class$4;
var _excluded = ["type"];
var HSL = function HSL(_ref) {
  var type = _ref.type,
    props = _objectWithoutProperties(_ref, _excluded);
  switch (type) {
    case "BUTTON":
      return /*#__PURE__*/React.createElement(Button, props);
    case "TEXT":
      return /*#__PURE__*/React.createElement(Text$2, props);
    case "FORM":
      return /*#__PURE__*/React.createElement(HSLForms, props);
    case "CAROUSEL":
      var subType = "value" in props ? props.value.builder_metadata_subtype : props.builder_metadata_subtype;
      if (subType === "IMAGE" || subType === "VIDEO") {
        return /*#__PURE__*/React.createElement(ImageHSL, props);
      }
      return /*#__PURE__*/React.createElement(Carousel, props);
    case "IMAGE":
    case "VIDEO":
      return /*#__PURE__*/React.createElement(ImageHSL, props);
    case "WHATSAPP_INTERACTIVE_BUTTON":
      return /*#__PURE__*/React.createElement(ReplyButton, props);
    case "WHATSAPP_INTERACTIVE_LIST":
      return /*#__PURE__*/React.createElement(List, props);
    case "WHATSAPP_INTERACTIVE_PRODUCT_LIST":
      return /*#__PURE__*/React.createElement(WhatsAppPLM, props);
    case "WHATSAPP_INTERACTIVE_SINGLE_PRODUCT":
      return /*#__PURE__*/React.createElement(SingleProductMessage, props);
    default:
      return /*#__PURE__*/React.createElement(RawText, props);
  }
};
HSL.propTypes = {
  type: PropTypes.string,
  builder_metadata_subtype: PropTypes.string
};
var HSLInput = (_dec$4 = ConfirmationDialog(), _dec$4(_class$4 = /*#__PURE__*/function (_React$Component) {
  function HSLInput(props) {
    var _this;
    _classCallCheck(this, HSLInput);
    _this = _callSuper(this, HSLInput, [props]);
    _defineProperty(_this, "renderVariant", function (_ref2) {
      var value = _ref2.value;
      return function (HSLString, i) {
        var disabled = _this.props.disabled;
        var disabledClassName = disabled ? styles$a.disabled : "";
        var VariantReplies = _this.renderVariantReplies;
        return /*#__PURE__*/React.createElement("div", {
          key: i,
          className: "".concat(styles$a.inputWrapper)
        }, _this.renderVariantLabel({
          i: i
        }), /*#__PURE__*/React.createElement("div", {
          className: "".concat(styles$a.textInputWrapper, " ").concat(disabledClassName)
        }, /*#__PURE__*/React.createElement(VariantReplies, {
          HSLString: HSLString,
          value: value,
          variantIndex: i,
          lockAxis: "y",
          useDragHandle: true,
          lockToContainerEdges: true,
          updateBeforeSortStart: function updateBeforeSortStart(_ref3) {
            var index = _ref3.index;
            return new Promise(function (resolve) {
              return _this.setState({
                sortingIndex: index
              }, resolve);
            });
          },
          onSortEnd: function onSortEnd(_ref4) {
            var oldIndex = _ref4.oldIndex,
              newIndex = _ref4.newIndex;
            _this.setState({
              sortingIndex: -1
            });
            var items = HSLString.split("<m>");
            var reorderedItems = arrayMove(items, oldIndex, newIndex);
            _this._handleChange(reorderedItems.join("<m>"), null, i);
          }
        }), _this.renderAddReply({
          HSLString: HSLString,
          i: i
        })), _this.renderSettingsPopup({
          i: i
        }));
      };
    });
    _defineProperty(_this, "renderVariantReplies", sortableContainer(function (_ref5) {
      var HSLString = _ref5.HSLString,
        value = _ref5.value,
        variantIndex = _ref5.variantIndex;
      var VariantReply = _this.renderVariantReply;
      if (typeof HSLString === "undefined" || HSLString === null || typeof HSLString !== "string") {
        return null;
      }
      var addHSLAutoOpen = function addHSLAutoOpen(i) {
        return i === HSLString.split("<m>").length - 1 && variantIndex === value.length - 1;
      };
      return /*#__PURE__*/React.createElement("div", null, HSLString.split("<m>").map(function (HSLElementString, i) {
        return /*#__PURE__*/React.createElement(VariantReply, {
          i: i,
          key: "item-".concat(i),
          index: i,
          value: value,
          variantIndex: variantIndex,
          HSLElementString: HSLElementString,
          autoOpen: addHSLAutoOpen(i) || _this.state.replace,
          onDelete: function onDelete() {
            return _this._handleDeleteReply(HSLString, i, variantIndex);
          }
        });
      }));
    }));
    _defineProperty(_this, "renderVariantReply", sortableElement(function (_ref6) {
      var value = _ref6.value,
        variantIndex = _ref6.variantIndex,
        HSLElementString = _ref6.HSLElementString,
        i = _ref6.i,
        onDelete = _ref6.onDelete,
        autoOpen = _ref6.autoOpen;
      var HSLType = _this._getType(HSLElementString);
      var JSONValue = _this._parse(HSLElementString, HSLType);
      var DragHandle = _this.renderDragHandle;
      var isSortingClassName = _this.state.sortingIndex !== -1 ? styles$a.isSorting : "";
      var activeClassName = _this.state.sortingIndex === i ? styles$a.active : "";
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: styles$a.reply
      }, /*#__PURE__*/React.createElement(HSL, _extends$f({}, _this.props, {
        key: "".concat(HSLElementString),
        mode: "small no-raw",
        type: HSLType,
        value: JSONValue,
        onChange: function onChange(HSL) {
          return _this._handleChange(HSL, i, variantIndex);
        },
        isNew: autoOpen && _this.state.newElementAdded
      })), !_this.props.disabled ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$a.replyActions, " ").concat(isSortingClassName, " ").concat(activeClassName)
      }, JSONValue.supported_response !== false ? /*#__PURE__*/React.createElement(Icon, {
        src: "edit",
        className: styles$a.replyActionsIcon
      }) : null, !JSONValue.supported_response ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(Icon, {
        onClick: onDelete,
        src: "trash",
        className: styles$a.replyActionsIcon
      })) : null, JSONValue.supported_response !== undefined ? /*#__PURE__*/React.createElement(AddHSL, {
        className: styles$a.replyActionsIcon,
        onClick: function onClick(type) {
          return _this._handleReplace(type, i, variantIndex);
        },
        actionType: "replaceAction",
        channelsEnabled: _this.props.channelsEnabled,
        currentChannelName: _this.props.currentChannelName
      }, /*#__PURE__*/React.createElement(ReplaceIcon, null)) : null, _this.props.withReplies && value[variantIndex].split("<m>").length > 1 ? /*#__PURE__*/React.createElement(DragHandle, null) : null) : null), JSONValue.supported_response === false && /*#__PURE__*/React.createElement("div", {
        className: styles$a.unsupported
      }, /*#__PURE__*/React.createElement("span", {
        className: styles$a.unsupported_icon
      }, /*#__PURE__*/React.createElement(ErrorCross, null)), /*#__PURE__*/React.createElement("span", {
        className: styles$a.unsupported_text
      }, "This element cannot be auto generated for Whatsapp")));
    }));
    _defineProperty(_this, "renderDragHandle", sortableHandle(function () {
      return /*#__PURE__*/React.createElement(Icon, {
        src: "reorder",
        className: styles$a.replyActionsIcon
      });
    }));
    _defineProperty(_this, "renderSettingsPopup", function (_ref7) {
      var i = _ref7.i;
      if (_this.props.allPlatforms.length === 0) return null;
      var supportedPlatforms = _this._getSupportedPlatformList(i);
      return /*#__PURE__*/React.createElement(Tooltip, {
        className: styles$a.settingsPopup,
        active: _this.state.settingsActiveIndex === i,
        position: "BOTTOM",
        offset: {
          top: 4,
          left: -16
        },
        attachTo: {
          current: _this._variantWrapperDOMs[i]
        },
        onClose: function onClose() {
          return _this.setState({
            settingsActiveIndex: false
          });
        }
      }, /*#__PURE__*/React.createElement(VariantSettings, {
        allPlatforms: _this.props.allPlatforms,
        supportedPlatforms: supportedPlatforms,
        onChange: _this._handleSupportedPlatformsChange(i),
        errors: _this.props.errors
      }));
    });
    _defineProperty(_this, "_parse", function (value, type) {
      if (type === "RAW") return value;
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    });
    _defineProperty(_this, "_getType", function (value) {
      try {
        var _JSON$parse = JSON.parse(value),
          type = _JSON$parse.type;
        switch (type) {
          case "CAROUSEL":
          case "IMAGE":
          case "VIDEO":
          case "BUTTON":
          case "TEXT":
          case "FORM":
          case "WHATSAPP_INTERACTIVE_BUTTON":
          case "WHATSAPP_INTERACTIVE_LIST":
          case "WHATSAPP_INTERACTIVE_PRODUCT_LIST":
          case "WHATSAPP_INTERACTIVE_SINGLE_PRODUCT":
            return type;
          default:
            return "RAW";
        }
      } catch (e) {
        return "RAW";
      }
    });
    _defineProperty(_this, "_handleAdd", function (HSLType, HSLString, variantIndex) {
      var value = _this.props.value;
      var newValue;
      if (HSLType === "RAW") {
        newValue = [""];
      } else if (HSLType === "") {
        newValue = [];
      } else {
        newValue = [JSON.stringify({
          type: HSLType,
          isNew: true
        })];
      }
      if (HSLString === "ADD_VARIANT" && _this.props.withVariants) {
        value = value.concat(newValue);
      } else if (HSLString === "ADD_REPLY" && _this.props.withReplies && Array.isArray(value)) {
        value[variantIndex] = "".concat(value[variantIndex], "<m>").concat(newValue);
      } else if (HSLString === "ADD_REPLY" && _this.props.withReplies && typeof value === "string") {
        value = value.concat("<m>".concat(newValue));
      } else {
        value = newValue;
      }
      _this.setState({
        newElementAdded: true
      });
      _this._handleOnChange(value);
    });
    _defineProperty(_this, "_handleReplace", function (HSLType, HSLIndex, variantIndex) {
      var value = _this.props.value;
      var newValue;
      if (HSLType === "RAW") {
        newValue = [""];
      } else if (HSLType === "") {
        newValue = [];
      } else {
        newValue = [JSON.stringify({
          type: HSLType,
          isNew: true
        })];
      }
      if (Array.isArray(value)) {
        var valueArr = value[variantIndex].split("<m>");
        valueArr[HSLIndex] = newValue[0];
        value[variantIndex] = valueArr.join("<m>");
      } else {
        var _valueArr = value.split("<m>");
        _valueArr[HSLIndex] = newValue[0];
        value = _valueArr.join("<m>");
      }
      _this.setState({
        newElementAdded: true,
        replace: true
      });
      _this._handleOnChange(value);
    });
    _defineProperty(_this, "_handleDelete", function (indexToDelete) {
      _this.props.activateConfirmationDialog({
        title: "Delete Message!",
        message: "Are you sure you want to delete this message?",
        positiveText: "Delete",
        negativeText: "Cancel",
        themed: true
      }, function (isConfirmed) {
        if (isConfirmed) {
          var value = _this.props.value;
          value = value.filter(function (_, i) {
            return i !== indexToDelete;
          });
          _this._handleOnChange(value);
          setTimeout(function () {
            // we also need to adjust the device map appropriately
            var map = _this.props.supportedPlatforms;
            Object.keys(map).map(function (key) {
              map[key] = map[key].filter(function (i) {
                return i !== indexToDelete;
              });
              map[key] = map[key].map(function (i) {
                return i > indexToDelete ? i - 1 : i;
              });
            });
            _this.props.onSupportedPlatformsChange(map);
          }, 0);
        }
      });
    });
    _defineProperty(_this, "_handleDeleteReply", function (HSLString, i, variantIndex) {
      _this.props.activateConfirmationDialog({
        title: "Delete Message!",
        message: "Are you sure you want to delete this message?",
        positiveText: "Delete",
        negativeText: "Cancel",
        themed: true
      }, function (isConfirmed) {
        if (isConfirmed) {
          var items = HSLString.split("<m>");
          var newItems = items.filter(function (_, index) {
            return index !== i;
          });
          var newItemsJoin = newItems.join("<m>");

          // this check makes sure when deleting two blank raw HSL, only the one intended, gets deleted
          if (newItemsJoin === "" && newItems.length === 1) {
            _this._handleChange(newItemsJoin, undefined, variantIndex);
          } else {
            _this._handleChange(newItemsJoin, null, variantIndex);
          }
        }
      });
    });
    _defineProperty(_this, "_handleChange", function (HSL, indexToUpdate, variantIndex) {
      var value = _this.props.value;
      var HSLString = "";
      var formHSL = function formHSL(value) {
        if (indexToUpdate === null || indexToUpdate === undefined) return _this._getHSLString(HSL);
        var HSLs = value.split("<m>");
        HSLs[indexToUpdate] = _this._getHSLString(HSL);
        return HSLs.join("<m>");
      };
      if (typeof value === "string") {
        HSLString = formHSL(value) ? [formHSL(value)] : [];
      } else {
        HSLString = value.map(function (currentVal, index) {
          if (index === variantIndex) {
            return formHSL(currentVal);
          }
          return currentVal;
        }).filter(function (val) {
          return !!val;
        });
      }

      // HSL String incorrectly returns [] if Raw hsl left blank, this check ensures that instead [""] is returned
      // to show blank raw hsl
      if (Array.isArray(HSLString) && HSLString.length === 0 && HSL === "" && indexToUpdate !== null) {
        HSLString = [""];
      }
      _this.state.replace ? _this.setState({
        newElementAdded: false,
        replace: false
      }) : _this.setState({
        newElementAdded: false
      });
      _this._handleOnChange(HSLString);
    });
    _defineProperty(_this, "_getHSLString", function (HSL) {
      if (typeof HSL === "string" && HSL.length === 0) return "";
      if (typeof HSL === "string") return HSL;
      return JSON.stringify(HSL);
    });
    _defineProperty(_this, "_onFocus", function (e) {
      _this.setState({
        active: true
      });
      if (_this.props.onFocus) {
        _this.props.onFocus(e);
      }
    });
    _defineProperty(_this, "_onBlur", function (e) {
      _this.setState({
        active: false
      });
      if (_this.props.onBlur) {
        _this.props.onBlur(e);
      }
    });
    _defineProperty(_this, "_handleOnChange", function (value) {
      if (_this.props.withVariants) _this.props.onChange(value);else if (typeof value === "string") {
        _this.props.onChange(value);
      } else _this.props.onChange(value[0]);
    });
    _defineProperty(_this, "_togglePopup", function (i) {
      return function () {
        _this.setState(function (state) {
          return {
            settingsActiveIndex: state.settingsActiveIndex === i ? -1 : i
          };
        });
      };
    });
    _defineProperty(_this, "_handleSupportedPlatformsChange", function (variantIndex) {
      return function (value) {
        var supportedPlatforms = _objectSpread2({}, _this.props.supportedPlatforms);

        // Delete all occurances first
        Object.keys(supportedPlatforms).map(function (platformId) {
          supportedPlatforms[platformId] = supportedPlatforms[platformId].filter(function (vIndex) {
            return vIndex !== variantIndex;
          });
        });
        value.forEach(function (platform) {
          var platformId = platform.value;
          supportedPlatforms[platformId] = supportedPlatforms[platformId] ? supportedPlatforms[platformId] : [];
          supportedPlatforms[platformId] = [].concat(_toConsumableArray(supportedPlatforms[platformId]), [variantIndex]);
        });
        _this.props.onSupportedPlatformsChange(supportedPlatforms);
      };
    });
    _defineProperty(_this, "_getPlatformTitleFromId", function (id) {
      var found;
      _this.props.allPlatforms.map(function (platform) {
        // eslint-disable-next-line eqeqeq
        if (id == platform.value) found = platform.title;
      });
      return found;
    });
    _defineProperty(_this, "_getSupportedPlatformList", function (i) {
      var supportedPlatforms = [];
      Object.keys(_this.props.supportedPlatforms).map(function (platformId) {
        if (_this.props.supportedPlatforms[platformId].indexOf(i) > -1) {
          supportedPlatforms.push({
            title: _this._getPlatformTitleFromId(platformId),
            value: platformId
          });
        }
      });
      return supportedPlatforms;
    });
    _defineProperty(_this, "_getPlatformLabel", function (i) {
      if (!_this.props.supportedPlatforms || !_this.props.allPlatforms) return "";
      var supportedPlatforms = _this._getSupportedPlatformList(i);
      var nPlatforms = supportedPlatforms.length;
      var platformTitle = nPlatforms ? supportedPlatforms[0].title : "";
      if (nPlatforms === 0) return "All Platforms";
      if (nPlatforms === 1 && platformTitle === "All") return "All Platforms";
      if (nPlatforms === 1 && platformTitle !== "All") return platformTitle;
      if (nPlatforms > 1) return "".concat(nPlatforms, " Platforms");
    });
    _this._variantWrapperDOMs = [];
    _this.state = {
      active: false,
      settingsActiveIndex: -1,
      sortingIndex: -1
    };
    return _this;
  }
  _inherits(HSLInput, _React$Component);
  return _createClass(HSLInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        label = _this$props.label,
        withMargin = _this$props.withMargin,
        labelClassName = _this$props.labelClassName,
        hint = _this$props.hint,
        disabled = _this$props.disabled;

      // when variants are enabled, the value is an array by default
      // if not enabled, then if the value exists,we convert it into an array with a single
      // value, otherwise it's an empty array
      var value = this.props.value;
      if (!this.props.withVariants) {
        if (typeof value === "string" && value.length === 0) {
          value = [value];
        } else {
          value = value ? [value] : [];
        }
      }
      var activeClassName = this.state.active ? styles$a.textActive : "";
      var marginClassName = withMargin ? styles$a.textWithMargin : "";
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$a.text, " ").concat(className, " ").concat(activeClassName, " ").concat(marginClassName)
      }, this.renderLabel({
        value: value,
        label: label,
        labelClassName: labelClassName
      }), this.renderHint({
        hint: hint
      }), this.renderVariants({
        value: value,
        disabled: disabled
      }), this.renderAddHSL({
        value: value
      }));
    }
  }, {
    key: "renderLabel",
    value: function renderLabel(_ref8) {
      var _this2 = this;
      var value = _ref8.value,
        label = _ref8.label,
        labelClassName = _ref8.labelClassName;
      if (!label) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$a.textLabelWrapper)
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles$a.textLabel, " ").concat(labelClassName)
      }, label), !this.props.value || value.length === 1 ? /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles$a.textLabel, " ").concat(labelClassName),
        onClick: function onClick() {
          _this2._handleOnChange([]);
        }
      }, "CLEAR") : null);
    }
  }, {
    key: "renderHint",
    value: function renderHint() {
      var hint = this.props.hint;
      if (!hint) return null;
      return /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles$a.textHint)
      }, hint);
    }
  }, {
    key: "renderVariants",
    value: function renderVariants(_ref9) {
      var value = _ref9.value;
      var disabled = this.props.disabled;
      if (value.length === 0) return null;
      return /*#__PURE__*/React.createElement(React.Fragment, null, value.map(this.renderVariant({
        value: value,
        disabled: disabled
      })), this.renderAddVariant({}));
    }
  }, {
    key: "renderVariantLabel",
    value: function renderVariantLabel(_ref10) {
      var _this3 = this;
      var i = _ref10.i;
      if (!this.props.withVariants) return null;
      var platformLabel = this._getPlatformLabel(i);
      return /*#__PURE__*/React.createElement("div", {
        className: styles$a.inputVariant
      }, this.props.withVariants ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
        className: styles$a.inputVariantIcon,
        src: "synonym_duplicate"
      }), /*#__PURE__*/React.createElement("div", {
        className: styles$a.inputVariantText
      }, "Variant ", i + 1)) : null, /*#__PURE__*/React.createElement("div", {
        className: styles$a.inputVariantEndLine
      }), this.props.allPlatforms.length !== 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        onClick: this._togglePopup(i),
        className: styles$a.inputVariantEndText
      }, platformLabel), /*#__PURE__*/React.createElement(Icon, {
        src: "gear",
        innerRef: function innerRef(DOMElement) {
          _this3._variantWrapperDOMs[i] = DOMElement;
        },
        onClick: this._togglePopup(i)
      })) : null, !this.props.isTranslated && /*#__PURE__*/React.createElement(Icon, {
        onClick: function onClick() {
          return _this3._handleDelete(i);
        },
        src: "trash"
      }));
    }
  }, {
    key: "renderAddHSL",
    value: function renderAddHSL(_ref11) {
      var _this4 = this;
      var value = _ref11.value;
      if (value.length > 0) return null;
      return /*#__PURE__*/React.createElement(AddHSL, {
        small: true,
        className: styles$a.addHSLButton,
        onClick: function onClick(type) {
          return _this4._handleAdd(type, "ADD_VARIANT");
        },
        channelsEnabled: this.props.channelsEnabled,
        currentChannelName: this.props.currentChannelName
      }, "Add Chat Element");
    }
  }, {
    key: "renderAddReply",
    value: function renderAddReply(_ref12) {
      var _this5 = this;
      var i = _ref12.i;
      if (!this.props.withReplies) return null;
      return /*#__PURE__*/React.createElement(AddHSL, {
        small: true,
        className: styles$a.addHSLButton,
        onClick: function onClick(type) {
          return _this5._handleAdd(type, "ADD_REPLY", i);
        },
        channelsEnabled: this.props.channelsEnabled,
        currentChannelName: this.props.currentChannelName
      }, "Add Reply");
    }
  }, {
    key: "renderAddVariant",
    value: function renderAddVariant() {
      var _this6 = this;
      if (!this.props.withVariants) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: styles$a.addVariant
      }, /*#__PURE__*/React.createElement(Icon, {
        className: styles$a.addVariantIcon,
        src: "synonym_duplicate"
      }), /*#__PURE__*/React.createElement("div", {
        className: styles$a.addVariantText
      }, "Add more variants"), /*#__PURE__*/React.createElement("div", {
        className: styles$a.addVariantEndLine
      }), /*#__PURE__*/React.createElement(AddHSL, {
        small: true,
        className: styles$a.addVariantButton,
        onClick: function onClick(type) {
          return _this6._handleAdd(type, "ADD_VARIANT");
        },
        channelsEnabled: this.props.channelsEnabled,
        currentChannelName: this.props.currentChannelName
      }, "Add Reply"));
    }
  }]);
}(React.Component)) || _class$4);
HSLInput.propTypes = {
  activateConfirmationDialog: PropTypes.func,
  allPlatforms: PropTypes.array,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  entitySearchURL: PropTypes.string,
  errors: PropTypes.array,
  hint: PropTypes.string,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onSupportedPlatformsChange: PropTypes.func,
  supportedPlatforms: PropTypes.array,
  value: PropTypes.string,
  withMargin: PropTypes.bool,
  withReplies: PropTypes.bool,
  withVariants: PropTypes.bool,
  isTranslated: PropTypes.bool,
  displayGlobalConstantSelect: PropTypes.bool,
  globalConstantsURL: PropTypes.string,
  isRephraseEnabled: PropTypes.bool,
  baseUrl: PropTypes.string
};
HSLInput.defaultProps = {
  allPlatforms: [],
  displayGlobalConstantSelect: false
};
HSLInput.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "renderLabel",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ value, label, labelClassName }",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderHint",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "renderVariants",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ value }",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderVariant",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ value }",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderVariantLabel",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ i }",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderAddHSL",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ value }",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderAddReply",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ i }",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderAddVariant",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "renderSettingsPopup",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ i }",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_parse",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }, {
      "name": "type",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_getType",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleAdd",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "HSLType",
      "type": null
    }, {
      "name": "HSLString",
      "type": null
    }, {
      "name": "variantIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleReplace",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "HSLType",
      "type": null
    }, {
      "name": "HSLIndex",
      "type": null
    }, {
      "name": "variantIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleDelete",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "indexToDelete",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleDeleteReply",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "HSLString",
      "type": null
    }, {
      "name": "i",
      "type": null
    }, {
      "name": "variantIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "HSL",
      "type": null
    }, {
      "name": "indexToUpdate",
      "type": null
    }, {
      "name": "variantIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_getHSLString",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "HSL",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_onFocus",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_onBlur",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleOnChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_togglePopup",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleSupportedPlatformsChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "variantIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_getPlatformTitleFromId",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "id",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_getSupportedPlatformList",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_getPlatformLabel",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "HSLInput",
  "props": {
    "allPlatforms": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "displayGlobalConstantSelect": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "activateConfirmationDialog": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "entitySearchURL": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "errors": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "hint": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "labelClassName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onBlur": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onFocus": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onSupportedPlatformsChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "supportedPlatforms": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "withMargin": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "withReplies": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "withVariants": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "isTranslated": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "globalConstantsURL": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "isRephraseEnabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "baseUrl": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var render = function render(type, value, element, props) {
  ReactDOM.render( /*#__PURE__*/React.createElement(HSLInput, _objectSpread2({
    type: type,
    value: value
  }, props)), document.getElementById(element));
};
var renderComponent = function renderComponent(component, element, props) {
  ReactDOM.render( /*#__PURE__*/React.createElement(component, _objectSpread2({}, props)), document.getElementById(element));
};
var renderAddHSL = function renderAddHSL(element, onClick) {
  ReactDOM.render( /*#__PURE__*/React.createElement(AddHSL, {
    onClick: onClick
  }), document.getElementById(element));
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  render: render,
  renderComponent: renderComponent,
  renderAddHSL: renderAddHSL,
  'default': HSLInput,
  HSLDisplay: HSLDisplay,
  AddHSL: AddHSL
});

export { AddHSL as A, HSLInput as H, renderComponent as a, renderAddHSL as b, index as i, render as r };
